/* ============================================================================
   STUDIO — EDISAMP
   ----------------------------------------------------------------------------
   El canvas Fabric es SIEMPRE 1024x1024 internamente y se escala por CSS.
   Fabric compensa la escala CSS al calcular el puntero, asi que raton y dedo
   funcionan igual sin recalcular nada. Lo unico que compensamos es el tamano
   visual de los tiradores (majEchelleControles).

   El JSON del diseno es el contrato con la fase Shopify: coordenadas
   normalizadas 0-1 relativas a la zona, cm reales, pxPerCm y dpi.
   ========================================================================== */

/* ============================================================================
   DENTRO DE LA TIENDA, CON SU CABECERA
   ----------------------------------------------------------------------------
   Franklin, varias veces: « el personalizador tendría que estar incrustado en
   mi tema para que el cliente no tenga la sensación de que es otra app ». La
   página iba con `layout none`: ni la cabecera, ni el menú, ni la bolsa de la
   tienda. Se entraba en otra cosa.

   Ahora la plantilla usa el layout del tema, y aquí se hace sitio: se mide
   dónde acaba la cabecera de la tienda —la que sea, fija o no— y el Studio
   ocupa el resto de la pantalla, debajo. Se mide en vez de escribir 110 px
   porque en el teléfono la cabecera es otra, y porque el día que se cambie el
   tema esto tiene que seguir funcionando solo.

   En local no hay cabecera de tienda, y entonces no cambia nada.
   ========================================================================== */
(function incrustadoEnLaTienda() {
  const deLaTienda = () => [...document.querySelectorAll(
      'header, [class*="announcement"], [class*="annonce"]')]
    .filter(h => !h.closest('.studio') && !h.closest('.modale'));
  if (!deLaTienda().length) return;
  const raiz = document.documentElement;
  raiz.setAttribute('data-incrustado', '');
  const medir = () => {
    let fondo = 0;
    deLaTienda().forEach(h => {
      const r = h.getBoundingClientRect();
      /* Lo que está arriba del todo y no ocupa media pantalla: una capa a
         pantalla completa —el carrito lateral, el buscador— no es cabecera. */
      if (r.height > 0 && r.top <= 1 && r.height < innerHeight * 0.4 && r.bottom > fondo)
        fondo = r.bottom;
    });
    raiz.style.setProperty('--alto-tienda', Math.round(fondo) + 'px');
  };
  medir();
  addEventListener('resize', medir);
  addEventListener('load', medir);
  setTimeout(medir, 600); setTimeout(medir, 2000);
})();

(function () {
'use strict';

const $  = s => document.querySelector(s);
const $$ = s => [...document.querySelectorAll(s)];

/* ------------------------------------------------------------- estado ---- */
const etat = {
  config: null,        // config-personnalisation.json
  catalogue: [],       // productos Shopify + merge
  produit: null,       // producto activo
  vue: null,           // id de vista activa
  zones: {},           // { idVue: idZona }
  designs: {},         // { idVue: fabricJSON }
  fond: {},            // { idVue: color|null }
  zoom: 1,
  apercu: false,
  realiste: true,     // capa de textura del tejido, ON por defecto
  historique: [], hIndex: -1, hPause: false,
};

const PROPS = ['zoneId','source','fondSupprime','sourceOriginale','estFond','policeId',
  /* modelo (FEATURE 0): sin estos campos en PROPS, los bloqueos y los
     emplacements se perderian en cada cambio de vista y en el historial. */
  'estModele','verrous','emplacement','emplacementRempli','cadrage',
  /* El QR guarda su URL y su estilo, NO solo la imagen: el archivo de
     impresion lo regenera a 300 DPI desde aqui. */
  'qr',
  /* Los simbolos guardan su id: el export los redibuja como VECTOR desde el
     catalogo en vez de estirar los pixeles del canvas. */
  'symbole',
  /* Colores quitados a mano (Cricut). `baseCouleursId` apunta a ORIGINALES,
     no lleva la dataURL: en el objeto reventaria el sessionStorage. */
  'couleursRetirees','toleranceCouleur','baseCouleursId'];
const MAX_HISTORIQUE = 40;

/* UN solo sitio decide si estamos en un telefono. Vive en el PRIMER bloque
   porque aqui ya se usa (plegado de avisos) y el segundo lo recoge por el
   puente: al reves era un ReferenceError silencioso que dejaba los avisos sin
   plegar y tapando el producto. */
const esMobile = () => Math.min(innerWidth, innerHeight) < 820
                    || /iPhone|iPad|Android/i.test(navigator.userAgent);

/* El canvas trabaja con una miniatura de MAX_COTE px: a tamano completo el
   navegador se arrastra, sobre todo en movil. Pero el archivo de impresion a
   300 DPI necesita los pixeles ORIGINALES, y antes se tiraban al subir.

   Los originales viven en este Map, NO como propiedad del objeto de Fabric: si
   estuvieran en el objeto entrarian en canvas.toJSON() y reventarian el
   sessionStorage (una foto de movil son varios MB en base64). El objeto solo
   lleva un id corto; construireJSON() los vuelve a juntar al exportar.

   Al recargar la pagina el Map se vacia: el diseno sobrevive con la miniatura
   y el export lo dice en vez de fingir 300 DPI. En la fase Shopify el original
   ira a Cloudinary y el JSON llevara su URL en lugar del dataUrl. */
const ORIGINALES = new Map();
let _idOriginal = 0;

/* ------------------------------------------------------------- canvas ---- */
const canvas = new fabric.Canvas('canvas', {
  preserveObjectStacking: true,
  uniformScaling: true,
  selection: false,
});

Object.assign(fabric.Object.prototype, {
  transparentCorners:false, cornerStyle:'circle',
  cornerColor:'#D2B68A', cornerStrokeColor:'#FFFFFF',
  borderColor:'#D2B68A', borderOpacityWhenMoving:1,
});

/* ═══════════ TIRAR DEL MEDIO RECORTA, TIRAR DE LA ESQUINA ESCALA ═══════════
   Franklin: « se me deforma automáticamente cuando cojo desde el centro y es
   lo que no quiero; que de una punta a otra se haga más grande, y que desde
   el medio me corte la imagen, sin deformar nada ».

   Es exactamente lo que hace cualquier editor serio, y lo que Fabric NO hace
   de fábrica: sus tiradores del medio estiran un solo eje, o sea deforman.
   Aquí se sustituyen por un RECORTE de verdad, con `cropX/cropY` — la foto no
   se estira, se enseña menos trozo — y el borde de enfrente se queda quieto,
   que es lo que espera la mano.

   Las esquinas no se tocan: el lienzo ya va en `uniformScaling`, así que
   escalan sin deformar. */
function _localEnObjeto(o, x, y) {
  /* El puntero, en las coordenadas SIN ESCALAR del objeto y con el centro en
     (0,0): así « lo que mide » se lee en píxeles de la propia foto. */
  const m = fabric.util.invertTransform(o.calcTransformMatrix());
  return fabric.util.transformPoint(new fabric.Point(x, y), m);
}

function _fijarBorde(o, lado, antes) {
  /* Cambiar width/height mueve el centro: se recoloca el objeto para que el
     borde de enfrente se quede donde estaba. */
  o.setCoords();
  const ahora = o.getCoords ? o.getCoords() : null;
  if (!antes || !ahora) return;
  const iA = lado === 'ml' || lado === 'mt' ? 2 : 0;   // esquina opuesta
  o.left += antes[iA].x - ahora[iA].x;
  o.top  += antes[iA].y - ahora[iA].y;
  o.setCoords();
}

function _recorte(lado) {
  return function (eventData, transform, x, y) {
    const o = transform.target;
    if (!o || o.type !== 'image' || !o._element) return false;
    const fuenteW = o._element.naturalWidth || o._element.width;
    const fuenteH = o._element.naturalHeight || o._element.height;
    const p = _localEnObjeto(o, x, y);
    const antes = o.getCoords();
    const MIN = 12;                                   // nunca menos de 12 px de foto

    if (lado === 'mr') {
      const w = Math.round(p.x + o.width / 2);
      o.set('width', Math.max(MIN, Math.min(w, fuenteW - (o.cropX || 0))));
    } else if (lado === 'ml') {
      const quita = Math.round(p.x + o.width / 2);    // cuánto se come por la izquierda
      const cropX = Math.max(0, Math.min((o.cropX || 0) + quita, (o.cropX || 0) + o.width - MIN));
      const w = o.width - (cropX - (o.cropX || 0));
      o.set({ cropX, width: Math.max(MIN, w) });
    } else if (lado === 'mb') {
      const h = Math.round(p.y + o.height / 2);
      o.set('height', Math.max(MIN, Math.min(h, fuenteH - (o.cropY || 0))));
    } else if (lado === 'mt') {
      const quita = Math.round(p.y + o.height / 2);
      const cropY = Math.max(0, Math.min((o.cropY || 0) + quita, (o.cropY || 0) + o.height - MIN));
      const h = o.height - (cropY - (o.cropY || 0));
      o.set({ cropY, height: Math.max(MIN, h) });
    }
    _fijarBorde(o, lado, antes);
    /* Sin esto la foto se sigue dibujando entera y sólo se encoge el marco:
       Fabric guarda el objeto en caché y hay que decirle que ha cambiado. */
    o.dirty = true;
    if (o.canvas) o.canvas.requestRenderAll();
    return true;
  };
}

/* Se aplica SOLO a las fotos: en un texto los tiradores del medio cambian el
   ancho del párrafo, que sí tiene sentido, y en una forma se esconden. */
function brancherRecorte(img) {
  if (!img || img.type !== 'image') return;
  if (img.estModele || img.qr) return;          // marcos y QR tienen sus reglas
  /* Los controles son del PROTOTIPO mientras no se copien: escribir en ellos
     cambiaría los de TODOS los objetos, textos incluidos. Se hace una copia
     propia de esta foto y ahí se sustituyen los cuatro del medio. */
  if (!Object.prototype.hasOwnProperty.call(img, 'controls')) {
    img.controls = Object.assign({}, fabric.Object.prototype.controls);
  }
  ['ml', 'mr', 'mt', 'mb'].forEach(lado => {
    const base = fabric.Object.prototype.controls[lado];
    img.controls[lado] = new fabric.Control({
      x: base.x, y: base.y, offsetX: base.offsetX, offsetY: base.offsetY,
      cursorStyle: (lado === 'ml' || lado === 'mr') ? 'ew-resize' : 'ns-resize',
      actionName: 'recadrer',
      actionHandler: _recorte(lado),
      render: base.render,
    });
  });
  img.on && img.on('modified', () => { /* el recorte ya está en el objeto */ });
}

/* Cualquier foto que entre en el lienzo —subida, restaurada de la sesión o
   traída de « mis fotos »— estrena los tiradores de recorte. Engancharlo aquí
   y no en cada sitio donde se crea una imagen es lo que evita que mañana una
   vía nueva se quede sin ellos. */
canvas.on('object:added', e => {
  const o = e && e.target;
  if (o && o.type === 'image') brancherRecorte(o);
});

const plateau = $('#plateau');
const mockup  = $('#mockup');
const texture = $('#texture');
const svgGuides = $('#guides');

/* -------------------------------------------------------------- utiles -- */
/* LA CARRERA DEL ARRANQUE. La foto del producto (`mockup`) llama a
   `majFormatPlateau` en su evento `load`, y ese `load` puede llegar ANTES de
   que `chargerProduit` haya puesto `etat.produit`: la imagen del HTML carga
   sola mientras el catálogo todavía viaja. Aquí se leía `etat.produit.perso`
   sin mirar, y cada arranque dejaba un « Cannot read properties of null
   (reading 'perso') » en la consola del cliente (visto el 11/09/2026).
   Mientras no hay producto se devuelve una vista VACÍA: todos los que llaman
   —el formato del plateau, la textura, las zonas— reciben algo que no tiene
   nada que pintar, sin tener que protegerlos uno a uno. Con producto
   configurado no cambia nada. */
const VUE_VIDE = Object.freeze({ id: null, zones: Object.freeze([]) });
const vueActive  = () => {
  const vs = etat.produit && etat.produit.perso && etat.produit.perso.vues;
  if (!vs) return VUE_VIDE;
  return vs.find(v => v.id === etat.vue);
};
const zoneActive = () => (vueActive().zones || []).find(z => z.id === etat.zones[etat.vue]);
const zonePar = (vId, zId) => {
  const v = (etat.produit.perso.vues || []).find(x => x.id === vId);
  return v ? (v.zones || []).find(z => z.id === zId) : null;
};
const estTexte = o => !!o && (o.type === 'textbox' || o.type === 'i-text');
const defauts  = () => etat.config.defauts || {};

/* La geometria vive en formes.js: rect, cercle, coeur y hexagone. */
function clipPour(z) { return clipDeForme(z); }

function majEchelleControles() {
  /* Contra el ancho del CUADRADO dibujado, no del plateau: con un producto
     alto los dos dejan de coincidir y los tiradores saldrian de otro tamano. */
  const cote = (canvas.lowerCanvasEl && canvas.lowerCanvasEl.clientWidth)
             || plateau.clientWidth;
  const f = 1024 / Math.max(cote, 1);
  Object.assign(fabric.Object.prototype, {
    cornerSize: Math.round(11*f), touchCornerSize: Math.round(30*f),
    borderScaleFactor: Math.max(1.4, f*1.3), padding: Math.round(4*f),
  });
  fabric.Object.prototype.controls.mtr.offsetY = Math.round(-34*f);
  canvas.requestRenderAll();
}

/* ================================ E3 · GUIDES ============================ */
/* Dos limites, como Vistaprint: la marge (borde imprimible) y la zone de
   securite un 4% hacia dentro. Lo que caiga entre ambas se imprime pero
   arriesga corte, asi que se avisa en amarillo. */
/* Etiquetas de las guias.
   En una zona grande caben dentro, como hasta ahora. En una pequena (los
   porte-cles son de 128 px) la etiqueta « Zone de securite » mide 132 px: mas
   ancha que la propia forma, y las dos se pisan. Ahi salen FUERA, apiladas
   sobre la zona y mas pequenas. Nada de mostrarlas solo al pasar por encima:
   en movil no hay hover. */
function etiquettes(z, s) {
  const ETIQ = [
    { texto:'Marges',           color:'#3B6FD4', borde:'rgba(59,111,212,.5)' },
    { texto:'Zone de sécurité', color:'#2E9E6B', borde:'rgba(46,158,107,.5)' },
  ];
  const caben = z.w >= 150 && z.h >= 90;

  const caja = (x, y, w, h, e, mini) => `
    <g>
      <rect x="${x}" y="${y}" width="${w}" height="${h}" rx="${mini ? 6 : 7}"
            fill="rgba(255,255,255,.82)" stroke="${e.borde}"/>
      <text x="${x + (mini ? 6 : 8)}" y="${y + h - (mini ? 5 : 6)}"
            fill="${e.color}"${mini ? ' class="mini"' : ''}>${e.texto}</text>
    </g>`;

  if (caben) {
    const dx = z.w * (1 - s) / 2, dy = z.h * (1 - s) / 2;
    return caja(z.x, z.y - 26, 76, 21, ETIQ[0], false)
         + caja(z.x + dx, z.y + dy + 6, 132, 21, ETIQ[1], false);
  }

  /* Fuera: ancho estimado a 10 px de tipo, centradas sobre la zona y apiladas
     con la mas cercana al borde abajo. */
  const h = 17, hueco = 3;
  const anchos = ETIQ.map(e => Math.round(e.texto.length * 5.6) + 14);
  const arriba = z.y - (h * 2 + hueco) - 6;
  const hayHueco = arriba >= 4;
  const y0 = hayHueco ? arriba : z.y + z.h + 34;   // si no cabe arriba, bajo las cotas

  return ETIQ.map((e, i) => caja(
    Math.round(z.x + z.w / 2 - anchos[i] / 2),
    y0 + i * (h + hueco), anchos[i], h, e, true)).join('');
}


/* ==========================================================================
   UNIDADES DEL CLIENTE — cm · inch · px
   --------------------------------------------------------------------------
   Franklin: « para el cliente, que elija px, cm o inch ». Los tres tienen
   sentido AQUI y ninguno en el admin: un cliente que piensa en pulgadas no
   entiende « 30 cm », y uno que va a mandar el fichero a otro sitio quiere
   los pixeles. El admin, en cambio, trabaja con una cinta metrica y solo
   necesita centimetros.

   Los px que se ensenan son los del FICHERO DE IMPRESION a su DPI, no los de
   la pantalla: los de pantalla dependen del zoom y no significan nada.
   La eleccion se recuerda — nadie quiere volver a elegir en cada visita. */
const CLE_UNITE = 'edisamp.unite';
let _unite = (() => { try { return localStorage.getItem(CLE_UNITE) || 'cm'; }
                      catch (e) { return 'cm'; } })();

/**
 * Una medida, escrita. Y si no hay medida, se dice — no se escribe cero.
 * -----------------------------------------------------------------------------
 * `+undefined || 0` daba 0, así que una zona sin calibración vertical se
 * anunciaba al CLIENTE como « 33 cm × 0 cm ». Cero es una medida; desconocido
 * no lo es. El admin ya distingue las dos cosas desde que hay dos escalas: aquí
 * faltaba no traicionarlo en la última línea.
 */
function fmtDim(cm) {
  if (cm == null || cm === '' || !isFinite(+cm) || +cm <= 0) return '—';
  const v = +cm || 0;
  if (_unite === 'in') return (Math.round(v / 2.54 * 100) / 100) + '″';
  if (_unite === 'px') {
    /* `defauts` es del PRIMER bloque, donde `S` todavia no existe: poner `S.`
       aqui es un ReferenceError que muere dentro del formateo y deja la lista
       de zonas vacia sin romper nada visible. La quinta vez que esta trampa
       muerde (ver CLAUDE.md). Regla: `S.` SOLO en el segundo bloque. */
    const dpi = (defauts().dpi || 300);
    return Math.round(v / 2.54 * dpi) + ' px';
  }
  return (Math.round(v * 10) / 10) + ' cm';
}

function dessinerGuides() {
  if (!etat.produit || etat.apercu) { svgGuides.innerHTML = ''; return; }
  const z = zoneActive();
  const m = (defauts().zoneSecurite || 0.04);
  const s = facteurSecurite(z, m);
  const cotes = fmtDim(z.cmW), cotesH = fmtDim(z.cmH);

  /* El rectangulo conserva el margen por lado de siempre; las demas formas
     escalan su propio path hacia el centro (ver formes.js). */
  let marges, securite;
  if (esRect(z)) {
    const dx = z.w * m, dy = z.h * m, r = z.radiusPx || 0;
    marges = `<rect x="${z.x}" y="${z.y}" width="${z.w}" height="${z.h}" rx="${r}"
                    fill="none" stroke="#3B6FD4" stroke-width="2"/>`;
    securite = `<rect x="${z.x+dx}" y="${z.y+dy}" width="${z.w-2*dx}" height="${z.h-2*dy}"
                      rx="${Math.max(0, r-Math.min(dx,dy))}"
                      fill="none" stroke="#2E9E6B" stroke-width="2" stroke-dasharray="10 8"/>`;
  } else {
    marges   = `<path d="${pathZone(z, 1)}" fill="none" stroke="#3B6FD4" stroke-width="2"/>`;
    securite = `<path d="${pathZone(z, s)}" fill="none" stroke="#2E9E6B" stroke-width="2"
                      stroke-dasharray="10 8"/>`;
  }

  /* La anilla no se imprime: se marca para que el cliente no ponga ahi nada. */
  const t = trouDe(z);
  const agujero = !t ? '' : `
    <circle cx="${t.cx}" cy="${t.cy}" r="${t.rExclusion}"
            fill="rgba(210,182,138,.18)" stroke="#B08A55" stroke-width="1.5"
            stroke-dasharray="5 4"/>
    <circle cx="${t.cx}" cy="${t.cy}" r="${t.r}" fill="rgba(34,45,82,.55)"/>`;

  /* Todo el grupo gira con la zona: guias, etiquetas y cotas anotan la zona
     tal como esta colocada sobre el mockup. */
  const ang = zonaRotacion(z), ctr = zonaCentro(z);
  const abrirG = ang ? `<g transform="rotate(${ang} ${ctr.cx} ${ctr.cy})">` : '';
  const cerrarG = ang ? '</g>' : '';

  svgGuides.innerHTML = `
    ${abrirG}
    ${marges}
    ${securite}
    ${agujero}

    ${etiquettes(z, s)}

    <text x="${z.x+z.w/2}" y="${z.y+z.h+24}" fill="#5A6485"
          text-anchor="middle">${cotes}</text>
    <text x="${z.x+z.w+16}" y="${z.y+z.h/2}" fill="#5A6485"
          text-anchor="middle"
          transform="rotate(90 ${z.x+z.w+16} ${z.y+z.h/2})">${cotesH}</text>
    ${cerrarG}
    ${emplacementsSVG()}
  `;
}

/* Marcadores de los emplacements vacios: marco punteado, icono y llamada a la
   accion. Se dibujan en la capa SVG y no como objetos del canvas para no
   tener que montar grupos de Fabric (rect + icono + texto) que complicarian
   el bloqueo, la serializacion y el historial. */
function emplacementsSVG() {
  if (etat.apercu) return '';
  return canvas.getObjects()
    .filter(o => o.emplacement && !o.emplacementRempli && o.zoneId === (zoneActive()||{}).id)
    .map(o => {
      const m = o.emplacement;
      const cx = m.x + m.w/2, cy = m.y + m.h/2;
      const gira = o.angle ? ` transform="rotate(${o.angle} ${cx} ${cy})"` : '';
      const icono = Math.min(38, m.h * 0.34);
      /* Un hueco redondo tiene que ANUNCIARSE redondo: si se marca con un
         rectangulo, el cliente encuadra su foto pensando que se imprime
         entera y luego se le recortan las orejas al perro. */
      const marco = (m.forme === 'cercle')
        ? `<circle cx="${cx}" cy="${cy}" r="${Math.min(m.w, m.h)/2}"
                   fill="rgba(255,255,255,.10)" stroke="#D2B68A" stroke-width="2.5"
                   stroke-dasharray="11 8"/>`
        : `<rect x="${m.x}" y="${m.y}" width="${m.w}" height="${m.h}" rx="8"
                 fill="rgba(255,255,255,.10)" stroke="#D2B68A" stroke-width="2.5"
                 stroke-dasharray="11 8"/>`;
      return `<g${gira}>
        ${marco}
        <text x="${cx}" y="${cy - icono*0.12}" text-anchor="middle"
              font-size="${icono}">📷</text>
        <text x="${cx}" y="${cy + icono*0.95}" text-anchor="middle"
              fill="#D2B68A" font-size="${Math.min(15, m.h*0.13)}">${
                m.media === 'texte' ? 'Ajouter votre texte' : 'Ajouter votre photo'}</text>
      </g>`;
    }).join('');
}

/* ================================ ALERTES ================================ */
/* Avisos que el cliente ha cerrado a mano. Vive sólo en esta pestaña: al
   recargar vuelven a salir, porque puede que el problema siga ahí. */
const _avisosCerrados = new Set();
function majAlertes() {
  const boite = $('#alertes');
  boite.innerHTML = '';
  if (!etat.produit) return;

  const z = zoneActive();
  const m = defauts().zoneSecurite || 0.04;
  const objets = canvas.getObjects().filter(o => !o.estFond);

  let hors = false, proche = false, pireDpi = null, texteMinCm = null;
  objets.forEach(o => {
    const zo = zonePar(etat.vue, o.zoneId); if (!zo) return;
    /* Se pasa el objeto ENTERO, no su bounding rect: formes.js prefiere las
       esquinas reales (getCoords). Con el objeto rotado, o con la zona
       rotada, las del bounding box caen fuera de la forma y disparaban
       avisos falsos. */
    const ev = evaluarObjeto(zo, o, m);
    if (ev.fuera) hors = true; else if (ev.cerca) proche = true;

    const d = dpiDe(o);
    if (d !== null && (pireDpi === null || d < pireDpi)) pireDpi = d;

    /* Altura real de la letra, no de la caja de texto: fontSize por la escala
       aplicada, llevado a cm de la zona. */
    if (estTexte(o)) {
      const hCm = (o.fontSize || 0) * (o.scaleY || 1) * (zo.cmH / zo.h);
      if (hCm > 0 && (texteMinCm === null || hCm < texteMinCm)) texteMinCm = hCm;
    }
  });

  /* CADA AVISO SE PUEDE CERRAR. Franklin: « mi dibujo está dentro del margen;
     lo que se sale es el cuadro de selección porque le di la vuelta… así para
     que simplemente lo puedan quitar con una X, para que el cliente no se
     asuste ». Y tiene razón en los dos frentes: un aviso que no se puede
     callar acaba ignorándose, y aquí a veces se equivoca.

     Se recuerda lo cerrado para ESA sesión y ESE aviso: si el cliente arregla
     el diseño y vuelve a sacarlo, el aviso reaparece — cerrarlo no apaga el
     control, sólo quita el cartel de en medio. */
  const ajouter = (cls, html) => {
    const clave = cls + '|' + html.replace(/[0-9]+/g, '#');
    if (_avisosCerrados.has(clave)) return;
    const el = document.createElement('div');
    el.className = 'alerte ' + cls;
    const txt = document.createElement('span');
    txt.className = 'alerte__txt';
    txt.innerHTML = html;
    const x = document.createElement('button');
    x.type = 'button'; x.className = 'alerte__x';
    x.setAttribute('aria-label', 'Fermer cet avertissement');
    x.title = 'Fermer';
    x.textContent = '✕';
    /* stopPropagation: en movil el contenedor lleva su propio onclick para
       plegar/desplegar. Sin esto, cerrar un aviso ademas plegaba el resto. */
    x.onclick = (ev) => { ev.stopPropagation(); _avisosCerrados.add(clave); el.remove(); };
    el.append(txt, x);
    boite.appendChild(el);
  };
  if (hors) ajouter('alerte--danger',
    '⚠ Une partie de votre design dépasse la zone d\'impression et ne sera pas imprimée.');
  else if (proche) ajouter('alerte--jaune',
    '⚠ Un élément est proche du bord — risque de coupe.');
  if (pireDpi !== null && pireDpi < (defauts().dpiAvertissement || 150))
    ajouter('alerte--jaune',
      `⚠ Qualité d'impression faible (≈ ${pireDpi} DPI). Réduisez la photo ou choisissez une image plus grande.`);

  /* Un texto por debajo de ~4 mm no se lee impreso. Critico en la medaille os,
     pero el aviso es global. */
  const minCm = defauts().hauteurTexteMinCm || 0.4;
  if (texteMinCm !== null && texteMinCm < minCm)
    ajouter('alerte--jaune', '⚠ Texte trop petit pour être lisible.');

  /* Un QR por debajo de ~1,5 cm impreso no lo lee un movil: cada modulo baja
     de medio milimetro. Va con los demas avisos, no escondido en su panel. */
  const qrs = objets.filter(o => o.qr);
  if (qrs.length) {
    const cmMin = 1.5;
    const petit = qrs.some(o => o.getScaledWidth() * (z.cmW / z.w) < cmMin);
    if (petit) ajouter('alerte--jaune',
      `⚠ QR trop petit pour être scanné (moins de ${cmMin} cm imprimés). Agrandissez-le.`);
  }

  plierAlertes(boite);
}

/* En un telefono, dos avisos apilados son 140 px que tapan justo el producto —
   y el producto es lo que el cliente esta mirando para decidir. Se pliegan: se
   ve el mas grave y un contador, y se despliegan al tocarlos. No se ocultan,
   que la informacion importa; se dejan de estorbar. */
function plierAlertes(boite) {
  const n = boite.children.length;
  boite.classList.remove('alertes--plie');
  boite.onclick = null;
  if (n < 2 || !esMobile()) return;

  boite.classList.add('alertes--plie');
  const badge = document.createElement('button');
  badge.type = 'button';
  badge.className = 'alertes__plus';
  badge.textContent = `+${n - 1}`;
  badge.setAttribute('aria-label', `Voir les ${n} avertissements`);
  boite.appendChild(badge);
  boite.onclick = () => {
    const abierto = boite.classList.toggle('alertes--ouvert');
    badge.textContent = abierto ? '✕' : `+${n - 1}`;
  };
}

/* DPI EFECTIVO.
   No basta con dividir los pixeles del archivo original entre los cm: si el
   cliente recorta la mitad de la foto y la estira igual, solo quedan la mitad
   de los pixeles para los mismos centimetros y el DPI cae. Por eso partimos
   de los pixeles REALMENTE usados: la porcion recortada, llevada a la escala
   del archivo original. */
function dpiDe(o) {
  if (o.type !== 'image' || !o.source) return null;
  const z = zonePar(etat.vue, o.zoneId); if (!z) return null;
  const cm = o.getScaledWidth() * (z.cmW / z.w);
  if (cm <= 0) return null;

  const natif = (o.source.natif && o.source.natif.w)
    || (o._element && o._element.naturalWidth) || o.width || 1;

  /* Solo se puede prometer la resolucion del original si el original sigue en
     memoria. Tras recargar la pagina quedan los pixeles de la miniatura, y
     anunciar el DPI del original seria enganar sobre la calidad de impresion. */
  const hayOriginal = !!(o.source.idOriginal && ORIGINALES.has(o.source.idOriginal));
  const ratioOriginal = hayOriginal ? (o.source.px.w / natif) : 1;
  const pxUtilises = (o.width || natif) * ratioOriginal;
  return Math.round(pxUtilises / cm * 2.54);
}

/* ============================== E2 · HISTORIQUE ========================== */
function instantane() { return JSON.stringify(canvas.toJSON(PROPS)); }

function pousserHistorique() {
  if (etat.hPause) return;
  const s = instantane();
  if (etat.historique[etat.hIndex] === s) return;
  etat.historique = etat.historique.slice(0, etat.hIndex + 1);
  etat.historique.push(s);
  if (etat.historique.length > MAX_HISTORIQUE) etat.historique.shift();
  etat.hIndex = etat.historique.length - 1;
  majBoutonsHistorique();
}

function majBoutonsHistorique() {
  $('#btn-annuler-h').disabled = etat.hIndex <= 0;
  $('#btn-refaire').disabled  = etat.hIndex >= etat.historique.length - 1;
}

function restaurerHistorique(i) {
  if (i < 0 || i >= etat.historique.length) return;
  etat.hIndex = i; etat.hPause = true;
  canvas.loadFromJSON(JSON.parse(etat.historique[i]), () => {
    reappliquer(); canvas.requestRenderAll();
    etat.hPause = false;
    majBoutonsHistorique(); majAlertes(); sauvegarder(); majPanneaux();
  });
}
const annuler = () => restaurerHistorique(etat.hIndex - 1);
const refaire = () => restaurerHistorique(etat.hIndex + 1);

/* Tras cargar un JSON hay que reponer clips y filtros: no viajan solos */
function reappliquer() {
  canvas.getObjects().forEach(o => {
    const z = zonePar(etat.vue, o.zoneId);
    if (z) o.clipPath = clipPour(z);
    /* Con la IA no hay filtro que reponer: la imagen sin fondo YA es la
       imagen del objeto. Solo nos aseguramos de que el recorte se respete. */
    if (o.type === 'image' && o.cropX === undefined) { o.cropX = 0; o.cropY = 0; }
    /* Los bloqueos del modelo se reponen aqui y no al sembrar: loadFromJSON
       corre en cada cambio de vista, en cada undo y al restaurar la sesion. */
    if (typeof MODELES !== 'undefined') MODELES.appliquerVerrous(o, etat.produit);
  });
}

/* ================================ VUES / ZONES =========================== */
/* La textura solo debe caer SOBRE la zona de impresion, no sobre toda la
   prenda: fuera de la zona no hay diseno que integrar. clip-path en % del
   espacio 1024. */
function majTexture() {
  const v = vueActive();
  const on = etat.realiste && !!v.texture && !etat.apercu;
  texture.hidden = !on;
  if (!on) return;
  if (texture.getAttribute('src') !== v.texture) texture.src = v.texture;
  texture.style.opacity = (defauts().textureOpacite != null)
    ? defauts().textureOpacite : 0.15;
  /* El recorte iba con clip-path:inset(), que solo sabe expresar rectangulos
     alineados a los ejes: con un circulo, un corazon o una zona rotada
     recortaba mal. Ahora es una mascara SVG con la forma real, en viewBox de
     1024 para que escale sola con el plateau sin recalcular al redimensionar. */
  const z = zoneActive(), T = 1024;
  texture.style.clipPath = 'none';
  const mascara = masqueDeZone(z, T);
  texture.style.webkitMaskImage = mascara;
  texture.style.maskImage = mascara;
  texture.style.webkitMaskSize = '100% 100%';
  texture.style.maskSize = '100% 100%';
  texture.style.webkitMaskRepeat = 'no-repeat';
  texture.style.maskRepeat = 'no-repeat';
}

/* Mascara SVG de la zona: blanco dentro de la forma, transparente fuera.
   Vale para todos los productos, no solo el t-shirt: la capa « Aperçu
   realiste » es global. */
function masqueDeZone(z, T) {
  const a = zonaRotacion(z), c = zonaCentro(z);
  const gira = a ? ` transform="rotate(${a} ${c.cx} ${c.cy})"` : '';
  const relleno = esRect(z)
    ? `<rect x="${z.x}" y="${z.y}" width="${z.w}" height="${z.h}" rx="${z.radiusPx||0}" fill="#fff"${gira}/>`
    : `<path d="${pathZone(z, 1)}" fill="#fff"${gira}/>`;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${T} ${T}">${relleno}</svg>`;
  return `url("data:image/svg+xml;utf8,${encodeURIComponent(svg)}")`;
}

/* EL ENCUADRE DEL PLATEAU.
   El espacio de coordenadas sigue siendo 1024 x 1024 —es el contrato con el
   admin, las guias, el JSON y el fichero de impresion— pero el plateau solo
   ensena la BANDA donde esta el producto. Las capas se dibujan como ese
   cuadrado, mas grandes que el plateau, y este las recorta.

   La proporcion sale de donde toca en cada caso, y por eso una imagen nueva
   se encuadra sola:
     - sin foto (gabarit plano): de los cm declarados, que son la verdad
     - con foto: del tamano NATURAL de la imagen, que es la banda real
   Se ignoran las diferencias menores del 2 %: el borde de un JPEG no
   justifica recortar nada. */
/* Donde cae la IMAGEN del mockup dentro del cuadrado de 1024, con `contain`.
   Es el mismo calculo que decide el encuadre del plateau, y hace falta aqui
   por separado porque el 3D pinta en un canvas, no en el DOM: ahi no hay
   `object-fit` que haga el trabajo. Devuelve null si no hay imagen. */
/* ¿Se puede dibujar el mockup en un canvas sin contaminarlo?
   Esto no es paranoia: costo una taza NEGRA. Dibujar una imagen de otro
   dominio sin CORS contamina el canvas, y WebGL se niega a subir un canvas
   contaminado — « Tainted canvases may not be loaded » — asi que la textura
   entera se pierde, no solo el trozo de imagen.
   El atributo crossorigin del <img> lo evita, pero si algun dia el mockup
   viene de un servidor que no manda CORS, mas vale una taza sin estampado
   que una taza negra. Se prueba una vez por imagen sobre un canvas de 1 px. */
const _teinture = new Map();
function mockupSansTeinture() {
  const src = mockup.currentSrc || mockup.src || '';
  if (!src) return false;
  if (_teinture.has(src)) return _teinture.get(src);
  let ok = false;
  try {
    const c = document.createElement('canvas'); c.width = c.height = 1;
    const g = c.getContext('2d');
    g.drawImage(mockup, 0, 0, 1, 1);
    g.getImageData(0, 0, 1, 1);          // lanza si esta contaminado
    ok = true;
  } catch (e) { ok = false; }
  _teinture.set(src, ok);
  return ok;
}

function rectMockup1024() {
  if (!mockup || mockup.hidden) return null;
  const w = mockup.naturalWidth, h = mockup.naturalHeight;
  if (!(w > 0 && h > 0)) return null;
  const r = w / h, T = 1024;
  if (r >= 1) { const hh = T / r; return { x:0, y:(T - hh) / 2, w:T, h:hh }; }
  const ww = T * r; return { x:(T - ww) / 2, y:0, w:ww, h:T };
}

function majFormatPlateau() {
  const v = vueActive();
  let r = 1;
  if (v && v.sansMockup) {
    const g = v.gabarit || {};
    if (g.cmW > 0 && g.cmH > 0) r = g.cmW / g.cmH;
  } else if (mockup.naturalWidth > 0 && mockup.naturalHeight > 0) {
    r = mockup.naturalWidth / mockup.naturalHeight;
  }
  if (!isFinite(r) || r <= 0) r = 1;
  if (Math.abs(r - 1) < 0.02) r = 1;
  etat.ratioPlateau = r;

  const pc = n => (Math.round(n * 1000) / 1000) + '%';
  const st = plateau.style;
  st.setProperty('--ratio-plateau', r);
  if (r >= 1) {
    /* Producto ancho: el cuadrado desborda por arriba y por abajo. */
    st.setProperty('--bande-w', '100%');
    st.setProperty('--bande-h', pc(r * 100));
    st.setProperty('--bande-x', '0%');
    st.setProperty('--bande-y', pc(-(r - 1) / 2 * 100));
  } else {
    /* Producto alto: desborda por los lados. */
    const k = 1 / r;
    st.setProperty('--bande-w', pc(k * 100));
    st.setProperty('--bande-h', '100%');
    st.setProperty('--bande-x', pc(-(k - 1) / 2 * 100));
    st.setProperty('--bande-y', '0%');
  }
  majEchelleControles();
  canvas.requestRenderAll();
}

/* naturalWidth no existe hasta que la imagen carga, asi que el encuadre se
   rehace tambien ahi. Sin esto, la primera vista sale cuadrada y solo se
   corrige al cambiar de vista. */
mockup.addEventListener('load', majFormatPlateau);

function majVue() {
  const v = vueActive();
  /* Vista sin mockup fotografico (la taza: gabarit plano de 19 x 9 cm). No
     hay foto de producto que mostrar, asi que el plateau se pone en blanco y
     el cliente edita sobre el wrap plano. El aspecto real de la taza llega en
     el punto 8 con el preview 3D. */
  const sansMockup = !!v.sansMockup;
  mockup.hidden = sansMockup;
  mockup.src = sansMockup ? '' : v.mockup;
  plateau.classList.toggle('plateau--gabarit', sansMockup);
  majFormatPlateau();
  majTexture();
  dessinerGuides(); majAlertes();
}

function changerVue(id) {
  if (id === etat.vue) return;
  etat.designs[etat.vue] = canvas.toJSON(PROPS);
  etat.vue = id;
  etat.hPause = true;
  canvas.loadFromJSON(etat.designs[id] || { objects: [] }, () => {
    reappliquer(); canvas.requestRenderAll();
    etat.hPause = false;
    etat.historique = []; etat.hIndex = -1; pousserHistorique();
    majVue(); construireVues(); majAlertes(); sauvegarder(); majPanneaux();
    rafraichir3D();
  });
}

function nbElements(vId) {
  if (vId === etat.vue) return canvas.getObjects().filter(o => !o.estFond).length;
  return ((etat.designs[vId] || {}).objects || []).filter(o => !o.estFond).length;
}

/* Las zonas de una misma vista son alternativas, no acumulables */
function choisirZone(vId, zId) {
  const avant = etat.zones[vId];
  if (vId === etat.vue && zId === avant) return;
  if (zId !== avant && nbElements(vId) > 0) {
    confirmer("Changer de zone d'impression effacera votre création actuelle. Voulez-vous continuer ?",
      () => appliquerZone(vId, zId, true));
    return;
  }
  appliquerZone(vId, zId, false);
}

function appliquerZone(vId, zId, effacer) {
  if (vId === etat.vue) {
    if (effacer) {
      canvas.getObjects().slice().forEach(o => canvas.remove(o));
      canvas.discardActiveObject();
    }
    etat.zones[vId] = zId;
    dessinerGuides(); majTexture(); construireVues(); majAlertes(); majPanneaux();
    pousserHistorique(); sauvegarder(); canvas.requestRenderAll();
  } else {
    if (effacer) etat.designs[vId] = { objects: [] };
    etat.zones[vId] = zId;
    changerVue(vId);
  }
}

/* Miniaturas de vista + chips de zona bajo el canvas */
/* Vistas y zonas viven en el panel derecho (fila horizontal en movil) */
function construireVues() {
  const cv = $('#vues'), cz = $('#zones');
  cv.innerHTML = ''; cz.innerHTML = '';

  /* LAS VISTAS ATADAS A UN MODELO NO SE LISTAN AQUÍ. Se eligen en « Modèle »,
     con su foto, que es donde el cliente las reconoce. Listarlas también como
     vistas ponía lo mismo dos veces en el mismo panel —« Modèle 1…4 » arriba y
     « 1 2 3 4 » debajo— y dos maneras de hacer lo mismo no son el doble de
     claras, son la mitad.
     Se mira si hay MÁS DE UNA atada: con una sola, quitarla dejaría el selector
     de vistas vacío sin ganar nada. */
  const vues = etat.produit.perso.vues || [];
  const porModelo = vues.filter(v => v.varianteId != null).length;
  vues.forEach(v => {
    if (porModelo > 1 && v.varianteId != null) return;
    const b = document.createElement('button');
    b.className = 'vue'; b.setAttribute('aria-selected', v.id === etat.vue);
    b.innerHTML = `<img src="${v.mockup}" alt=""><span>${v.nom}</span>`;
    b.onclick = () => changerVue(v.id);
    cv.appendChild(b);
  });
  /* Sin ninguna vista que elegir, el bloque sobra. */
  const blocV = cv.closest('.cote__bloc');
  if (blocV) blocV.hidden = !cv.children.length;

  (vueActive().zones || []).forEach(z => {
    /* « Décor fixe » = parte del diseno, no un area que el cliente elija.
       Ofrecersela seria invitarle a escribir encima del dibujo. */
    if (z.role === 'decor') return;
    const b = document.createElement('button');
    b.className = 'zone' + (z.role === 'saisie' ? ' zone--saisie' : '');
    b.setAttribute('aria-selected', z.id === etat.zones[etat.vue]);
    /* SIN MEDIDA NO SE ESCRIBE UNA MEDIA. Con las dos incógnitas salía
       « — × — », que parece un fallo de la app; y con una sola, « 115,2 cm × — »,
       que es peor todavía porque el número que queda es el heredado de otro
       producto. Cuando no hay ninguna calibración física se dice con
       palabras. */
    const conAncho = z.cmW > 0, conAlto = z.cmH > 0;
    b.innerHTML = `<span class="zone__nom">${z.nom}</span>`
      + (conAncho || conAlto
          ? `<span class="zone__cm">${fmtDim(z.cmW)} × ${fmtDim(z.cmH)}</span>`
          : `<span class="zone__cm zone__cm--pendiente"
                   title="Ce produit n’a pas encore ses mesures réelles : la zone se dessine bien, mais on ne peut pas encore la traduire en centimètres."
             >mesures à venir</span>`);
    b.onclick = () => choisirZone(etat.vue, z.id);
    cz.appendChild(b);
  });
}

/* ================================== ZOOM ================================= */
/* ZOOM Y ARRASTRE CON EL RATÓN. Franklin: « quería acercarlo y alejarlo con el
   pad, y moverlo a la derecha y a la izquierda, pero no me deja… si quiero
   puedo hacer zoom y verlo más a detalle ». Había pellizco en el móvil y dos
   botones +/−, y nada más: en un portátil, para colocar un texto de 4 mm hay
   que poder acercarse.

   `etat.pan` es el desplazamiento del tablero. Va en el MISMO transform que la
   escala, y el orden importa: primero se traslada y luego se escala, si no el
   desplazamiento se multiplicaría por el zoom y el tablero se escaparía. */
function aplicarTransformPlateau() {
  const p = etat.pan || (etat.pan = { x: 0, y: 0 });
  /* DESDE LA ESQUINA. La cuenta de abajo supone que el tablero escala desde
     su esquina de arriba a la izquierda; el CSS lo escalaba desde su CENTRO
     (el valor por defecto). Con los dos desacordes, acercarse « sobre el
     puntero » no se quedaba sobre el puntero: medido en el móvil, el punto
     que estaba entre los dedos acababa 214 px más allá. Se fija aquí, junto
     a la transformación, para que no dependa de ninguna hoja de estilo. */
  plateau.style.transformOrigin = '0 0';
  plateau.style.transform = `translate(${p.x}px, ${p.y}px) scale(${etat.zoom})`;
}

function appliquerZoom(z, centro) {
  const antes = etat.zoom || 1;
  etat.zoom = Math.min(3, Math.max(0.5, z));
  if (!etat.pan) etat.pan = { x: 0, y: 0 };
  /* Sin punto (botones + y −): hacia el centro del tablero, que es como se
     veía antes con el origen en el centro. */
  const sinPunto = !centro;
  if (!centro) centro = { x: plateau.offsetWidth / 2, y: plateau.offsetHeight / 2 };
  /* Acercarse SOBRE EL PUNTERO, no sobre el centro de la pantalla: si no, lo
     que se estaba mirando se va de la vista justo al acercarse. */
  if (centro && antes > 0) {
    const k = etat.zoom / antes;
    etat.pan.x = centro.x - (centro.x - etat.pan.x) * k;
    etat.pan.y = centro.y - (centro.y - etat.pan.y) * k;
  }
  /* Al alejar del todo, se recentra — centrado DE VERDAD: con el origen en
     la esquina, « pan a cero » lo habría llevado arriba a la izquierda. */
  if (etat.zoom <= 0.5001) etat.pan = { x: (1 - etat.zoom) * plateau.offsetWidth / 2,
                                        y: (1 - etat.zoom) * plateau.offsetHeight / 2 };
  /* « 100 % » (el botón del valor, o un producto nuevo) es la vista de
     partida, tal cual: sin desplazamiento. */
  if (sinPunto && etat.zoom === 1) etat.pan = { x: 0, y: 0 };
  aplicarTransformPlateau();
  $('#zoom-val').textContent = Math.round(etat.zoom * 100) + '%';
}

/* Mover el tablero sin cambiar el zoom. */
function deplacerPlateau(dx, dy) {
  if (!etat.pan) etat.pan = { x: 0, y: 0 };
  etat.pan.x += dx; etat.pan.y += dy;
  aplicarTransformPlateau();
}

/* ============================== CONFIRMACION ============================= */
/* La accion pendiente vive AQUI y solo aqui.
   Antes estaba partida entre los dos bloques: este guardaba el callback en una
   variable privada y el manejador del boton leia otra en window. Nunca se
   encontraban, asi que "Effacer et changer" no hacia nada. */
let _actionConfirmee = null;

function confirmer(texte, action) {
  $('#confirmer-texte').textContent = texte;
  _actionConfirmee = action;
  $('#modale-confirmer').hidden = false;
  setTimeout(() => { const b = $('#btn-confirmer'); if (b) b.focus(); }, 0);
}

function fermerConfirmer() {
  _actionConfirmee = null;
  $('#modale-confirmer').hidden = true;
}

function executerConfirmation() {
  const a = _actionConfirmee;
  fermerConfirmer();
  if (typeof a === 'function') a();
}

/* ============================== PERSISTENCIA =============================
   DOS CAPAS, y las dos hacen falta.

   sessionStorage es la capa RÁPIDA: sincrona, sin promesas, sobrevive a un
   F5 y está lista antes de que el editor termine de montarse. Es lo que había.

   Lo que NO hacía era sobrevivir a cerrar la pestaña. Media hora de trabajo se
   perdía sin aviso y sin nada que recuperar — la peor pérdida que tenía el
   Studio, y la que no se ve probando, porque probando no se cierra la pestaña.

   La capa DURABLE (creation.js, IndexedDB) es la que permite volver mañana.
   Se escribe con más rebote porque no corre prisa: si la pestaña se cierra
   antes, `pagehide` fuerza la escritura.
   ========================================================================== */
const cleStockage = () => 'edisamp-studio-' + (etat.produit ? etat.produit.handle : 'x');
let _t = null;

/** Lo que constituye la sesión del cliente. Un solo sitio que lo diga. */
function instantanea() {
  return {
    productHandle: etat.produit ? etat.produit.handle : null,
    productTitle: etat.produit ? (etat.produit.titre || etat.produit.handle) : null,
    variant: etat.variante || null,
    color: etat.couleur || null,
    vue: etat.vue,
    zones: etat.zones,
    designs: etat.designs,
    fond: etat.fond,
  };
}

/* Una miniatura del diseño para la tarjeta « votre création vous attend ».
   Pequeña a propósito: es un recordatorio, no una prueba de impresión. */
function miniatura() {
  try {
    return canvas.toDataURL({ format: 'png', multiplier: 220 / (canvas.getWidth() || 220) });
  } catch (e) { return null; }
}

function sauvegarder() {
  clearTimeout(_t);
  _t = setTimeout(() => {
    if (!etat.produit) return;
    etat.designs[etat.vue] = canvas.toJSON(PROPS);

    try {
      sessionStorage.setItem(cleStockage(), JSON.stringify({
        vue: etat.vue, zones: etat.zones, designs: etat.designs, fond: etat.fond,
        designId: (typeof CREATION !== 'undefined') ? CREATION.idActual() : null,
      }));
    } catch (e) { console.warn('[EDISAMP] sessionStorage plein.'); }

    if (typeof CREATION !== 'undefined' && CREATION.disponible()) {
      CREATION.guardar({ ...instantanea(), preview: miniatura() });
    }
    if (typeof EVENEMENTS !== 'undefined') {
      EVENEMENTS.emitir(EVENEMENTS.TIPOS.DESIGN_MODIFIED, {
        designId: (typeof CREATION !== 'undefined') ? CREATION.idActual() : null,
        productHandle: etat.produit.handle,
      });
      EVENEMENTS.tocar();
    }
  }, 300);
}

function restaurer() {
  try {
    const b = sessionStorage.getItem(cleStockage());
    if (!b) return false;
    const d = JSON.parse(b);
    etat.vue = d.vue || etat.vue;
    Object.assign(etat.zones, d.zones || {});
    etat.designs = d.designs || {};
    etat.fond = d.fond || {};
    if (d.designId && typeof CREATION !== 'undefined') CREATION.comenzar(d.designId);
    return true;
  } catch (e) { return false; }
}

/**
 * Retoma una creación guardada de verdad. Async porque IndexedDB lo es.
 *
 * Sólo pisa el estado si el registro trae algo: retomar una sesión vacía
 * dejaría al cliente peor que si no hubiera retomado nada.
 */
async function retomarCreacion(designId) {
  if (typeof CREATION === 'undefined' || !CREATION.disponible()) return false;
  const r = await CREATION.cargar(designId);
  if (!r || !r.designs || !Object.keys(r.designs).length) return false;

  CREATION.comenzar(r.designId);
  /* El modelo también: en el cojín, « Modifier » tiene que volver al cojín
     que se compró, no al primero de la lista. */
  if (r.variant) etat.variante = r.variant;
  etat.vue = r.vue || etat.vue;
  Object.assign(etat.zones, r.zones || {});
  etat.designs = r.designs;
  etat.fond = r.fond || {};

  /* Y AHORA el lienzo. Poner `etat.designs` y no cargarlo dejaba el editor
     vacío con la sesión llena — y el primer `sauvegarder()` posterior escribía
     el lienzo vacío ENCIMA del trabajo recuperado. Se perdía justo lo que se
     venía a rescatar.

     Es el mismo camino que `changerVue`: cargar, reponer clips y filtros
     —no viajan en el JSON— y sólo entonces dejar que el historial y el
     guardado vuelvan a correr. */
  await new Promise((listo) => {
    etat.hPause = true;
    canvas.loadFromJSON(etat.designs[etat.vue] || { objects: [] }, () => {
      reappliquer();
      canvas.requestRenderAll();
      etat.hPause = false;
      etat.historique = []; etat.hIndex = -1;
      listo();
    });
  });

  if (typeof EVENEMENTS !== 'undefined') {
    EVENEMENTS.emitir(EVENEMENTS.TIPOS.DESIGN_RESUMED, {
      designId: r.designId, productHandle: r.productHandle,
    });
  }
  return true;
}

/**
 * « Votre création vous attend » — discreto, y sólo cuando hay algo.
 *
 * No es un modal ni bloquea nada: es una tarjeta abajo a la izquierda que se
 * puede ignorar. Un pop-up delante de alguien que acaba de entrar a crear es
 * exactamente la interrupción que esta experiencia no quiere.
 */
function ofrecerRetomar(meta) {
  if (!meta || document.querySelector('.reprise')) return;

  const caja = document.createElement('aside');
  caja.className = 'reprise';
  caja.setAttribute('role', 'status');

  const cuando = (() => {
    const min = Math.round((Date.now() - (meta.updatedAt || 0)) / 60000);
    if (min < 60) return `il y a ${Math.max(1, min)} min`;
    const h = Math.round(min / 60);
    return h < 24 ? `il y a ${h} h` : `il y a ${Math.round(h / 24)} j`;
  })();

  caja.innerHTML = `
    <div class="reprise__vignette">${meta.preview
      ? `<img src="${meta.preview}" alt="">` : ''}</div>
    <div class="reprise__texte">
      <p class="reprise__titre">Votre création vous attend</p>
      <p class="reprise__quand">${meta.productTitle || ''} · ${cuando}</p>
    </div>
    <button type="button" class="reprise__ok">Continuer</button>
    <button type="button" class="reprise__non" aria-label="Fermer">&times;</button>`;

  caja.querySelector('.reprise__ok').addEventListener('click', async () => {
    caja.remove();
    const ok = await retomarCreacion(meta.designId);
    if (ok) {
      // `retomarCreacion` ya ha cargado el lienzo. Aquí sólo se repinta la
      // interfaz y se empuja el primer punto de historial.
      majVue(); construireVues(); majAlertes(); pousserHistorique();
      if (typeof rafraichir3D === 'function') rafraichir3D();
    }
  });
  caja.querySelector('.reprise__non').addEventListener('click', () => caja.remove());

  document.body.append(caja);
}

/**
 * Crear una variante: la creación actual sigue donde está, y se sigue
 * trabajando sobre una copia con vida propia.
 *
 * Se guarda ANTES de copiar: si no, la variante nacería sin lo último que el
 * cliente acaba de hacer, que es justo lo que quería probar de otra manera.
 */
async function creerVariante() {
  if (typeof CREATION === 'undefined' || !CREATION.disponible()) return null;
  if (!etat.produit) return null;

  etat.designs[etat.vue] = canvas.toJSON(PROPS);
  await CREATION.guardarAhora({ ...instantanea(), preview: miniatura() });

  const copia = await CREATION.duplicar();
  if (!copia) return null;

  /* No se recarga nada: el lienzo ya tiene el contenido correcto. Lo único
     que ha cambiado es a qué sesión se guarda a partir de ahora. */
  if (typeof EVENEMENTS !== 'undefined') {
    EVENEMENTS.emitir(EVENEMENTS.TIPOS.DESIGN_STARTED, {
      designId: copia.designId, productHandle: etat.produit.handle,
      meta: { variantDe: copia.parentDesignId },
    });
  }
  return copia;
}

/* Cerrar la pestaña no puede esperar al rebote de 800 ms. `pagehide` es el
   único que dispara de verdad en iOS Safari — `beforeunload` no. */
if (typeof window !== 'undefined') {
  window.addEventListener('pagehide', () => {
    if (typeof CREATION === 'undefined' || !etat.produit) return;
    try {
      etat.designs[etat.vue] = canvas.toJSON(PROPS);
      CREATION.guardarAhora({ ...instantanea(), preview: null });
    } catch (e) {}
  });
}

function apresChangement() {
  /* EL JSON CADUCA CON EL DISENO. Se cachea en `etat.jsonCompleto` para que
     « Continuer » y « Ajouter » no lo reconstruyan dos veces seguidas — pero
     desde que se puede anadir varias piezas sin salir, un JSON viejo
     significa mandar al carrito el diseno ANTERIOR. Se tira aqui, que es por
     donde pasa todo cambio. */
  etat.jsonCompleto = null;
  majAlertes(); canvas.requestRenderAll(); sauvegarder(); pousserHistorique();
  /* Un solo enganche para TODO el 3D: cada cambio del diseno pasa por aqui,
     asi que la textura no puede quedarse desincronizada por una via que
     alguien olvidara conectar. */
  rafraichir3D();
}

/* Puentes al bloque de paneles: se define despues, asi que no podemos
   llamarlo directamente desde aqui. */
function majPanneaux()            { if (window.__panneaux) window.__panneaux.maj(); }

/* ===================== FINITIONS — impression / gravure ==================
   Franklin no solo sublima: tambien graba con laser (Cricut), sobre todo
   medailles y porte-cles. Son dos oficios distintos con el MISMO diseno.

   Que cambia en gravure:
     - No hay color. El laser quema: solo hay tono. Se desactiva la paleta y
       el preview se ve en un tono grabado uniforme sobre el material.
     - Las fotos se ven en monocromo de alto contraste, que es lo que de verdad
       va a salir.
     - El export genera, ADEMAS del PNG normal, el fichero de laser.

   El preview de gravure se hace con FILTROS DE PINTADO, no tocando el diseno:
   ni los objetos ni el JSON se enteran. Asi el cliente puede cambiar de
   acabado las veces que quiera sin degradar su trabajo, y el mismo diseno
   sirve para los dos. */
function finitions() {
  const p = etat.produit && etat.produit.perso;
  const l = (p && p.finitions) || null;
  return (l && l.length > 1) ? l : null;      // con una sola no hay que elegir
}

const NOM_FINITION = { impression:'Impression', gravure:'Gravure' };

/* El filtro que da el aspecto « quemado ». Se aplica al canvas del cliente por
   CSS y al lienzo del 3D por ctx.filter: la misma receta en los dos sitios. */
const FILTRE_GRAVURE = 'grayscale(1) contrast(1.45) brightness(.82) sepia(.35)';

function construireFinitions() {
  const bloc = $('#bloc-finition'); if (!bloc) return;
  const l = finitions();
  bloc.hidden = !l;
  if (!l) return;
  const c = $('#finitions'); c.innerHTML = '';
  l.forEach(f => {
    const b = document.createElement('button');
    b.className = 'finition'; b.type = 'button';
    b.textContent = NOM_FINITION[f] || f;
    b.setAttribute('aria-pressed', f === etat.finition);
    b.onclick = () => appliquerFinition(f);
    c.appendChild(b);
  });
}

function appliquerFinition(f) {
  if (!f || f === etat.finition) return;
  etat.finition = f;
  const grave = (f === 'gravure');
  document.body.classList.toggle('gravure', grave);
  /* El fondo de color no significa nada en un grabado: no hay tinta que
     poner, solo material que quitar. */
  const p = etat.produit.perso;
  $('#onglet-fond').hidden = grave || !p.fondAutorise;
  if (grave && !$('#panneau-fond').hidden) fermerPanneaux();
  construireFinitions(); majAlertes(); canvas.requestRenderAll(); rafraichir3D();
}

/* =========================== TALLAS (camiseta) ===========================
   El mockup es UNA sola foto. Elegir talla no cambia la foto: cambia CUANTOS
   CENTIMETROS representa. Un ancho de pecho de 58 cm (S) sobre los mismos 461
   px da 7,95 px/cm; una XL de 65 cm da 7,09. Consecuencia: el MISMO estampado
   de 30 cm ocupa mas torso en una S que en una XL, que es exactamente lo que
   pasa con la prenda de verdad.

   El EXPORT NO CAMBIA NUNCA: siguen siendo 30 x 45 cm reales. Esto es preview.

   Al cambiar de talla las zonas se redimensionan y el diseno se reescala con
   ellas alrededor del centro de la zona. Se puede hacer sin miedo porque el
   contrato del JSON ya es en coordenadas normalizadas 0-1 relativas a la
   zona: el diseno no « se mueve », se vuelve a expresar a otra escala. */
function tailles() {
  const p = etat.produit && etat.produit.perso;
  return (p && p.anchoPorTalla) || null;
}

function construireTailles() {
  const bloc = $('#bloc-taille'); if (!bloc) return;
  const t = tailles();
  /* Con UNA sola talla no hay nada que elegir: un selector con un solo boton
     es ruido que ademas invita a pulsarlo. Franklin ha dejado el t-shirt en
     M unica « asi ya no se toca ». */
  bloc.hidden = !t || Object.keys(t).length < 2;
  if (bloc.hidden) return;
  const c = $('#tailles'); c.innerHTML = '';
  Object.keys(t).forEach(nom => {
    const b = document.createElement('button');
    b.className = 'taille'; b.type = 'button';
    b.textContent = nom;
    b.title = `${t[nom]} cm de largeur de poitrine`;
    b.setAttribute('aria-pressed', nom === etat.taille);
    b.onclick = () => appliquerTaille(nom);
    c.appendChild(b);
  });
}

/* Reexpresa una zona y su contenido a la escala de la talla elegida. */
function appliquerTaille(nom) {
  const t = tailles(); if (!t || !t[nom] || nom === etat.taille) return;
  etat.taille = nom;
  const cm = t[nom];

  (etat.produit.perso.vues || []).forEach(v => {
    const px = (v.torso || {}).largeurPx;
    if (!px) return;
    const k = px / cm;
    (v.zones || []).forEach(z => {
      /* Sin cmW/cmH no hay nada que reescalar: `Math.round(undefined * k)` es
         NaN y dejaría la zona con w/h/x/y a NaN, o sea invisible. Producto sin
         medir = talla sin efecto, que es lo honesto. */
      if (!(z.cmW > 0) || !(z.cmH > 0)) return;
      const cx = z.x + z.w/2, cy = z.y + z.h/2;
      const nw = Math.round(z.cmW * k), nh = Math.round(z.cmH * k);
      const r = nw / z.w;
      if (Math.abs(r - 1) > 0.0005) {
        /* La vista activa vive en el canvas; las demas, serializadas. Hay que
           tocar las dos o al cambiar de vista el diseno saldria descuadrado. */
        if (v.id === etat.vue) {
          canvas.getObjects().filter(o => o.zoneId === z.id).forEach(o => {
            o.set({ left: cx + (o.left - cx) * r, top: cy + (o.top - cy) * r,
                    scaleX: (o.scaleX || 1) * r, scaleY: (o.scaleY || 1) * r });
            o.setCoords();
          });
        } else {
          const d = etat.designs[v.id];
          (d && d.objects || []).forEach(o => {
            if (o.zoneId !== z.id) return;
            o.left = cx + (o.left - cx) * r; o.top = cy + (o.top - cy) * r;
            o.scaleX = (o.scaleX || 1) * r; o.scaleY = (o.scaleY || 1) * r;
          });
        }
      }
      z.w = nw; z.h = nh;
      z.x = Math.round(cx - nw/2); z.y = Math.round(cy - nh/2);
    });
    v.torso = Object.assign({}, v.torso, { largeurCm: cm, pxParCm: +(px/cm).toFixed(4) });
  });

  if (typeof invalidarCache === 'function') invalidarCache();
  canvas.getObjects().forEach(o => {
    const z = zonePar(etat.vue, o.zoneId); if (z) o.clipPath = clipPour(z);
  });
  construireTailles(); dessinerGuides(); majTexture(); construireVues();
  majAlertes(); canvas.requestRenderAll(); sauvegarder(); rafraichir3D();
}

/* ======================== 8 · PREVIEW 3D DE LA TAZA =======================
   El 3D es un espejo del canvas plano, no una segunda fuente de verdad: se
   recorta la ZONA del canvas de Fabric y se vuelca tal cual en la funda
   cilindrica. El fondo del cliente entra solo, porque es un objeto mas del
   canvas (estFond). Las guias NO entran: viven en la capa SVG, aparte.
   ======================================================================== */
function produitAvec3D() {
  return !!(etat.produit && etat.produit.perso && etat.produit.perso.preview3D);
}

/* Pinta el wrap plano de la vista activa en el lienzo que le den. */
function peindreWrap(dest) {
  /* La zona que se envuelve en la taza esta DECLARADA en la vista
     (`zoneImpression`, punto 5), no es « la que el cliente tenga
     seleccionada ». Con una sola zona daba igual; con dos, la segunda se
     envolvia estirada al wrap en cuanto el cliente la tocaba — y el 3D
     ensenaba algo que no correspondia a lo que se iba a imprimir.
     Sin declaracion manda la PRIMERA zona: un defecto determinista. */
  const v = vueActive(); if (!v) return;
  const zs = v.zones || [];
  /* Orden de preferencia: la declarada, la marcada « impression », la
     primera. Sin esto, en la taza Stitch el 3D podia envolver la bandita del
     prenom en lugar del diseno entero. */
  const z = zs.find(x => x.id === v.zoneImpression)
         || zs.find(x => !x.role || x.role === 'impression')
         || zs[0];
  if (!z) return;
  const src = canvas.lowerCanvasEl;
  /* El canvas de Fabric es retina: sus pixeles reales no son los 1024
     logicos con los que estan medidas las zonas. */
  const k = src.width / 1024;
  const c = dest.getContext('2d');
  c.clearRect(0, 0, dest.width, dest.height);

  /* EL MARCO DE SELECCION NO SE IMPRIME EN LA TAZA.
     Franklin: « sale con el margen y no tendria que salir asi ». Y era eso:
     el rectangulo dorado y las asas del objeto seleccionado acababan
     ENVUELTOS en la taza, como si formaran parte del diseno.
     La causa es que en esta version de Fabric los controles se dibujan en el
     canvas de ABAJO, que es justo el que se copia a la textura. Medido: con
     el objeto seleccionado la textura tiene 6 582 pixeles dorados; sin
     seleccionar, cero.
     Se apagan bordes y asas mientras se copia y se devuelven despues. Asi el
     cliente NO pierde la seleccion —sigue pudiendo mover su texto— y la taza
     ensena solo lo que se va a imprimir. */
  const sel = canvas.getActiveObject();
  const restaurar = [];
  if (sel) {
    const objs = (sel.type === 'activeSelection' && typeof sel.getObjects === 'function')
      ? sel.getObjects().concat(sel) : [sel];
    objs.forEach(o => {
      restaurar.push([o, o.hasBorders, o.hasControls]);
      o.hasBorders = false; o.hasControls = false;
    });
    canvas.renderAll();
  }

  /* EL DISENO DE FONDO TAMBIEN VA A LA TAZA. Franklin: « ves que la taza no
     tiene la imagen y quiero que tenga esa imagen estampada ».
     Aqui estaba el fallo: el mockup es una capa <img> del DOM, NO un objeto
     de Fabric, asi que pintando solo el canvas la taza salia blanca con el
     prenom flotando. En esta taza el mockup ES el estampado —el dibujo de
     Stitch— y sin el, el 3D no ensena el producto sino la mitad de el.
     Se recorta la parte de la imagen que cae dentro de la zona que se
     envuelve, en pixeles naturales del archivo, y se recorta al borde: una
     zona puede sobresalir de la imagen y `drawImage` con origen fuera no
     dibuja nada. */
  const R = rectMockup1024();
  if (R && mockup.complete && mockupSansTeinture()) {
    const nw = mockup.naturalWidth, nh = mockup.naturalHeight;
    const aPx = (u, orig, largo, nat) => (u - orig) / largo * nat;
    let sx = aPx(z.x, R.x, R.w, nw), sy = aPx(z.y, R.y, R.h, nh);
    let sw = z.w / R.w * nw,          sh = z.h / R.h * nh;
    /* Recorte a la imagen, manteniendo la proporcion de lo que se descarta
       para que el trozo dibujado siga cayendo donde toca. */
    const dx = dest.width / sw, dy = dest.height / sh;
    let ox = 0, oy = 0, ow = dest.width, oh = dest.height;
    if (sx < 0)      { ox = -sx * dx; ow -= ox; sw += sx; sx = 0; }
    if (sy < 0)      { oy = -sy * dy; oh -= oy; sh += sy; sy = 0; }
    if (sx + sw > nw) { const ex = sx + sw - nw; ow -= ex * dx; sw -= ex; }
    if (sy + sh > nh) { const ey = sy + sh - nh; oh -= ey * dy; sh -= ey; }
    if (sw > 0 && sh > 0 && ow > 0 && oh > 0) {
      try { c.drawImage(mockup, sx, sy, sw, sh, ox, oy, ow, oh); } catch (e) {}
    }
  }

  /* Y encima, lo que ha puesto el cliente.
     El filtro CSS de gravure vive en el elemento, no en los pixeles del
     canvas, asi que el 3D no lo veria: se repite aqui al pintar. Se aplica
     SOLO al diseno del cliente, no al estampado de fondo. */
  c.filter = (etat.finition === 'gravure') ? FILTRE_GRAVURE : 'none';
  c.drawImage(src, z.x * k, z.y * k, z.w * k, z.h * k, 0, 0, dest.width, dest.height);
  c.filter = 'none';

  if (restaurar.length) {
    restaurar.forEach(([o, b, ct]) => { o.hasBorders = b; o.hasControls = ct; });
    canvas.renderAll();
  }
}

let _3dListo = false;
function maj3D(recargar) {
  const caja = $('#apercu3d');
  if (!caja) return;
  const quiere = produitAvec3D();
  /* Sin WebGL no se anuncia un 3D que no va a existir: el cliente se queda
     con el editor plano de siempre, que es completamente utilizable. */
  const puede = quiere && typeof TASSE3D !== 'undefined' && TASSE3D.disponible();
  caja.hidden = !puede;
  document.body.classList.toggle('avec-3d', puede);

  if (quiere && !puede) console.info('[EDISAMP] WebGL no disponible: preview 2D');
  if (!puede) { if (_3dListo) TASSE3D.activer(false); return; }

  if (!_3dListo) {
    /* Three.js se baja AQUI, no al cargar la pagina: quien compra una
       camiseta no debe pagar 600 ko por un 3D que no vera. El editor plano ya
       esta usable mientras tanto. */
    TASSE3D.chargerThree().then(ok => {
      if (!ok) { caja.hidden = true; document.body.classList.remove('avec-3d'); return; }
      _3dListo = TASSE3D.init({ conteneur: caja, peindre: peindreWrap });
      if (!_3dListo) { caja.hidden = true; document.body.classList.remove('avec-3d'); return; }
      TASSE3D.activer(true); TASSE3D.majTexture(true);
    });
    return;
  }
  TASSE3D.activer(true);
  if (recargar) TASSE3D.redimensionner();
  TASSE3D.majTexture(true);
}

/* Cada cambio del diseno refresca la textura. TASSE3D ya trae su propio
   debounce, asi que llamar de mas no cuesta. */
function rafraichir3D() {
  if (_3dListo && produitAvec3D()) TASSE3D.majTexture();
}

/* expuesto al segundo bloque */
/* Los originales a resolucion completa viven en el bloque 1, y el bloque 2 es
   quien los guarda al subir una foto. Sin exponerlos, `ORIGINALES` y
   `_idOriginal` eran ReferenceError ahi dentro y CUALQUIER subida de foto
   moria antes del canvas.add(). */
function nouvelIdOriginal() { return 'o' + (++_idOriginal); }

const unite = () => _unite;
const setUnite = u => { _unite = u;
  try { localStorage.setItem(CLE_UNITE, u); } catch (e) {} };

window.__studio = { etat, canvas, $, $$, PROPS, zoneActive, vueActive, zonePar,
  unite, setUnite, fmtDim,
  plateau, ORIGINALES, nouvelIdOriginal, esMobile,
  estTexte, clipPour, defauts, majAlertes, apresChangement, sauvegarder,
  retomarCreacion, ofrecerRetomar, instantanea, miniatura, nbElements,
  creerVariante,
  pousserHistorique, restaurer, majVue, construireVues, changerVue, choisirZone,
  confirmer, fermerConfirmer, executerConfirmation, appliquerZoom, deplacerPlateau, majTexture, majEchelleControles, dessinerGuides,
  annuler, refaire, restaurerHistorique, majBoutonsHistorique, reappliquer, dpiDe,
  maj3D, rafraichir3D, peindreWrap, produitAvec3D, rectMockup1024,
  construireTailles, appliquerTaille, construireFinitions, appliquerFinition,
  tailles, finitions,
  FILTRE_GRAVURE };
})();

/* ============================================================================
   STUDIO — panneaux, produits, panier
   ========================================================================== */
(function () {
'use strict';

const S = window.__studio;
const { etat, canvas, $, $$, PROPS } = S;

/* ============================ RED DE SEGURIDAD ===========================
   Este archivo son DOS IIFE. El segundo solo ve al primero a traves de `S`, y
   usar un nombre del primero sin ese prefijo es un ReferenceError que casi
   siempre ocurre DENTRO de un callback — de Fabric, de una promesa, de un
   listener — donde muere en silencio y deja una funcion a medias sin que nada
   se rompa a la vista.

   Ha pasado cuatro veces: zonePar, _idOriginal, esMobile y zoneActive. Cada
   una costo una sesion de depuracion porque el sintoma estaba lejos de la
   causa. Asi que en vez de confiar en acordarse: al cargar, se comprueba que
   cada nombre que el puente exporta NO exista tambien como global suelto, y
   se avisa en consola. Cuesta un milisegundo y no cambia nada en produccion.
   ========================================================================= */
(function verifierPont() {
  const sueltos = Object.keys(S).filter(k => {
    try { return eval('typeof ' + k) !== 'undefined'; } catch (e) { return false; }
  });
  if (sueltos.length) {
    console.warn('[EDISAMP] Nombres del puente accesibles tambien como global — '
      + 'pueden enmascarar un olvido de « S. » :', sueltos.join(', '));
  }
})();

/* =============================== E1 · PRODUITS =========================== */
function fermerDemarrage() {
  const d = $('#demarrage'); if (!d || d.hidden) return;
  d.classList.add('demarrage--part');
  setTimeout(() => { d.hidden = true; }, 380);
}

/* DE DONDE SALE LA CONFIG, POR ORDEN DE PRIORIDAD.
   Esto fallaba en produccion de la peor manera posible: se hacia
   `fetch('config-personnalisation.json').json()` a secas. En la tienda ese
   fichero NO EXISTE — Shopify devuelve el HTML de su 404 —, `.json()` lanzaba,
   `demarrer()` moria entero y el cliente se quedaba con « Erreur de
   chargement » y nada mas. Un fichero que falta no puede tumbar el Studio.

   1. `window.EDISAMP_SHOPIFY.config` — lo inyecta el tema, generado al
      desplegar con lo que hay en el admin. Es la via de PRODUCCION.
   2. El localStorage del admin — solo existe en el Mac de Franklin.
   3. `config-personnalisation.json` — el fichero del repo, para el desarrollo
      local y como ultimo recurso. */
async function chargerConfig() {
  const inj = (window.EDISAMP_SHOPIFY || {}).config;
  if (inj && inj.produits) {
    console.info('[EDISAMP] config inyectée par le thème');
    return inj;
  }
  const local = BOUTIQUE.configLocaleAdmin();
  if (local) { console.info('[EDISAMP] config del admin (localStorage) en uso'); return local; }
  try {
    const r = await fetch('config-personnalisation.json', { cache:'no-store' });
    if (!r.ok) throw new Error('HTTP ' + r.status);
    return await r.json();
  } catch (e) {
    console.error('[EDISAMP] aucune configuration disponible:', e.message);
    return null;
  }
}

async function demarrer() {
  const config = await chargerConfig();
  if (!config) {
    $('#nom-produit').textContent = 'Configuration indisponible';
    $('#produits-etat').textContent =
      'La configuration des produits n\u2019a pas pu être chargée. '
      + 'Réessayez dans un instant, ou revenez à la boutique.';
    $('#modale-produits').hidden = false;
    fermerDemarrage();
    return;
  }
  etat.config = config;

  let bruts = [];
  try { bruts = await BOUTIQUE.chargerCatalogue(config, false); }
  catch (e) { console.error('[EDISAMP] catalogue:', e); }
  etat.catalogue = BOUTIQUE.fusionner(bruts, config);

  const dispo = produitsVisibles();
  const demande = new URLSearchParams(location.search).get('produit');
  const choisi = demande
    ? dispo.find(p => p.handle === demande)      // pedido: ése o ninguno
    : dispo[0];

  /* PEDIR UN PRODUCTO Y RECIBIR OTRO. Esto era `... || dispo[0]`: si el
     cliente pulsaba « Personalizar » en el llavero y el llavero no estaba
     publicado, el Studio abría EL PRIMERO de la lista — una camiseta que no
     tenía nada que ver con lo que acababa de mirar. Franklin: « se abre una
     camiseta, nada que ver ». Un producto que no está no se sustituye por
     otro: se dice. */
  if (demande && !choisi) {
    /* ANTES DE DECIR QUE NO, IR A BUSCARLO. La lista de aquí sale de
       `assets/edisamp-config.js`, que es una foto del admin hecha al
       desplegar; el botón « Personnaliser » de la ficha, en cambio, sale del
       metafield del producto, que ya está en la tienda. Entre lo uno y lo otro
       pueden pasar días, y entonces el cliente pulsa un botón que existe hacia
       un Studio que no conoce el producto. Se pregunta a la tienda por la
       misma config que encendió el botón. */
    const rescatado = await BOUTIQUE.rescaterProduit(demande);
    if (rescatado && !nomSeulement(rescatado)) {
      etat.config.produits = etat.config.produits || {};
      etat.config.produits[demande] = rescatado.perso;
      etat.catalogue = etat.catalogue
        .filter(p => p.handle !== demande).concat([rescatado]);
      console.info('[EDISAMP] producto recuperado del metafield:', demande);
      chargerProduit(rescatado).catch(e => console.warn('[EDISAMP]', e));
      ocultarElectorDeProducto();
      return;
    }
    if (rescatado) {                       // nom_seulement: lo explica y vuelve
      chargerProduit(rescatado).catch(e => console.warn('[EDISAMP]', e));
      return;
    }

    const enBorrador = BOUTIQUE.configures(etat.catalogue)
      .find(p => p.handle === demande);
    $('#nom-produit').textContent = enBorrador ? enBorrador.titre : 'Producto no disponible';
    $('#modale-produits').hidden = false;
    /* La lista PRIMERO: al montarse reescribe `#produits-etat` con su propio
       recuento, y se comía la explicación. */
    construireListeProduits();
    $('#produits-etat').textContent = enBorrador
      ? 'Este producto todavía no está publicado para personalizar. '
        + 'Publícalo en el admin, o ábrelo tú añadiendo « &brouillon=1 » a la dirección.'
      : 'Este producto todavía no está preparado para personalizar. '
        + 'Mientras tanto, puedes elegir uno de éstos.';
    fermerDemarrage();
    return;
  }

  if (!choisi) {
    $('#nom-produit').textContent = 'Aucun produit configuré';
    $('#produits-etat').textContent =
      'Aucun produit n\'est encore configuré. Ouvrez admin.html pour en configurer un.';
    $('#modale-produits').hidden = false;
    fermerDemarrage();
    return;
  }
  chargerProduit(choisi).catch(e => console.warn('[EDISAMP]', e));
  /* LA LISTA SÓLO SI NO SE PIDIÓ NADA. Franklin: « si aplasto personalizar en
     el llavero, quiero llegar al llavero y ya está; esa parte de elección no
     tiene que estar ahí ». Viniendo de una ficha concreta, elegir producto ya
     está hecho. */
  if (!demande) construireListeProduits();
  else ocultarElectorDeProducto();
}

/* El cliente solo ve productos PUBLICADOS. Configurar no es publicar: un
   producto a medio ajustar no debe llegar a la tienda. Con ?brouillon=1
   Franklin puede probar los suyos antes de publicarlos. */
function produitsVisibles() {
  const verBorradores = new URLSearchParams(location.search).has('brouillon');
  return verBorradores
    ? BOUTIQUE.configures(etat.catalogue)
    : BOUTIQUE.publies(etat.catalogue);
}

/* Un producto « nom_seulement » no tiene nada que editar aqui: su nombre va
   integrado en el collage y lo compone Franklin a mano. La ficha de la tienda
   no ofrece el boton, pero un enlace directo o un marcador viejo si pueden
   llegar — y ensenarle al cliente un editor que no le corresponde es peor que
   un error: le deja creer que puede mover cosas que no se van a mover. */
function nomSeulement(p) {
  return ((p && p.perso) || {}).modePersonnalisation === 'nom_seulement';
}

async function chargerProduit(p) {
  if (nomSeulement(p)) {
    const ns = (p.perso.nomSeulement || {});
    const cuerpo = document.querySelector('#studio') || document.body;
    cuerpo.innerHTML = `<div style="max-width:520px;margin:12vh auto;padding:0 20px;
        text-align:center;font-family:inherit;color:#222D52">
      <h2 style="font-family:'Bodoni Moda',serif;margin:0 0 10px">${p.titre || ''}</h2>
      <p style="line-height:1.55">Ce produit se personnalise directement sur sa
      fiche : il suffit d\u2019indiquer le prénom souhaité
      ${ns.limite ? `(${ns.limite} caractères maximum)` : ''}. Le design est
      composé par nos soins.</p>
      <p><a href="/products/${p.handle}" style="display:inline-block;margin-top:14px;
        padding:13px 24px;border-radius:14px;background:#D2B68A;color:#fff;
        text-decoration:none;font-weight:600">Retour à la fiche produit</a></p>
    </div>`;
    /* Sin esto la pantalla de carga se quedaba encima del mensaje hasta que
       saltaba el temporizador de 12 s. */
    fermerDemarrage();
    return;
  }
  etat.produit = p;

  /* ── NADA DE MEDIDAS FALSAS ────────────────────────────────────────────
     Si una vista llega con la calibración de plantilla (454|456 px / 58 cm,
     que son los de una camiseta), sus centímetros no los midió nadie: son el
     resultado de aplicar la escala de otra prenda. Se olvidan aquí, en la
     puerta, para que TODO lo de abajo —la lista de zonas, el aviso de DPI,
     las guías, el archivo de impresión— trabaje con « no lo sé » en vez de
     con un número inventado. La regla está en formes.js, compartida con el
     admin (ver `calibracionHeredada`). */
  if (typeof olvidarCalibracionHeredada === 'function') {
    (p.perso.vues || []).forEach(v => {
      if (olvidarCalibracionHeredada(v))
        console.info('[EDISAMP] vista «' + v.id + '» sin medir: se ignora la calibración heredada');
    });
  }

  etat.zones = {}; etat.designs = {}; etat.fond = {};
  /* El cliente entra en la zona donde tiene algo que hacer: si hay una de
     « saisie », esa. Si no, la primera que no sea decorado. */
  (p.perso.vues || []).forEach(v => {
    const zs = v.zones || [];
    const util = zs.find(z => z.role === 'saisie')
              || zs.find(z => z.role !== 'decor') || zs[0];
    etat.zones[v.id] = (util || {}).id;
  });
  etat.vue = (p.perso.vues[0] || {}).id;

  S.restaurer();

  /* Retomar una creacion guardada. Dos caminos, y en este orden:
       ?reprendre=<designId>  el cliente ha pulsado « Continuer ma creation »
       sin parametro          se mira si hay una de ESTE producto y se ofrece

     Se hace DESPUES de restaurar la sesion de pestana: si alguien recarga en
     mitad de un trabajo, lo que manda es lo que tenia delante, no una version
     guardada hace tres dias. */
  const _pedida = new URLSearchParams(location.search).get('reprendre');
  if (_pedida) {
    const ok = await S.retomarCreacion(_pedida);
    if (!ok) console.info('[EDISAMP] la creacion pedida ya no existe');
  } else if (typeof CREATION !== 'undefined' && CREATION.disponible()) {
    const previa = CREATION.ultima(p.handle);
    // Sin nada dibujado todavia en esta pestana: entonces si tiene sentido
    // ofrecer lo de la ultima vez. Si ya hay trabajo, no se interrumpe.
    const vacio = !Object.values(etat.designs || {})
      .some(d => ((d || {}).objects || []).length);
    if (previa && vacio) S.ofrecerRetomar(previa);
  }

  /* La sesion existe desde que hay producto, no desde el primer guardado: si
     no, el evento de apertura viaja sin identificador y no se puede atar a
     nada de lo que venga despues. */
  if (typeof CREATION !== 'undefined' && !CREATION.idActual()) CREATION.comenzar();

  /* La shell de creación: volver, estado de guardado y la bolsa. Se monta una
     sola vez, con el producto ya cargado para que « ← » sepa a dónde vuelve. */
  if (typeof COQUILLE !== 'undefined' && !window.__coquilleMontee) {
    window.__coquilleMontee = true;
    COQUILLE.monter({
      guardarAhora: () => {
        if (typeof CREATION === 'undefined' || !etat.produit) return null;
        etat.designs[etat.vue] = canvas.toJSON(PROPS);
        return CREATION.guardarAhora({ ...S.instantanea(), preview: null });
      },
      alSac: () => { location.href = '/cart'; },
    });
    COQUILLE.mostrarSac(0);
  }

  if (typeof EVENEMENTS !== 'undefined') {
    EVENEMENTS.emitir(EVENEMENTS.TIPOS.DESIGN_STARTED, {
      designId: (typeof CREATION !== 'undefined') ? CREATION.idActual() : null,
      productHandle: p.handle,
    });
    EVENEMENTS.vigilar({
      designId: (typeof CREATION !== 'undefined') ? CREATION.idActual() : null,
      productHandle: p.handle,
    });
  }

  /* Si la sesion no traia nada para una vista, se siembra con el modelo por
     defecto del producto. Se hace DESPUES de restaurar para no pisar el
     trabajo del cliente al recargar la pagina. */
  if (typeof MODELES !== 'undefined') {
    (p.perso.vues || []).forEach(v => {
      const yaHay = ((etat.designs[v.id] || {}).objects || []).length;
      if (yaHay) return;
      const semilla = MODELES.objetosDeVue(p, v.id);
      if (semilla) etat.designs[v.id] = semilla;
    });
  }

  /* Modo simple: el cliente solo toca lo que Franklin dejo abierto, asi que
     « + Ajouter un texte » no pinta nada — anadir elementos libres es
     justamente lo que el modo simple prohibe. */
  const simple = typeof MODELES !== 'undefined' && MODELES.esSimple(p);
  etat.taille = p.perso.tailleDefaut
    || Object.keys(p.perso.anchoPorTalla || { M:1 })[0];
  etat.finition = p.perso.finitionDefaut || (p.perso.finitions || ['impression'])[0];
  document.body.classList.toggle('gravure', etat.finition === 'gravure');
  document.body.classList.toggle('mode-simple', simple);

  /* Estandar de los porte-cles (PRODUITS.md): diseno base fijo y SOLO texto.
     Ahi las pestanas Photos, Fond y Formes no llevan a ningun sitio util y
     solo estorban, en movil sobre todo. Se ocultan cuando el modelo no tiene
     ningun hueco de foto; la medaille, que si lo tiene, las conserva. */
  document.body.classList.toggle('mode-simple-textes', simple && !modeleAvecPhoto(p));

  construireModeles(p);
  $('#nom-produit').textContent = p.titre;
  /* NO escribir el precio a pelo aqui: majBoutonsPanier() es la unica
     autoridad de este indicador, y esta linea le pisaba el subtotal cada vez
     que se recargaba el producto — cambiar de modelo o de vista borraba la
     suma y volvia a 4.90 con tres piezas dentro. */
  majBoutonsPanier();
  document.title = `${p.titre} — EDISAMP Studio`;
  $('#onglet-fond').hidden = !p.perso.fondAutorise;
  const ongletPhotos = $('.onglet[data-panneau="photos"]');
  if (ongletPhotos) ongletPhotos.hidden = !photosPermises();
  if (!photosPermises() && $('#panneau-photos') && !$('#panneau-photos').hidden) fermerPanneaux();

  etat.hPause = true;
  canvas.loadFromJSON(etat.designs[etat.vue] || { objects: [] }, () => {
    S.reappliquer(); canvas.requestRenderAll();
    etat.hPause = false;
    etat.historique = []; etat.hIndex = -1; S.pousserHistorique();
    S.majVue(); S.construireVues(); S.majAlertes(); majPanneaux();
    construirePolices(); construireCouleurs();
    S.maj3D(true); S.construireTailles(); S.construireFinitions(); majOngletQR();
    /* El Studio ya es usable: fuera la pantalla de carga. Se quita AQUI y no
       en el load de la pagina porque lo que tarda no es el HTML, es leer el
       catalogo y montar el producto — que es justo lo que el cliente estaba
       esperando mirando una pantalla en blanco. */
    fermerDemarrage();
    /* Con una sola herramienta disponible, obligar a descubrir la pestana es
       un paso de mas: se abre el panel de texto ya. */
    if (document.body.classList.contains('mode-simple-textes')) {
      /* « Ajoutez un texte ou sélectionnez-en un » miente en modo simple: no
         se puede anadir nada. */
      const indice = $('#texte-indice');
      if (indice) indice.textContent =
        'Touchez un texte sur le produit pour le modifier.';
      /* Abrirlo solo en escritorio, donde el panel FLOTA al lado del canvas.
         En movil es una bottom-sheet que tapa el producto nada mas entrar, y
         encima sobra: tocar el hueco de texto ya abre el panel con el foco en
         el contenido (ver remplirEmplacementTexte). */
      if (matchMedia('(min-width: 900px)').matches) ouvrirPanneau('texte');
    }
  });
}

/* ¿El modelo del producto tiene algun hueco de FOTO? Decide si el cliente
   necesita la pestana Photos en modo simple. */
function modeleAvecPhoto(p) {
  const m = p.perso && p.perso.modeleDefaut;
  if (!m || !Array.isArray(m.vues)) return false;
  return m.vues.some(v => (v.objects || []).some(
    o => o.emplacement && o.emplacement.media !== 'texte'));
}

/* ----------------------------------------------------------------------------
   ELEGIR MODELO — una variante con su foto
   ----------------------------------------------------------------------------
   Franklin: « para las almohadas tenemos cinco tipos… si el cliente elige el
   número 2 tiene que llegar con lo que ya puse en el número 2 ». En su Shopify
   eso es UN producto con la opción « Modele » y cuatro variantes, cada una con
   su propia foto. Aquí se eligen por la imagen, no por el número, y la que
   esté elegida es la que se manda al carrito.
   -------------------------------------------------------------------------- */
function construireModeles(p) {
  const bloc = $('#bloc-modele'), cont = $('#modeles');
  if (!bloc || !cont) return;
  const vs = (p.variantes || []).filter(v => v.disponible !== false);
  /* SÓLO CUANDO LA VARIANTE ES UN DISEÑO, NO UNA TALLA. En la camiseta las
     variantes son S/M/L y ya tienen su propio selector: repetirlas aquí
     sería pedir dos veces lo mismo. Se mira cómo llamó Franklin a la opción
     en Shopify — en los cojines, « Modele ». */
  const esDiseno = (p.optionsNoms || [])
    .some(n => /mod[eè]le|modelo|design|motif|style|estampado/i.test(String(n)));
  /* Con una sola variante no hay nada que elegir: el bloque no aparece. */
  if (!esDiseno || vs.length < 2) { bloc.hidden = true; etat.variante = null; return; }
  bloc.hidden = false;
  cont.innerHTML = '';
  if (!etat.variante || !vs.some(v => v.id === etat.variante)) {
    etat.variante = vs[0].id;
    /* Con vistas por modelo, la vista de partida es la del modelo de partida:
       si no, el cliente ve el modelo 1 marcado y la foto de otro. */
    const p0 = vuePourModele(p, etat.variante);
    if (p0 && p0.id !== etat.vue) S.changerVue(p0.id);
  }
  vs.forEach((v, i) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'modele' + (v.id === etat.variante ? ' modele--on' : '');
    b.title = v.titre || ('Modèle ' + (i + 1));
    b.setAttribute('aria-pressed', v.id === etat.variante ? 'true' : 'false');
    b.innerHTML = (v.image ? `<img src="${v.image}" alt="" loading="lazy">`
                           : '<span class="vignette__vide" aria-hidden="true"></span>')
      + `<span class="modele__n">${v.titre || (i + 1)}</span>`;
    b.onclick = () => choisirModele(v);
    cont.appendChild(b);
  });
}

/* La vista atada a un modelo, si la hay. Franklin ata cada vista a su variante
   desde el admin (`vue.varianteId`) porque cada cojín lleva un estampado de
   base distinto: la zona imprimible no cae en el mismo sitio en los cuatro. */
function vuePourModele(p, idVariante) {
  const vs = (p && p.perso && p.perso.vues) || [];
  return vs.find(v => v.varianteId != null
                   && String(v.varianteId) === String(idVariante)) || null;
}

function choisirModele(v) {
  etat.variante = v.id;

  /* SI ESE MODELO TIENE SU PROPIA VISTA, SE VA A ELLA — con su foto, su
     calibración y sus zonas. Es lo que pidió Franklin: « cada foto va a tener
     su propia zona, para que el cliente pueda elegir qué modelo quiere
     personalizar, porque cada uno lleva un estampado de base ». */
  const propia = vuePourModele(etat.produit, v.id);
  if (propia) {
    if (propia.id !== etat.vue) S.changerVue(propia.id);
    construireModeles(etat.produit);
    return;
  }

  /* Y si no la tiene, lo de siempre: se cambia la foto y se conservan las
     zonas. Los productos que ya funcionaban siguen igual. */
  if (v.image) {
    const vue = (etat.produit.perso.vues || []).find(x => x.id === etat.vue);
    if (vue) { vue.mockup = v.image; S.majVue(); }
  }
  construireModeles(etat.produit);
}

/* Viniendo de una ficha concreta, el selector de producto sobra: se quita el
   botón que lo abre y no se monta la lista. */
function ocultarElectorDeProducto() {
  const b = $('#btn-produit');
  if (b) b.hidden = true;
  const m = $('#modale-produits');
  if (m) m.hidden = true;
}

function construireListeProduits() {
  const c = $('#liste-produits'); c.innerHTML = '';
  const dispo = produitsVisibles();
  dispo.forEach(p => {
    const b = document.createElement('button');
    b.className = 'produit';
    /* Sin `|| ''`: una cadena vacía en src resuelve a la URL del documento
       y pinta el icono de rotura. `media-sure.js` lo recogería igual, pero
       la causa se arregla donde está. */
    b.innerHTML = `${p.image ? `<img src="${p.image}" alt="" loading="lazy">`
                             : '<span class="vignette__vide" aria-hidden="true"></span>'}
      <div class="produit__txt"><div class="produit__nom">${p.titre}</div>
      <div class="produit__prix">${p.prix.toFixed(2)} ${p.devise}</div></div>`;
    b.onclick = () => {
      $('#modale-produits').hidden = true;
      history.replaceState(null, '', '?produit=' + p.handle);
      chargerProduit(p).catch(e => console.warn('[EDISAMP]', e));
    };
    c.appendChild(b);
  });
  $('#produits-etat').textContent = dispo.length
    ? `${dispo.length} produit(s) disponible(s)`
    : 'Aucun produit configuré.';
}

/* ================================ E4 · TEXTE ============================= */
/* La caja debe nacer DENTRO de la zone de securite (4% por lado = 92%),
   si no el aviso amarillo "proche du bord" salta con cada texto nuevo y
   deja de significar nada. 0.88 le deja aire. */
const MARGE_TEXTE = 0.88;
const largeurTexte = z => Math.round(z.w * MARGE_TEXTE);
let genreActif = 'tous', rechercheTexte = '';

function policesDuProduit() {
  const ids = (etat.produit.perso.polices || []).length
    ? etat.produit.perso.polices : POLICES.map(p => p.id);
  return POLICES.filter(p => ids.includes(p.id));
}

function construireGenres() {
  const c = $('#txt-genres'); c.innerHTML = '';
  GENRES.forEach(g => {
    const b = document.createElement('button');
    b.className = 'genre'; b.textContent = g.nom;
    b.setAttribute('aria-pressed', g.id === genreActif);
    b.onclick = () => { genreActif = g.id; construireGenres(); construirePolices(); };
    c.appendChild(b);
  });
}

/* Lazy: la fuente se descarga cuando su ficha entra en pantalla, nunca las 30
   de golpe. Sin esto son ~1 MB y varios segundos en movil. */
const observador = new IntersectionObserver(entradas => {
  entradas.forEach(e => {
    if (!e.isIntersecting) return;
    const fam = e.target.dataset.famille;
    chargerPolice(fam).then(() => {
      e.target.querySelector('.police__apercu').style.fontFamily = `"${fam}", sans-serif`;
    });
    observador.unobserve(e.target);
  });
}, { root: null, rootMargin: '120px' });

function construirePolices() {
  const c = $('#txt-polices'); if (!c) return;
  c.innerHTML = '';
  const o = canvas.getActiveObject();
  const actuelle = o && S.estTexte(o) ? o.policeId : null;

  policesDuProduit()
    .filter(p => genreActif === 'tous' || p.genre === genreActif || p.aussi === genreActif)
    .filter(p => !rechercheTexte || p.nom.toLowerCase().includes(rechercheTexte))
    .forEach(p => {
      const b = document.createElement('button');
      b.className = 'police'; b.dataset.famille = p.famille;
      b.setAttribute('aria-pressed', p.id === actuelle);
      b.innerHTML = `<span class="police__apercu">Aa Emma</span>
                     <span class="police__nom">${p.nom}</span>`;
      b.onclick = () => chargerPolice(p.famille).then(() => {
        appliquerTexte({ fontFamily: p.famille }); 
        const a = canvas.getActiveObject(); if (a) a.policeId = p.id;
        canvas.requestRenderAll(); construirePolices();
      });
      c.appendChild(b);
      observador.observe(b);
    });
  if (!c.children.length) c.innerHTML = '<p class="aide">Aucune police trouvée.</p>';
  /* La lista se reconstruye al elegir una tipografia, y eso borraba las marcas
     de « bajo llave » puestas antes: los botones volvian a parecer pulsables
     aunque no hicieran nada. */
  majControlesVerrouilles(canvas.getActiveObject());
}

function construireCouleurs() {
  const pal = etat.produit.perso.couleurs || ['#FFFFFF','#111111','#D2B68A'];
  const remplir = (sel, onPick) => {
    const c = $(sel); if (!c) return;
    c.innerHTML = '';
    pal.forEach(hex => {
      const b = document.createElement('button');
      b.className = 'pastille'; b.style.background = hex;
      b.dataset.hex = hex; b.title = hex;
      b.onclick = () => onPick(hex);
      c.appendChild(b);
    });
    const libre = document.createElement('input');
    libre.type = 'color'; libre.className = 'pastille';
    libre.style.padding = '0'; libre.title = 'Couleur libre';
    libre.oninput = () => onPick(libre.value);
    c.appendChild(libre);
  };
  remplir('#txt-couleurs', hex => appliquerTexte({ fill: hex }));
  remplir('#fond-couleurs', hex => appliquerFond(hex));
}

function ajouterTexte() {
  if (!puedePoner('texte')) { avisarNoPermitido('texte'); return; }
  const z = S.zoneActive();
  const pol = policesDuProduit()[0];
  chargerPolice(pol.famille).then(() => {
    const t = new fabric.Textbox('VOTRE TEXTE', {
      left: z.x + z.w/2, top: z.y + z.h/2, originX:'center', originY:'center',
      width: largeurTexte(z), fontFamily: pol.famille, fill: (etat.produit.perso.couleurs||['#FFFFFF'])[0],
      fontSize: Math.round(z.h * 0.12), textAlign:'center', splitByGrapheme:false,
      lockScalingFlip:true,
    });
    t.setControlsVisibility({ tl:false,tr:false,bl:false,br:false,mt:false,mb:false });
    t.zoneId = z.id; t.policeId = pol.id; t.clipPath = S.clipPour(z);
    canvas.add(t); canvas.setActiveObject(t);
    S.apresChangement(); majPanneaux();
  });
}

/** Apaga los controles del panel Texte que este objeto tiene bajo llave. */
function majControlesVerrouilles(o) {
  if (!o) return;
  const puede = p => (typeof MODELES === 'undefined' || !MODELES.peutModifier)
    ? true : MODELES.peutModifier(o, p, etat.produit);
  const bloque = (sel, on) => $$(sel).forEach(n => {
    n.toggleAttribute('disabled', !on);
    n.classList.toggle('verrouille', !on);
    if (!on && !n.title) n.title = 'Verrouillé par le modèle de ce produit.';
  });
  bloque('#txt-couleurs button, #txt-couleurs input', puede('fill'));
  bloque('.police', puede('fontFamily'));
  const c = $('#txt-contenu');
  if (c) {
    const ok = puede('text');
    c.toggleAttribute('readonly', !ok);
    c.classList.toggle('verrouille', !ok);
  }
}

function appliquerTexte(props) {
  const o = canvas.getActiveObject();
  if (!S.estTexte(o)) return;

  /* LO QUE EL ADMIN CIERRA, AQUI SE RESPETA.
     -------------------------------------------------------------------------
     Los candados de posicion los aplicaba Fabric y funcionaban. Los de color,
     tipografia y contenido no pasan por Fabric: se aplican desde estos
     paneles, que no preguntaban nada. Con « couleur : non » declarado en el
     admin, el cliente cambiaba el color igual — el admin prometia una cosa y
     la tienda hacia otra. */
  let aplicar = props;
  if (typeof MODELES !== 'undefined' && MODELES.filtrerProps) {
    const r = MODELES.filtrerProps(o, props, etat.produit);
    aplicar = r.props;
    if (r.bloquees && !Object.keys(aplicar).length) return;
  }
  if (!Object.keys(aplicar).length) return;

  o.set(aplicar); o.setCoords();
  S.apresChangement(); majPanneauTexte(o);
}

function majPanneauTexte(o) {
  /* El asistente se repinta con el panel: si se acaba de añadir un texto, el
     primer paso es escribirlo. */
  if (typeof ASISTENTE !== 'undefined' && !$('#panneau-texte').hidden) {
    setTimeout(() => ASISTENTE.activar('#panneau-texte'), 0);
  }
  /* Un boton que no hace nada es peor que un boton que no esta: se marca lo
     que este producto no deja tocar, en vez de dejar al cliente pulsando. */
  majControlesVerrouilles(o);
  $('#txt-contenu').value = o.text || '';
  $('#txt-taille').value = Math.round(o.fontSize);
  $('#txt-taille-val').textContent = Math.round(o.fontSize) + ' px';
  $('#txt-espacement').value = o.charSpacing || 0;
  $('#txt-espacement-val').textContent = (o.charSpacing || 0);
  $('#txt-contour').value = o.strokeWidth || 0;
  $('#txt-contour-val').textContent = (o.strokeWidth || 0);
  $('#txt-contour-couleur').value = o.stroke || '#000000';
  $('#txt-gras').classList.toggle('btn--actif', o.fontWeight === 'bold');
  $('#txt-italique').classList.toggle('btn--actif', o.fontStyle === 'italic');
  ['gauche','centre','droite'].forEach((a,i) => {
    $('#txt-' + a).classList.toggle('btn--actif', o.textAlign === ['left','center','right'][i]);
  });
}

/* ============================================================================
   E5 · PHOTOS — ARQUITECTURA ACTUAL, Y LO QUE NO ES
   ----------------------------------------------------------------------------
   ESTO SIGUE SIENDO UN MODELO DE SUSTITUCION, no un pipeline no destructivo.
   Se deja escrito porque quien venga detras merece saberlo antes de anadir la
   siguiente herramienta.

   COMO FUNCIONA HOY. Cada foto vive en tres sitios, y cada uno tiene un papel:

     o.sourceOriginale   la foto tal como la subio el cliente, a la resolucion
                         de impresion. INMUTABLE. Es a donde vuelve
                         « Restaurer le fond original ».

     ORIGINALES[id]      el artwork PREPARADO: la foto con lo que se le haya
                         hecho. De aqui sale el fichero de impresion a 300 DPI
                         y de aqui parte « Ameliorer la qualite ».

     o._element          la copia de trabajo del lienzo, acotada a MAX_COTE
                         para que el canvas vaya fluido. NO es autoridad de
                         nada: es lo que se ve.

   Las dos resoluciones son deliberadas: MAX_COTE (1600) para la pantalla y
   MAX_ORIGINAL (3000) para el papel. Toda operacion que cambie la imagen tiene
   que tocar LAS DOS, cada una a su tamano. Olvidarlo fue el origen de los tres
   fallos de esta ronda.

   POR QUE ESTO NO ES UN PIPELINE. No hay lista de operaciones ni receta: cada
   herramienta calcula un resultado y SUSTITUYE lo que habia. Funciona porque
   ahora mismo solo hay dos herramientas derivadas —detourage y mejora— y su
   orden esta fijado: primero se quita el fondo, despues se mejora lo que
   quedo. Con dos piezas y un orden, sustituir basta.

   CUANDO DEJARA DE BASTAR. En cuanto entre una tercera operacion derivada
   —recorte destructivo, knockout de color, cualquier filtro que no sea
   reversible por si mismo— hara falta lo que Product Studio ya tiene:

       ORIGINAL inmutable  +  lista de operaciones  ->  resultado derivado

   Sin eso, desactivar la segunda de tres operaciones obliga a rehacer la
   tercera desde un estado que ya no existe, y ahi es donde reaparecen
   exactamente los fallos que se acaban de corregir: una herramienta leyendo
   una version que otra ya habia reemplazado.

   No se hace ahora porque con dos operaciones seria complejidad sin beneficio.
   Se hara el dia que entre la tercera.
   ========================================================================== */

/* ================================ E5 · PHOTOS ============================ */
const MAX_COTE = 1600;
const CLE_RECENTES = 'edisamp-photos-recentes';

/* Tope del ORIGINAL que se conserva para el archivo de impresion. Una foto de
   iPhone son 4032 x 3024, y guardarla en base64 son ~11 Mo de cadena viva en
   memoria. A 3000 px de lado siguen saliendo 300 DPI en una impresion de 25
   cm, y Safari de iOS deja de matar la pestana. */
const MAX_ORIGINAL = 3000;

/* EL TOPE LO MANDA LO QUE SE VA A IMPRIMIR, NO UN NÚMERO REDONDO.
   3000 px dan 300 DPI hasta 25,4 cm y ya está — pero una camiseta imprime a
   30 cm (3 543 px) y un cojín a 58 (6 850). O sea que en los productos
   GRANDES la foto del cliente se recortaba por debajo de lo necesario antes
   de que nadie pudiera hacer nada, y el archivo de producción salía con menos
   píxeles reales de los que el papel pedía. En un porte-clés de 5 cm, en
   cambio, 3000 px son cinco veces más de lo que hace falta.

   Se calcula: el lado más grande que este producto imprime, a su DPI. Con dos
   topes:
     · SUELO 3000 — nunca se empeora lo que ya había.
     · TECHO 6500 en escritorio, 3000 en un teléfono. El límite del móvil no
       es capricho: una foto de iPhone son 4032 × 3024 y en base64 ~11 Mo de
       cadena viva; Safari de iOS mata la pestaña. Ahí más píxeles no es más
       calidad, es un cliente que pierde el diseño.
   Un 15 % de margen porque el cliente casi siempre recorta algo. */
/* MÓVIL DE VERDAD, NO VENTANA PEQUEÑA.
   `esMobile()` decide por el lado menor de la ventana (< 820 px) y para la
   INTERFAZ está bien: con esa altura el panel tiene que ser una bottom-sheet
   venga de donde venga. Pero para decidir cuánta memoria aguanta el aparato
   es el criterio equivocado, y lo vi midiendo: el MacBook con la ventana a
   1475 × 755 daba `esMobile() === true`, así que se le capaba la foto a
   3000 px como a un iPhone. Un portátil con la ventana no maximizada perdía
   calidad de impresión sin que nada lo dijera.
   Aquí se pregunta por el APARATO: un iPhone o un Android lo son siempre, y
   `deviceMemory` bajo delata un equipo justo de RAM aunque tenga pantalla
   grande. Chrome y Edge dan `deviceMemory`; Safari no, y ahí manda el
   user-agent, que es justo donde hace falta. */
const _aparatoLimitado = () =>
  /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  || (typeof navigator.deviceMemory === 'number' && navigator.deviceMemory <= 4);

function topeOriginal() {
  const TECHO = _aparatoLimitado() ? 3000 : 6500;
  let cm = 0;
  try {
    ((etat.produit || {}).perso || {}).vues.forEach(v =>
      (v.zones || []).forEach(z => {
        cm = Math.max(cm, +z.cmW || 0, +z.cmH || 0);
      }));
  } catch (e) { return MAX_ORIGINAL; }
  if (!(cm > 0)) return MAX_ORIGINAL;
  const dpi = (S.defauts().dpi || 300);
  const px = Math.round(cm / 2.54 * dpi * 1.15);
  return Math.min(TECHO, Math.max(MAX_ORIGINAL, px));
}

const esMobile = S.esMobile;

/* Decodifica y reduce FUERA del hilo principal cuando el navegador puede.
   `createImageBitmap` con resize hace las dos cosas de golpe y sin bloquear;
   el camino antiguo (FileReader -> Image -> canvas) queda de reserva. */
async function _bitmap(file, maxCote) {
  if (typeof createImageBitmap === 'function') {
    try {
      const completo = await createImageBitmap(file);
      const f = Math.min(1, maxCote / Math.max(completo.width, completo.height));
      if (f === 1) return completo;
      const chico = await createImageBitmap(completo, {
        resizeWidth: Math.round(completo.width * f),
        resizeHeight: Math.round(completo.height * f),
        resizeQuality: 'high',
      });
      completo.close && completo.close();
      return chico;
    } catch (e) { /* Safari viejo: se cae al camino de reserva */ }
  }
  return new Promise((res, rej) => {
    const u = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(u); res(img); };
    img.onerror = () => { URL.revokeObjectURL(u); rej(new Error('image illisible')); };
    img.src = u;
  });
}

const _aDataUrl = (canvas, tipo, q) => new Promise(res => {
  /* toBlob + FileReader en vez de toDataURL: toDataURL codifica de forma
     SINCRONA y con una foto grande congela la interfaz un segundo largo. */
  if (canvas.toBlob) {
    canvas.toBlob(b => {
      if (!b) return res(canvas.toDataURL(tipo, q));
      const l = new FileReader();
      l.onload = () => res(l.result);
      l.onerror = () => res(canvas.toDataURL(tipo, q));
      l.readAsDataURL(b);
    }, tipo, q);
  } else res(canvas.toDataURL(tipo, q));
});

/* Devuelve la miniatura de trabajo y el original acotado. `avance` recibe un
   texto para que el cliente vea que pasa algo: en un iPhone con una foto de 6
   Mo esto son varios segundos y sin aviso parece que la app se ha colgado. */
async function reduireImage(file, avance) {
  const transp = /png|webp/i.test(file.type);
  const tipo = transp ? 'image/png' : 'image/jpeg';

  avance && avance('Lecture de la photo…', 1);
  const bmp = await _bitmap(file, topeOriginal());
  const o = { w: bmp.width, h: bmp.height };

  const dibujar = (src, w, h) => {
    const c = document.createElement('canvas');
    c.width = w; c.height = h;
    c.getContext('2d').drawImage(src, 0, 0, w, h);
    return c;
  };

  avance && avance('Préparation…', 2);
  const f = Math.min(1, MAX_COTE / Math.max(o.w, o.h));
  const cMini = dibujar(bmp, Math.round(o.w*f), Math.round(o.h*f));
  const dataUrl = await _aDataUrl(cMini, tipo, 0.86);

  /* El original acotado solo se rehace si de verdad se acoto; si el bitmap ya
     cabia, se reutiliza la propia miniatura cuando son la misma cosa. */
  avance && avance('Conservation de la qualité…', 3);
  const originalDataUrl = (f === 1)
    ? dataUrl
    : await _aDataUrl(dibujar(bmp, o.w, o.h), tipo, 0.92);

  bmp.close && bmp.close();
  return { dataUrl, origine: o, originalDataUrl };
}

/* Consejo del producto en la modal de subida. La medaille lo usa para pedir
   una carita detourada, que es lo unico que queda bien en 2,8 cm: un consejo
   en el momento de elegir la foto evita la mitad de los pedidos malos. */
function majConseilPhoto() {
  const el = $('#conseil-photo'); if (!el) return;
  const c = (etat.produit && etat.produit.perso && etat.produit.perso.conseilPhoto) || '';
  el.textContent = c;
  el.hidden = !c;
}

/* ¿Este producto admite fotos del cliente? Franklin lo decide producto a
   producto en el admin: « para los llaveros me gustaría quitar la parte de
   la foto ». Sin decir nada, sí — como siempre. */
function photosPermises() {
  const p = etat.produit && etat.produit.perso;
  return !(p && p.photosAutorisees === false);
}

/* ¿QUÉ DEJA PONER LA ZONA ACTIVA? Franklin decide zona a zona en el admin:
   « si sólo puede escribir, o sólo foto, o libre, así para que no pueda
   subir otra cosa el cliente ». Una zona « Lo que escribe el cliente » sin
   elegir nada es sólo texto: es lo que su nombre ya prometía. */
function permisDeZone() {
  const z = S.zoneActive();
  if (!z) return 'libre';
  if (z.permite) return z.permite;
  return z.role === 'saisie' ? 'texte' : 'libre';
}
/* tipo: 'texte' | 'photo' | 'forme' | 'qr' */
function puedePoner(tipo) {
  if (tipo === 'photo' && !photosPermises()) return false;
  const p = permisDeZone();
  return p === 'libre' || p === tipo;
}
function avisarNoPermitido(tipo) {
  const p = permisDeZone();
  if (tipo === 'photo' && !photosPermises()) return;   // ni se ofrece
  alert(p === 'texte' ? 'Dans cette zone, vous pouvez seulement écrire du texte.'
      : p === 'photo' ? 'Dans cette zone, vous pouvez seulement ajouter une photo.'
      : 'Ce produit n’accepte pas cet élément ici.');
}
/* Las pestañas siguen a la zona: lo que no se puede poner, no se ofrece.
   Sólo ESCONDE: lo que ya escondían el producto (fotos, QR) sigue escondido. */
function majOngletsZone() {
  const tab = k => $(`.onglet[data-panneau="${k}"]`);
  const poner = (k, ok) => {
    const t = tab(k); if (!t) return;
    if (!ok) {
      t.hidden = true;
      const pn = $('#panneau-' + k);
      if (pn && !pn.hidden) fermerPanneaux();
    }
  };
  const tt = tab('texte'); if (tt) tt.hidden = !puedePoner('texte');
  if (!puedePoner('texte')) poner('texte', false);
  const tp = tab('photos'); if (tp) tp.hidden = !puedePoner('photo');
  if (!puedePoner('photo')) poner('photos', false);
  const tf = tab('formes'); if (tf) tf.hidden = !puedePoner('forme');
  if (!puedePoner('forme')) poner('formes', false);
  /* El QR: si el producto lo permite lo decide majOngletQR(); aquí sólo se
     quita en una zona que no lo admite. */
  if (!puedePoner('qr')) poner('qr', false);
  else { try { const q = tab('qr'); if (q) q.hidden = !qrAutorise(); } catch (e) {} }
}

async function ajouterFichier(file) {
  /* EL CIERRE VA AQUÍ, NO SÓLO EN LA PESTAÑA. Por esta función pasan todas
     las fotos del cliente: el botón, arrastrar un fichero, la ventana de
     subida. Esconder la pestaña y dejar el arrastre abierto sería esconder
     la puerta con la puerta abierta. Lo mismo vale para la zona. */
  if (!puedePoner('photo')) { avisarNoPermitido('photo'); return; }
  const maxMo = (S.defauts().tailleMaxMo || 15);
  if (!/^image\/(jpeg|png|webp)$/.test(file.type)) {
    alert('Format non supporté. Utilisez JPG, PNG ou WEBP.'); return;
  }
  if (file.size > maxMo * 1024 * 1024) {
    alert(`Photo trop lourde (${(file.size/1048576).toFixed(1)} Mo). Maximum ${maxMo} Mo.`); return;
  }
  /* Antes esto era una cadena de promesas sin red: si algo fallaba —y con una
     foto grande en iOS falla— no pasaba NADA visible y la app parecia
     congelada. Ahora se ve que trabaja, y si se rompe se dice. */
  montrerTravail('Ajout de votre photo…', 0);
  try {
    const { dataUrl, origine, originalDataUrl } =
      await reduireImage(file, (t, etapa) => montrerTravail(t, etapa));
    memoriserRecente(dataUrl, origine);
    placerImage(dataUrl, origine, originalDataUrl);
    $('#modale-depot').hidden = true;
    finirTravail('Photo ajoutée');
    majBadgePhotos();
  } catch (e) {
    console.error('[EDISAMP] photo:', e);
    alert('Une erreur est survenue avec cette photo. Réessayez, ou choisissez-en '
        + 'une autre — si elle est très lourde, une photo plus petite passera mieux.');
  } finally {
    cacherTravail();
  }
}

/* El recorte del hueco. Vive en una sola funcion porque lo usan el relleno de
   fotos y el de textos, y porque el export tiene que reproducirlo exactamente:
   dos copias del mismo calculo acabarian divergiendo. */
function clipEmplacement(m, angle) {
  const comun = { left: m.x + m.w/2, top: m.y + m.h/2,
                  originX:'center', originY:'center',
                  absolutePositioned:true, angle: angle || 0 };
  return (m.forme === 'cercle')
    ? new fabric.Circle(Object.assign({ radius: Math.min(m.w, m.h) / 2 }, comun))
    : new fabric.Rect(Object.assign({ width: m.w, height: m.h }, comun));
}

/* Rellena UN emplacement con la foto del cliente: encaje cover, recorte al
   marco y encuadre guardado aparte para poder regenerarlo a 300 DPI. */
function remplirEmplacement(marco, dataUrl, origine, originalDataUrl) {
  /* zonePar y zoneActive viven en el PRIMER bloque y aqui solo llegan por el
     puente `S`. Sin el prefijo esto lanzaba « zonePar is not defined » y la
     promesa moria en silencio: rellenar un hueco de foto no funcionaba desde
     que se escribio. Lo tapaba que ninguna prueba habia llegado a completar
     una subida dentro de un emplacement. */
  const z = S.zonePar(etat.vue, marco.zoneId) || S.zoneActive();
  fabric.Image.fromURL(dataUrl, img => {
    const m = marco.emplacement;
    const f = MODELES.encadrer(m, img.width, img.height, marco.cadrage);
    img.set({ left:f.cx, top:f.cy, originX:'center', originY:'center',
              scaleX:f.escala, scaleY:f.escala, angle: marco.angle || 0 });
    img.zoneId = marco.zoneId;
    img.estModele = true;
    img.emplacement = m;
    img.emplacementRempli = true;
    img.cadrage = Object.assign({}, MODELES.CADRAGE_DEFECTO, marco.cadrage);
    img.verrous = marco.verrous;
    img.source = { px: origine, natif: { w: img.width, h: img.height } };
    if (originalDataUrl) {
      const id = S.nouvelIdOriginal();
      S.ORIGINALES.set(id, originalDataUrl);
      img.source.idOriginal = id;
    }
    /* Recorte al marco, no a la zona: el hueco manda. */
    img.clipPath = clipEmplacement(m, marco.angle);
    MODELES.appliquerVerrous(img, etat.produit);
    canvas.remove(marco);
    canvas.add(img);
    canvas.setActiveObject(img);
    S.apresChangement(); S.dessinerGuides(); majPanneaux();
  }, { crossOrigin:'anonymous' });
}

/* Rellena un emplacement de TEXTO. El marco manda: el texto nace con el ancho
   del hueco y recortado a el, para que no se desborde por mucho que escriba
   el cliente. En modo simple solo se le deja el contenido. */
function remplirEmplacementTexte(marco) {
  const m = marco.emplacement;
  const pol = policesDuProduit()[0];
  const t = new fabric.Textbox(m.texteDefaut || 'Votre texte', {
    left: m.x + m.w/2, top: m.y + m.h/2,
    originX:'center', originY:'center',
    width: m.w, angle: marco.angle || 0,
    fontSize: m.fontSize || Math.round(m.h * 0.5),
    fontFamily: (m.familleCss) || pol.famille,
    fill: m.couleur || '#FFFFFF',
    textAlign: m.alignement || 'center',
  });
  t.zoneId = marco.zoneId;
  t.policeId = m.policeId || pol.id;
  t.estModele = true;
  t.emplacement = m;
  t.emplacementRempli = true;
  t.verrous = marco.verrous;
  t.clipPath = clipEmplacement(m, marco.angle);
  MODELES.appliquerVerrous(t, etat.produit);
  canvas.remove(marco);
  canvas.add(t);
  canvas.setActiveObject(t);
  S.apresChangement(); S.dessinerGuides(); majPanneaux();
  /* Se abre el panel Texte con el foco en el contenido: es lo unico que el
     cliente puede tocar en modo simple, asi que llevarlo ahi ahorra un paso. */
  const onglet = document.querySelector('.onglet[data-panneau="texte"]');
  if (onglet) onglet.click();
  const campo = $('#txt-contenu');
  if (campo) { campo.focus(); campo.select && campo.select(); }
}

function placerImage(dataUrl, origine, originalDataUrl) {
  /* Si el cliente venia de tocar un hueco, la foto va a ese hueco. */
  if (etat.emplacementPendiente && canvas.getObjects().includes(etat.emplacementPendiente)) {
    const marco = etat.emplacementPendiente;
    etat.emplacementPendiente = null;
    return remplirEmplacement(marco, dataUrl, origine, originalDataUrl);
  }
  const z = S.zoneActive();
  fabric.Image.fromURL(dataUrl, img => {
    const e = Math.min(z.w/img.width, z.h/img.height) * .85;
    img.set({ left:z.x+z.w/2, top:z.y+z.h/2, originX:'center', originY:'center',
              scaleX:e, scaleY:e });
    img.zoneId = z.id;
    /* `natif` = tamano del bitmap que llevamos en el canvas; `px` = el del
       archivo que subio el cliente. Guardarlo es imprescindible: el JSON se
       construye sobre el objeto SERIALIZADO, que ya no tiene _element, y sin
       este dato el ratio original/miniatura sale mal. */
    img.source = { px: origine, natif: { w: img.width, h: img.height } };
    if (originalDataUrl) {
      const id = S.nouvelIdOriginal();
      S.ORIGINALES.set(id, originalDataUrl);
      img.source.idOriginal = id;
    }
    img.clipPath = S.clipPour(z);
    /* los tiradores de recorte se enganchan solos al entrar en el lienzo
       (ver `object:added` en el módulo del lienzo) */
    canvas.add(img); canvas.setActiveObject(img);
    S.apresChangement(); majPanneaux();
  }, { crossOrigin:'anonymous' });
}

function memoriserRecente(dataUrl, origine) {
  try {
    const l = JSON.parse(sessionStorage.getItem(CLE_RECENTES) || '[]');
    l.unshift({ dataUrl, origine });
    sessionStorage.setItem(CLE_RECENTES, JSON.stringify(l.slice(0, 6)));
  } catch (e) { /* cuota: las recientes son un extra, no bloquean */ }
  construireRecentes();
}

function construireRecentes() {
  let l = [];
  try { l = JSON.parse(sessionStorage.getItem(CLE_RECENTES) || '[]'); } catch (e) {}
  $('#bloc-recentes').hidden = !l.length;
  const c = $('#recentes'); c.innerHTML = '';
  l.forEach(p => {
    const b = document.createElement('button');
    b.className = 'recente';
    b.innerHTML = `<img src="${p.dataUrl}" alt="">`;
    b.onclick = () => { placerImage(p.dataUrl, p.origine); $('#modale-depot').hidden = true; };
    c.appendChild(b);
  });
}

/* ------------------------- fond par IA ----------------------------------- */
/* El boton nunca puede quedarse mudo: refleja si el modelo se esta bajando,
   si esta listo o si fallo (sin red, CDN bloqueado). */
function majEtatIA() {
  const b = $('#btn-fond-photo'), aide = $('#fond-aide');
  if (!b || b.hidden) return;
  const o = imageCourante();
  if (o && o.fondSupprime) {
    aide.textContent = 'Fond supprimé. Vous pouvez revenir à la photo d’origine.';
    return;
  }
  switch (FondIA.etat()) {
    case 'chargement':
      b.textContent = '⏳ Préparation…';
      b.disabled = true;
      aide.textContent = `Téléchargement du modèle : ${FondIA.pourcentage()} %`;
      break;
    case 'erreur':
      b.textContent = '✨ Supprimer le fond';
      b.disabled = true;
      aide.textContent = "Indisponible : impossible de charger le modèle (connexion ou navigateur).";
      break;
    case 'pret':
      b.textContent = '✨ Supprimer le fond';
      b.disabled = false;
      aide.textContent = 'Modèle prêt — la suppression sera rapide.';
      break;
    default:
      b.textContent = '✨ Supprimer le fond';
      b.disabled = false;
      aide.textContent = 'Détection du sujet par IA, directement sur votre appareil.';
  }
}
let _travailAnnule = false;

/* El parte de trabajo.
   -----------------------------------------------------------------------
   NO lleva porcentaje, y es a propósito. La referencia que inspiró esto es
   una DESCARGA: hay bytes viajando, así que hay un tanto por ciento real que
   contar. Aquí el cliente elige un archivo de su propio teléfono: no se
   transfiere nada, y lo que tarda es decodificar y redimensionar, que el
   navegador no informa. Un número subiendo ahí sería inventado.

   Lo que sí es real son las TRES etapas por las que pasa `reduireImage`, y
   cada una termina de verdad. Así que el parte se llena por tramos: tres
   segmentos que se encienden cuando su etapa acaba. Dice lo mismo —cuánto
   falta— sin afirmar una precisión que no existe. */
const ETAPAS = 3;

/**
 * Progreso del modal.
 *
 * REGLA: el porcentaje solo se ensena cuando existe de verdad.
 *
 * La libreria de detourage informa de `actuel/total` MIENTRAS BAJA EL MODELO
 * —ahi el numero es real y util, son 40 Mo— y despues se calla durante la
 * inferencia, que es una sola operacion que no se puede subdividir. Antes se
 * ensenaba un « 25 % » que venia de esa fase de descarga y se quedaba
 * congelado mientras el modelo pensaba: parecia atascado.
 *
 * Ahora: barra con relleno real durante la descarga, barra indeterminada
 * durante la inferencia. Nada de temporizadores que suban solos.
 */
/* IDENTIFICADOR DEL TRABAJO EN CURSO.
   Sin esto pasaba lo siguiente, medido: el detourage supera su tope de 75 s,
   `Promise.race` rechaza y la interfaz se recompone... pero la operacion de
   fondo NO se cancela —una promesa no se puede matar— y sigue llamando al
   callback de progreso. Cada llamada hacia `boite.hidden = false` y volvia a
   abrir un modal que ya se habia cerrado. Resultado: un cuadro de progreso
   eterno para un trabajo que nadie espera. A los 230 s seguia ahi.

   Ahora cada trabajo se lleva un numero. El progreso de un trabajo viejo se
   ignora en silencio, que es exactamente lo que merece. */
let _travailId = 0;
const nouveauTravail = () => ++_travailId;

function progresTravail(txt, pc, cle, jeton) {
  /* Progreso de un trabajo ya abandonado: se tira. */
  if (jeton !== undefined && jeton !== _travailId) return;
  const jauge = $('#travail-jauge'), fill = $('#travail-jauge-fill');
  const sous = $('#travail-sous');
  const boite = $('#travail');
  if (boite) { boite.removeAttribute('data-fini'); boite.hidden = false; }

  /* Un 100 % de descarga NO es el final: despues viene la inferencia, que no
     informa. Al llegar a 100 se cambia sola a indeterminada, para que la barra
     no se quede llena y quieta mientras el modelo piensa. */
  /* Al 100 % la DESCARGA acabo, pero el trabajo no: falta la inferencia, que
     no informa de nada. La barra pasa a indeterminada sin mirar la clave — mi
     version anterior exigia que la clave casara con /fetch|download/ y la
     clave real de la libreria no casa, asi que la barra se quedaba llena y
     quieta diciendo « Téléchargement » mientras el modelo pensaba. */
  if (typeof pc === 'number' && pc >= 100) {
    pc = null;
    txt = 'Suppression du fond…';
  }

  /* El texto se escribe AQUI, despues de la posible reasignacion. Ponerlo
     arriba dejaba « Téléchargement du modèle… » puesto durante la inferencia. */
  const et = $('#travail-txt');
  if (et && txt) et.textContent = txt;
  if (!jauge || !fill) return;

  if (typeof pc === 'number' && pc >= 0 && pc <= 100) {
    jauge.classList.remove('travail__jauge--indet');
    fill.style.width = pc + '%';
    jauge.setAttribute('aria-valuenow', String(pc));
    if (sous) sous.textContent = pc + ' %' + (cle && /fetch|download/i.test(cle)
      ? ' — téléchargement du modèle' : '');
  } else {
    /* Indeterminada: se anima, pero no finge saber cuanto queda. */
    jauge.classList.add('travail__jauge--indet');
    fill.style.width = '';
    jauge.removeAttribute('aria-valuenow');
    if (sous) sous.textContent = '';
  }
}

function montrerTravail(txt, sousOEtapa) {
  nouveauTravail();
  $('#travail-txt').textContent = txt;
  const boite = $('#travail');

  const etapa = typeof sousOEtapa === 'number' ? sousOEtapa : null;
  if (etapa === null) {
    $('#travail-sous').textContent = sousOEtapa || '';
    boite.removeAttribute('data-etapa');
  } else {
    $('#travail-sous').textContent = '';
    boite.dataset.etapa = String(Math.min(etapa, ETAPAS));
  }
  boite.removeAttribute('data-fini');
  boite.hidden = false;
  /* Sin cifra: indeterminada. Es mas honesto que un 0 % que no se mueve. */
  const jauge = $('#travail-jauge');
  if (jauge && etapa === null) {
    jauge.classList.add('travail__jauge--indet');
    const fill = $('#travail-jauge-fill');
    if (fill) fill.style.width = '';
    jauge.removeAttribute('aria-valuenow');
  }
}

/* El distintivo de la pestaña Photos: cuántas fotos hay en el diseño.
   -----------------------------------------------------------------------
   Es el detalle que la referencia clava: el « 1 » que aparece sobre el icono
   al terminar la descarga. No es decoración — es lo que convierte una acción
   en un REGISTRO. El indicador desaparece, pero queda una marca de que algo
   tuyo está ahí, y esa marca acompaña al cliente el resto de la sesión.

   Cuenta objetos de verdad del lienzo. Si borra una foto, baja. */
function majBadgePhotos() {
  const boton = document.querySelector('.onglet[data-panneau="photos"]');
  if (!boton) return;
  let n = 0;
  try {
    // `canvas` es el lienzo de Fabric; el fondo no cuenta como foto añadida.
    n = canvas.getObjects()
      .filter(o => o && o.type === 'image' && !o.estFond).length;
  } catch (e) { return; }

  if (!n) { boton.removeAttribute('data-badge'); return; }
  const nuevo = boton.dataset.badge !== String(n);
  boton.dataset.badge = String(n);
  if (nuevo) {
    boton.removeAttribute('data-badge-nuevo');
    void boton.offsetWidth;   // sin esto, poner y quitar en un tick no anima
    boton.dataset.badgeNuevo = 'true';
    setTimeout(() => boton.removeAttribute('data-badge-nuevo'), 500);
  }
}

/* El final. Es el momento que la referencia hace bien y que aquí faltaba
   entero: hasta ahora el indicador simplemente DESAPARECÍA, y desaparecer no
   es lo mismo que confirmar. */
function finirTravail(txt) {
  const boite = $('#travail');
  $('#travail-txt').textContent = txt;
  boite.dataset.etapa = String(ETAPAS);
  boite.dataset.fini = 'true';
  setTimeout(() => { boite.hidden = true; boite.removeAttribute('data-fini'); }, 620);
}

const cacherTravail = () => {
  /* Cerrar el cuadro invalida el trabajo: si el de fondo sigue vivo y manda
     progreso, ya no encontrara su jeton y no volvera a abrir el modal. */
  nouveauTravail();
  const b = $('#travail');
  // Si está cerrando en el estado « hecho », se le deja terminar.
  if (b.dataset.fini === 'true') return;
  b.hidden = true;
};

/* Reemplaza los pixeles del objeto conservando posicion, escala, rotacion y
   recorte relativo. Es la clave del requisito: la foto sin fondo aparece
   exactamente donde estaba. */
function remplacerImage(o, dataUrl) {
  return new Promise(res => {
    fabric.util.loadImage(dataUrl, el => {
      if (!el) { res(false); return; }
      const ancienNat = (o._element && o._element.naturalWidth) || o.width;
      const k = el.naturalWidth / ancienNat;      // por si la IA cambia el tamano
      const cx = (o.cropX || 0) * k, cy = (o.cropY || 0) * k;
      const w  = o.width * k, h = o.height * k;
      o.setElement(el);
      o.set({ cropX:cx, cropY:cy, width:w, height:h,
              scaleX:o.scaleX / k, scaleY:o.scaleY / k });
      if (o.source) o.source.natif = { w: el.naturalWidth, h: el.naturalHeight };
      o.setCoords();
      canvas.requestRenderAll();
      res(true);
    }, null, { crossOrigin:'anonymous' });
  });
}

/**
 * Quita el fondo SIN perder un solo píxel de la foto del cliente.
 *
 * EL FALLO QUE HABIA AQUI, y es de arquitectura, no de ajuste. Se reducia la
 * foto a 1600 px para que el modelo cupiera en memoria —hasta ahi bien— y
 * despues se ponia LA SALIDA DEL MODELO como nueva imagen del objeto. O sea
 * que una foto de 4800 px volvia convertida en una de 1600, y la calidad
 * caia de 158 a 53 DPI sin que nadie lo pidiera.
 *
 * La salida de un modelo de segmentacion NO es el artwork. Es una MASCARA.
 *
 * Asi que ahora:
 *
 *     ORIGINAL a resolucion completa   (no se toca nunca)
 *       -> copia reducida solo para la inferencia
 *       -> el modelo devuelve un PNG recortado
 *       -> se le extrae el CANAL ALFA, que es la mascara
 *       -> esa mascara se estira a las medidas del ORIGINAL
 *       -> se aplica sobre el ORIGINAL a resolucion completa
 *       -> resultado: RGBA del tamano de la foto del cliente
 *
 * La mascara se estira con interpolacion suave, y eso esta bien: un contorno
 * es una frontera continua, no una rejilla de detalle. Lo que no se puede
 * estirar es la FOTO, y la foto ya no se estira — nunca sale de su tamano.
 */
async function supprimerFondIA(modeleForce) {
  const o = imageCourante();
  if (!o || o.fondSupprime) return;
  canvas.setActiveObject(o);

  const el = o._element;
  if (!el || !el.naturalWidth) return;

  const W = el.naturalWidth, H = el.naturalHeight;
  /* Si ya hubo un detourage y se restauro, el elemento actual ES el original.
     Se comprueba igualmente que no se este detourando algo ya detourado: eso
     daria un resultado distinto cada vez y el §13-E pide determinismo. */

  /* EL ORIGINAL QUE SE GUARDA ES EL DE IMPRESION, NO EL DEL LIENZO.
     Segundo intento sobre lo mismo, y el fallo era sutil: guardaba el elemento
     del canvas, que esta acotado a MAX_COTE (1600 px). Restaurar devolvia
     entonces una foto de 1600 px como « original » y el fichero de impresion
     perdia para siempre los 2400 px que el cliente habia subido — sin decirlo,
     y sin vuelta atras.

     La autoridad es `ORIGINALES`, que guarda hasta MAX_ORIGINAL (3000 px). El
     elemento del lienzo solo es la copia con la que se trabaja en pantalla. */
  if (!o.sourceOriginale) {
    const idAvant = o.source && o.source.idOriginal;
    const dataAvant = idAvant ? S.ORIGINALES.get(idAvant) : null;
    if (dataAvant) {
      o.sourceOriginale = dataAvant;
    } else {
      const plein = document.createElement('canvas');
      plein.width = W; plein.height = H;
      plein.getContext('2d').drawImage(el, 0, 0);
      o.sourceOriginale = plein.toDataURL('image/png');
    }
    o.sourceNatif = { w: W, h: H };
  }

  /* La copia para el modelo. El limite sigue existiendo —un iPhone con una
     imagen de 1600 px se queda sin memoria— pero ahora solo limita LO QUE VE
     EL MODELO, no lo que se queda el cliente. */
  const TOPE = esMobile() ? 1024 : 1600;
  const f = Math.min(1, TOPE / Math.max(W, H));
  const tampon = document.createElement('canvas');
  tampon.width = Math.max(1, Math.round(W * f));
  tampon.height = Math.max(1, Math.round(H * f));
  tampon.getContext('2d').drawImage(el, 0, 0, tampon.width, tampon.height);
  const pourModele = tampon.toDataURL('image/png');

  _travailAnnule = false;
  montrerTravail('Suppression du fond en cours…',
                 'Le premier essai télécharge le modèle, cela peut prendre quelques secondes.');
  try {
    const modele = modeleForce || FondIA.MODELE_DEFAUT();

    /* Cronometro por etapas. No es decoracion: sin separar « bajar el modelo »
       de « pensar » no se sabe si una espera de 40 s es red o calculo, y son
       dos problemas distintos con dos soluciones distintas. */
    const chrono = { debut: performance.now(), telechargement: 0, inference: 0,
                     masque: 0, premierProgres: 0, finProgres: 0 };

    /* DOS ETAPAS QUE EL CLIENTE VE DISTINTAS.
       Mientras baja el modelo hay porcentaje de verdad y se dice que es una
       descarga — asi la primera espera larga tiene una explicacion. Cuando la
       libreria deja de informar, empieza la inferencia: se cambia el texto y
       la barra pasa a indeterminada. Antes las dos fases compartian rotulo y
       el 25 % se quedaba congelado pareciendo un cuelgue. */
    const jeton = nouveauTravail();
    const sans = await FondIA.supprimerFond(pourModele,
      (pc, cle) => {
        if (_travailAnnule) return;
        if (!chrono.premierProgres) chrono.premierProgres = performance.now();
        chrono.finProgres = performance.now();
        progresTravail('Téléchargement du modèle…', pc, cle, jeton);
      },
      modele);
    if (jeton !== _travailId) return;   // otro trabajo tomo el relevo
    if (_travailAnnule) return;
    chrono.telechargement = chrono.finProgres
      ? chrono.finProgres - chrono.debut : 0;
    chrono.inference = performance.now()
      - (chrono.finProgres || chrono.debut);

    const tMasque = performance.now();
    progresTravail('Finalisation…', null, null, jeton);

    /* DOS RESOLUCIONES, Y NO ES CAPRICHO. El Studio guarda a proposito dos
       versiones de cada foto: el elemento del lienzo, acotado a MAX_COTE
       (1600 px) para que el canvas vaya fluido, y el ORIGINAL para impresion,
       acotado a MAX_ORIGINAL (3000 px). Son dos topes distintos porque sirven
       para dos cosas distintas.

       Mi primera version aplicaba la mascara solo al elemento del lienzo y
       metia ESE resultado como original de impresion. O sea que arreglaba la
       perdida de calidad en pantalla y la volvia a introducir en el fichero
       que se imprime — el sitio donde de verdad importa.

       La MISMA mascara se aplica a las dos, cada una a su tamaño. */
    const elemMasque = await appliquerMasquePleineResolution(el, sans, W, H);
    if (_travailAnnule) return;

    const ok = await remplacerImage(o, elemMasque);
    if (!ok) throw new Error('image illisible');
    o.fondSupprime = true;
    o.modeleDetourage = modele;

    /* Y ahora el de impresion, a SU resolucion. Si no existe, el elemento ya
       es lo mejor que hay. */
    const idO = o.source && o.source.idOriginal;
    const dataOrig = idO ? S.ORIGINALES.get(idO) : null;
    if (dataOrig) {
      try {
        const elOrig = await new Promise((res2, rej2) => {
          fabric.util.loadImage(dataOrig, e2 => e2 ? res2(e2) : rej2(new Error('original illisible')),
            null, { crossOrigin: 'anonymous' });
        });
        const pleinImpression = await appliquerMasquePleineResolution(
          elOrig, sans, elOrig.naturalWidth, elOrig.naturalHeight);
        majOriginalPrepare(o, pleinImpression);
      } catch (e2) {
        /* Si el original no se puede releer, mejor el elemento detourado que
           un fichero de impresion CON el fondo que el cliente quito. */
        console.warn('[EDISAMP] masque sur original:', e2);
        majOriginalPrepare(o, elemMasque);
      }
    } else {
      majOriginalPrepare(o, elemMasque);
    }
    chrono.masque = performance.now() - tMasque;
    chrono.total = performance.now() - chrono.debut;
    /* Se deja a la vista para poder medir sin instrumentar a mano cada vez. */
    o.chronoDetourage = chrono;
    window.__chronoDetourage = chrono;
    console.info('[EDISAMP] détourage —',
      'téléchargement', Math.round(chrono.telechargement), 'ms ·',
      'inférence', Math.round(chrono.inference), 'ms ·',
      'masque HD', Math.round(chrono.masque), 'ms ·',
      'total', Math.round(chrono.total), 'ms');

    majPanneaux(); S.apresChangement();
  } catch (e) {
    console.warn('[EDISAMP] fond IA:', e);
    if (!_travailAnnule) {
      const inactif = e && /inactivite|timeout/.test(e.message || '');
      alert(inactif
        ? 'Le détourage s’est interrompu : le modèle ne répond plus. '
          + 'Votre photo n’a pas été modifiée. Vérifiez votre connexion et réessayez.'
        : 'Le détourage n’a pas abouti. Votre photo n’a pas été modifiée.');
    }
  } finally { cacherTravail(); }
}

/**
 * Toma el alfa del recorte del modelo y lo aplica al original completo.
 *
 * Solo se usa el CANAL ALFA de lo que devuelve el modelo. Su RGB se descarta
 * a proposito: viene de la copia reducida, y usarlo seria volver a meter la
 * perdida de calidad por la puerta de atras.
 */
function appliquerMasquePleineResolution(elOriginal, dataUrlMasque, W, H) {
  return new Promise((res, rej) => {
    fabric.util.loadImage(dataUrlMasque, mEl => {
      if (!mEl) return rej(new Error('masque illisible'));
      try {
        /* La mascara, estirada a las medidas del original. */
        const mc = document.createElement('canvas');
        mc.width = W; mc.height = H;
        const mg = mc.getContext('2d', { willReadFrequently: true });
        mg.imageSmoothingEnabled = true;
        mg.imageSmoothingQuality = 'high';
        mg.drawImage(mEl, 0, 0, W, H);
        const masque = mg.getImageData(0, 0, W, H).data;

        /* El original, intacto, con el alfa de la mascara encima. */
        const out = document.createElement('canvas');
        out.width = W; out.height = H;
        const og = out.getContext('2d', { willReadFrequently: true });
        og.drawImage(elOriginal, 0, 0, W, H);
        const img = og.getImageData(0, 0, W, H);
        /* El modelo devuelve una mascara cuyo maximo es 254, no 255. Un pixel
           a 254 es « casi opaco », y aguas abajo eso cuenta como
           semitransparencia: el control DTF avisaria de un velo que no existe
           y el fichero llevaria un canal alfa lleno de valores intermedios sin
           motivo. Lo que esta a 250 o mas se cierra a opaco; lo demas —el
           borde de verdad— se respeta tal cual. */
        for (let i = 3; i < img.data.length; i += 4) {
          const a = masque[i];
          img.data[i] = a >= 250 ? 255 : a;
        }
        og.putImageData(img, 0, 0);
        res(out.toDataURL('image/png'));
      } catch (e) { rej(e); }
    }, null, { crossOrigin: 'anonymous' });
  });
}

/**
 * Deja el artwork PREPARADO como la fuente que usan la impresion y la mejora.
 *
 * `ORIGINALES` deja de significar « la foto tal como se subio » y pasa a
 * significar « la foto con lo que el cliente le ha hecho ». El original de
 * verdad vive en `o.sourceOriginale`, que no se toca. Sin esta separacion,
 * cada herramienta leia una version distinta y se pisaban unas a otras.
 */
/** El bitmap del objeto a su resolucion nativa, no al tamano de pantalla. */
function sourcePleineResolution(o) {
  const el = o._element;
  if (!el || !el.naturalWidth) return o.toDataURL();
  const c = document.createElement('canvas');
  c.width = el.naturalWidth; c.height = el.naturalHeight;
  c.getContext('2d').drawImage(el, 0, 0);
  return c.toDataURL('image/png');
}

function majOriginalPrepare(o, dataUrl) {
  const id = (o.source && o.source.idOriginal) || S.nouvelIdOriginal();
  S.ORIGINALES.set(id, dataUrl);
  o.source = Object.assign({}, o.source, { idOriginal: id });
}

async function annulerFondIA() {
  const o = imageCourante();
  if (!o || !o.sourceOriginale) return;
  canvas.setActiveObject(o);
  montrerTravail('Restauration de la photo…');
  try {
    await remplacerImage(o, o.sourceOriginale);
    o.fondSupprime = false;
    o.modeleDetourage = null;
    /* Y el fichero de impresion TAMBIEN vuelve. Sin esta linea la pantalla
       ensenaba la foto con su fondo y el PNG de produccion seguia saliendo
       recortado: dos verdades distintas para la misma foto. */
    majOriginalPrepare(o, o.sourceOriginale);
    /* `sourceOriginale` NO se borra: el cliente puede volver a quitar el fondo
       y volver a restaurar las veces que quiera, y siempre desde la MISMA foto
       de partida. Borrarlo obligaba a que el segundo detourage partiera de un
       sitio distinto que el primero. */
    majPanneaux(); S.apresChangement();
  } finally { cacherTravail(); }
}

/* ========================= COULEURS DE L'IMAGE ===========================
   QUITAR COLORES, NO QUITAR EL FONDO. Son dos cosas distintas y hacian falta
   las dos. Franklin: « los dibujos se van a cortar en Cricut; entonces en
   algunos tonos, en sombras y demas, no va a salir. Si alguien sube una cara
   de una persona, va a ser dificil ».

   Tiene razon en el fondo del asunto: una cortadora NO imprime. Recorta una
   silueta de vinilo por color. Un degradado no existe para ella — o el color
   esta o no esta. Asi que lo util no es « quitar el fondo » sino poder decir
   « de esta foto quiero ESTOS tres colores y ninguno mas ».

   COMO SE ELIGE LA PALETA. Contar colores exactos no sirve: una foto de movil
   trae decenas de miles y ninguno se repite. Se reducen a una rejilla de
   32 niveles por canal, se cuentan, y despues se FUNDEN los cubos parecidos
   —la sombra de un rojo es el mismo rojo para quien va a cortar—. El
   representante de cada grupo es la media real de sus pixeles, no el centro
   del cubo, que daria colores lavados que no estan en la imagen.

   Lo transparente no cuenta. Si ya se quito el fondo, la paleta tiene que ser
   la del sujeto; si no, el primer color de la lista seria siempre el fondo
   que ya no esta.

   EL BORDE. Un corte a cuchillo deja el contorno dentado. Entre `tol` y
   `tol x 1.35` el alfa sube en rampa, asi que el borde conserva su
   antialiasing y la pieza no sale con escalones.

   SIEMPRE SE PARTE DE LA MISMA BASE. Cada cambio recalcula desde la imagen
   guardada ANTES de quitar el primer color. Si se aplicara encima de lo ya
   aplicado, volver a poner un color seria imposible y la tolerancia iria
   comiendose la foto a cada toque. La base vive en ORIGINALES, con su id,
   por lo mismo que los originales: una dataURL en el objeto revienta el
   sessionStorage. */

const TOL_COULEUR_DEFAUT = 34;

/* Pixeles de una imagen a un tamano manejable para analizar. */
function _pixelsPourAnalyse(el, cote) {
  const k = Math.min(1, cote / Math.max(el.naturalWidth, el.naturalHeight));
  const w = Math.max(1, Math.round(el.naturalWidth * k));
  const h = Math.max(1, Math.round(el.naturalHeight * k));
  const c = document.createElement('canvas');
  c.width = w; c.height = h;
  const g = c.getContext('2d', { willReadFrequently: true });
  g.drawImage(el, 0, 0, w, h);
  return g.getImageData(0, 0, w, h).data;
}

const _hex = (r, g, b) => '#' + [r, g, b]
  .map(v => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, '0'))
  .join('');

function paletteDeImage(el, n) {
  const d = _pixelsPourAnalyse(el, 180);
  const cubos = new Map();
  for (let i = 0; i < d.length; i += 4) {
    if (d[i + 3] < 128) continue;                    // transparente: no cuenta
    const r = d[i], g = d[i + 1], b = d[i + 2];
    const k = ((r >> 3) << 10) | ((g >> 3) << 5) | (b >> 3);
    let c = cubos.get(k);
    if (!c) { c = { n: 0, r: 0, g: 0, b: 0 }; cubos.set(k, c); }
    c.n++; c.r += r; c.g += g; c.b += b;
  }
  const lista = [...cubos.values()]
    .map(c => ({ n: c.n, r: c.r / c.n, g: c.g / c.n, b: c.b / c.n }))
    .sort((a, b) => b.n - a.n);

  /* Fundir los parecidos. 46 sobre 441 (la diagonal del cubo RGB) separa un
     rojo de un burdeos y junta un rojo con su propia sombra, que es justo lo
     que hay que hacer para una cortadora. */
  const FUSION = 46;
  const grupos = [];
  for (const c of lista) {
    const g = grupos.find(x => Math.hypot(x.r - c.r, x.g - c.g, x.b - c.b) < FUSION);
    if (g) {
      const t = g.n + c.n;
      g.r = (g.r * g.n + c.r * c.n) / t;
      g.g = (g.g * g.n + c.g * c.n) / t;
      g.b = (g.b * g.n + c.b * c.n) / t;
      g.n = t;
    } else if (grupos.length < (n || 10)) {
      grupos.push(Object.assign({}, c));
    }
  }
  const total = grupos.reduce((s, g) => s + g.n, 0) || 1;
  return grupos.map(g => ({
    hex: _hex(g.r, g.g, g.b),
    part: Math.round(g.n / total * 100),
  }));
}

/* La imagen del objeto tal como estaba antes de tocarle un solo color. */
function baseCouleurs(o) {
  if (o.baseCouleursId) {
    const d = S.ORIGINALES.get(o.baseCouleursId);
    if (d) return d;
  }
  const d = sourcePleineResolution(o);
  const id = S.nouvelIdOriginal();
  S.ORIGINALES.set(id, d);
  o.baseCouleursId = id;
  return d;
}

function _rgbDe(hex) {
  const m = /^#?([0-9a-f]{6})$/i.exec(String(hex || ''));
  if (!m) return null;
  const v = parseInt(m[1], 16);
  return [(v >> 16) & 255, (v >> 8) & 255, v & 255];
}

/* Rehace la imagen desde la base quitando los colores marcados. */
function _retirerCouleurs(dataUrl, hexes, tol) {
  return new Promise((res, rej) => {
    fabric.util.loadImage(dataUrl, el => {
      if (!el) { rej(new Error('image illisible')); return; }
      const W = el.naturalWidth, H = el.naturalHeight;
      const c = document.createElement('canvas');
      c.width = W; c.height = H;
      const g = c.getContext('2d', { willReadFrequently: true });
      g.drawImage(el, 0, 0);
      const im = g.getImageData(0, 0, W, H);
      const d = im.data;
      const cibles = hexes.map(_rgbDe).filter(Boolean);
      if (cibles.length) {
        const dur = tol, doux = tol * 1.35;
        for (let i = 0; i < d.length; i += 4) {
          if (!d[i + 3]) continue;
          let min = Infinity;
          for (let k = 0; k < cibles.length; k++) {
            const t = cibles[k];
            const dd = Math.hypot(d[i] - t[0], d[i + 1] - t[1], d[i + 2] - t[2]);
            if (dd < min) min = dd;
          }
          if (min <= dur) d[i + 3] = 0;
          else if (min < doux) {
            d[i + 3] = Math.round(d[i + 3] * (min - dur) / (doux - dur));
          }
        }
      }
      g.putImageData(im, 0, 0);
      res(c.toDataURL('image/png'));
    }, null, { crossOrigin: 'anonymous' });
  });
}

async function appliquerCouleursRetirees(o) {
  const base = baseCouleurs(o);
  const hexes = o.couleursRetirees || [];
  const tol = o.toleranceCouleur || TOL_COULEUR_DEFAUT;
  montrerTravail(hexes.length ? 'Retrait des couleurs…' : 'Restauration des couleurs…');
  try {
    const out = hexes.length ? await _retirerCouleurs(base, hexes, tol) : base;
    await remplacerImage(o, out);
    /* renderAll, no requestRenderAll: la peticion se encola para el siguiente
       frame y con el panel abierto encima llegaba tarde — la foto se quedaba
       en pantalla con el color todavia puesto hasta el proximo toque. Medido:
       el pixel central de la banda seguia azul hasta forzar el repintado. */
    canvas.renderAll();
    /* Y el fichero de impresion tambien: si solo cambiara la pantalla, el
       cliente cortaria una cosa y la maquina otra. */
    majOriginalPrepare(o, out);
    S.apresChangement();
  } finally { cacherTravail(); }
  majPanneauCouleurs();
}

let _paletteCache = null;      // { id, liste } — analizar cuesta, no se repite

function majPanneauCouleurs() {
  const bloc = $('#bloc-couleurs-img'); if (!bloc) return;
  const o = derniereImage && canvas.contains(derniereImage)
    ? derniereImage : imageCourante();
  if (!o || o.type !== 'image') { bloc.hidden = true; return; }
  bloc.hidden = false;

  const base = baseCouleurs(o);
  if (!_paletteCache || _paletteCache.id !== o.baseCouleursId) {
    const el = new Image();
    el.onload = () => {
      _paletteCache = { id: o.baseCouleursId, liste: paletteDeImage(el, 10) };
      majPanneauCouleurs();
    };
    el.src = base;
    return;
  }

  const retirees = o.couleursRetirees || [];
  const cc = $('#img-couleurs');
  cc.innerHTML = '';
  _paletteCache.liste.forEach(({ hex, part }) => {
    const b = document.createElement('button');
    b.type = 'button';
    const fuera = retirees.includes(hex);
    b.className = 'pastille' + (fuera ? ' pastille--retiree' : '');
    b.style.background = hex;
    b.title = `${hex} · ${part}% ${fuera ? '— retirée, toucher pour remettre' : ''}`;
    b.setAttribute('aria-pressed', fuera ? 'true' : 'false');
    b.onclick = () => {
      const l = (o.couleursRetirees || []).slice();
      const i = l.indexOf(hex);
      if (i >= 0) l.splice(i, 1); else l.push(hex);
      o.couleursRetirees = l;
      appliquerCouleursRetirees(o);
    };
    cc.appendChild(b);
  });
  const reset = $('#img-couleurs-reset');
  if (reset) reset.hidden = !retirees.length;
  const tol = $('#img-tolerance');
  if (tol) { tol.value = o.toleranceCouleur || TOL_COULEUR_DEFAUT;
             $('#img-tol-val').textContent = tol.value; }
}

function brancherCouleursImage() {
  const tol = $('#img-tolerance'); if (!tol) return;
  tol.oninput = () => { $('#img-tol-val').textContent = tol.value; };
  /* Al soltar, no en cada pixel del deslizador: cada recalculo recorre la foto
     entera y hacerlo sesenta veces por segundo cuelga el movil. */
  tol.onchange = () => {
    const o = imageCourante() || derniereImage; if (!o) return;
    o.toleranceCouleur = parseInt(tol.value, 10) || TOL_COULEUR_DEFAUT;
    if ((o.couleursRetirees || []).length) appliquerCouleursRetirees(o);
  };
  const reset = $('#img-couleurs-reset');
  if (reset) reset.onclick = () => {
    const o = imageCourante() || derniereImage; if (!o) return;
    o.couleursRetirees = [];
    appliquerCouleursRetirees(o);
  };
}

/* ============================ RECADRAGE (crop) ===========================
   No destructivo: Fabric guarda cropX/cropY/width/height sobre la imagen
   completa, asi que los pixeles originales siguen ahi y se puede volver a
   entrar para ampliar el encuadre.

   Como funciona el modo:
     - un "fantasma" muestra la imagen ENTERA translucida, colocado de forma
       que la porcion visible actual quede justo donde esta
     - encima, un marco con esquinas arrastrables
     - al validar, se convierten las esquinas del marco a pixeles de la imagen
       usando la matriz inversa del fantasma
   ========================================================================== */
let recadrage = null;

function entrerRecadrage(img) {
  if (!img || img.type !== 'image' || recadrage) return;
  const el = img._element;
  if (!el || !el.naturalWidth) return;

  const natW = el.naturalWidth, natH = el.naturalHeight;
  const sx = img.scaleX, sy = img.scaleY;
  const cx = img.cropX || 0, cy = img.cropY || 0;

  // desplazamiento del centro de la imagen completa respecto al centro visible
  const offX = sx * (natW/2 - cx - img.width/2);
  const offY = sy * (natH/2 - cy - img.height/2);
  const rad = fabric.util.degreesToRadians(img.angle || 0);
  const off = fabric.util.rotatePoint(new fabric.Point(offX, offY), new fabric.Point(0,0), rad);

  const fantome = new fabric.Image(el, {
    left: img.left + off.x, top: img.top + off.y,
    originX:'center', originY:'center',
    scaleX:sx, scaleY:sy, angle:img.angle || 0,
    cropX:0, cropY:0, width:natW, height:natH,
    opacity:.32, selectable:false, evented:false, excludeFromExport:true,
  });

  const cadre = new fabric.Rect({
    left: img.left, top: img.top, originX:'center', originY:'center',
    width: img.width * sx, height: img.height * sy, angle: img.angle || 0,
    fill:'rgba(210,182,138,.10)', stroke:'#D2B68A', strokeWidth:2,
    strokeUniform:true, lockRotation:true, hasRotatingPoint:false,
    objectCaching:false, excludeFromExport:true,
  });
  cadre.setControlsVisibility({ mtr:false });

  /* El recorte necesita ver el producto: cerramos el panel abierto. En movil
     el bottom-sheet (z 80) tapaba literalmente los botones Valider/Annuler. */
  $$('.panneau').forEach(pa => { pa.hidden = true; });
  $$('.onglet').forEach(o => o.setAttribute('aria-selected', false));

  img.visible = false;
  canvas.add(fantome); canvas.add(cadre);
  canvas.setActiveObject(cadre);
  recadrage = { img, fantome, cadre, natW, natH };
  $('#recadre-actions').hidden = false;
  canvas.requestRenderAll();
}

function sortirRecadrage(valider) {
  if (!recadrage) return;
  const { img, fantome, cadre, natW, natH } = recadrage;

  if (valider) {
    // esquinas del marco -> pixeles de la imagen completa
    const inv = fabric.util.invertTransform(fantome.calcTransformMatrix());
    const locales = cadre.getCoords(true, true)
      .map(p => fabric.util.transformPoint(p, inv));
    const xs = locales.map(p => p.x), ys = locales.map(p => p.y);
    const borne = (v, max) => Math.max(0, Math.min(max, v));

    const x0 = borne(Math.min(...xs) + natW/2, natW);
    const y0 = borne(Math.min(...ys) + natH/2, natH);
    const x1 = borne(Math.max(...xs) + natW/2, natW);
    const y1 = borne(Math.max(...ys) + natH/2, natH);
    const w = Math.max(8, x1 - x0), h = Math.max(8, y1 - y0);
    const centre = cadre.getCenterPoint();

    img.set({
      cropX:Math.round(x0), cropY:Math.round(y0),
      width:Math.round(w), height:Math.round(h),
      left:centre.x, top:centre.y,
      scaleX:fantome.scaleX, scaleY:fantome.scaleY, angle:fantome.angle,
    });
    img.setCoords();
  }

  canvas.remove(fantome); canvas.remove(cadre);
  img.visible = true;
  canvas.setActiveObject(img);
  recadrage = null;
  $('#recadre-actions').hidden = true;
  S.apresChangement(); majPanneaux();
}

/* ================================= E6 · FOND ============================= */
function appliquerFond(hex) {
  if (!etat.produit.perso.fondAutorise) return;
  const z = S.zoneActive();
  canvas.getObjects().filter(o => o.estFond).forEach(o => canvas.remove(o));
  if (hex) {
    /* EL FONDO TIENE LA FORMA DEL PRODUCTO, NO LA DE SU CAJA. Franklin, con
       un porte-cles redondo delante: « cuando los fondos acrilicos tengan un
       fondo que no salga en cuadrado, si el producto es circular, entonces
       eso tambien tienes que tenerlo en cuenta ». Se pintaba siempre un
       rectangulo de la caja envolvente, asi que en un disco de acrilico se
       veia un cuadrado beige colgando por las esquinas.
       En el fichero de impresion ya salia bien —impression.js recorta a la
       forma antes de exportar—, o sea que lo unico equivocado era lo que el
       cliente veia. Que es lo peor que puede estar equivocado: decide con
       eso. */
    const enForme = (typeof esRect === 'function') && !esRect(z);
    const r = enForme
      ? new fabric.Path(pathZone(z, 1), { fill:hex })
      : new fabric.Rect({ left:z.x, top:z.y, width:z.w, height:z.h,
                          originX:'left', originY:'top', fill:hex });
    if (enForme) {
      const a = zonaRotacion(z), c = zonaCentro(z);
      r.set({ originX:'center', originY:'center', left:c.cx, top:c.cy, angle:a });
    }
    r.set({ selectable:false, evented:false });
    r.estFond = true; r.zoneId = z.id;
    canvas.add(r); canvas.sendToBack(r);
  }
  etat.fond[etat.vue] = hex || null;
  S.apresChangement();
}

/* ================================ PANNEAUX =============================== */
/* Ultimo objeto de cada tipo sobre el que actuar.
   Los botones del panel operan sobre esta referencia, no sobre la seleccion
   viva: asi un tap en el bottom-sheet (que en algunos navegadores roba el
   foco) no deja los botones sin objeto. Se limpia al seleccionar otro
   elemento o al borrarlo. */
let derniereImage = null, dernierTexte = null;

const imageCourante = () => {
  const o = canvas.getActiveObject();
  if (o && o.type === 'image') return o;
  return (derniereImage && canvas.getObjects().includes(derniereImage)) ? derniereImage : null;
};
const texteCourant = () => {
  const o = canvas.getActiveObject();
  if (S.estTexte(o)) return o;
  return (dernierTexte && canvas.getObjects().includes(dernierTexte)) ? dernierTexte : null;
};

function majPanneaux() {
  /* La zona puede haber cambiado: sus pestañas, primero. */
  majOngletsZone();
  const o = canvas.getActiveObject();
  const txt = S.estTexte(o), img = !!o && o.type === 'image';

  if (txt) dernierTexte = o;
  if (img) derniereImage = o;
  // si se selecciona otro tipo de objeto, la referencia del otro se olvida
  if (img) dernierTexte = null;
  if (txt) derniereImage = null;
  if (derniereImage && !canvas.getObjects().includes(derniereImage)) derniereImage = null;
  if (dernierTexte && !canvas.getObjects().includes(dernierTexte)) dernierTexte = null;

  /* BUG QUE ESTUVO ROMPIENDO LOS BOTONES:
     #photo-options y #texte-options nacen con class="inactif" en el HTML, que
     pone pointer-events:none. Solo se cambiaba `display`, asi que los botones
     quedaban grises y los clics no llegaban nunca. Hay que quitar la clase. */
  const actifTexte = !!texteCourant(), actifImage = !!imageCourante();

  $('#texte-options').style.display = actifTexte ? '' : 'none';
  $('#texte-options').classList.toggle('inactif', !actifTexte);
  $('#texte-indice').hidden = actifTexte;
  if (txt) majPanneauTexte(o);

  $('#photo-options').style.display = actifImage ? '' : 'none';
  $('#photo-options').classList.toggle('inactif', !actifImage);
  $('#photo-indice').hidden = actifImage;
  majPanneauSymboles();
  const o2 = imageCourante();
  const img2 = !!o2;
  if (img2) {
    const fait = !!o2.fondSupprime;
    /* Que se vea QUE YA SE HIZO. Antes el boton simplemente desaparecia y el
       panel quedaba como si nunca hubiera pasado nada. */
    if ($('#fond-fait')) $('#fond-fait').hidden = !fait;
    $('#btn-fond-photo').hidden = fait;
    $('#btn-fond-annuler').hidden = !fait;
    /* « Améliorer le détourage » solo tiene sentido si YA se detouro y con un
       modelo que no era el mejor: ofrecerlo despues del grande seria prometer
       algo que no va a cambiar. */
    $('#btn-fond-mieux').hidden =
      !fait || o2.modeleDetourage === FondIA.MODELE_MAX;
    majEtatIA();
    majEtatAmeliorer(o2);
  }
  /* La paleta se refresca con la seleccion, no solo cuando hay foto activa:
     si no hay ninguna, el bloque se esconde solo. */
  majPanneauCouleurs();
  if (o && o.zoneId && o.zoneId !== etat.zones[etat.vue]) {
    etat.zones[etat.vue] = o.zoneId; S.dessinerGuides(); S.majTexture(); S.construireVues();
  }
}

/* En movil el panel es una bottom-sheet que TAPA el producto, y cerrarlo era
   adivinanza: la X quedaba pequena al lado del asa. Tres salidas ahora, las
   tres naturales en un telefono: la X (ya con tamano de dedo por CSS),
   deslizar el asa hacia abajo, y tocar fuera del panel. */
function brancherFermetureMobile() {
  $$('.panneau').forEach(pan => {
    const tete = pan.querySelector('.panneau__tete');
    if (!tete) return;
    let y0 = null;
    tete.addEventListener('touchstart', e => {
      y0 = e.touches[0].clientY; pan.style.transition = 'none';
    }, { passive:true });
    tete.addEventListener('touchmove', e => {
      if (y0 === null) return;
      const dy = e.touches[0].clientY - y0;
      if (dy > 0) pan.style.transform = `translateY(${dy}px)`;
    }, { passive:true });
    tete.addEventListener('touchend', e => {
      if (y0 === null) return;
      const dy = (e.changedTouches[0] || {}).clientY - y0;
      pan.style.transition = ''; pan.style.transform = '';
      /* 70 px es el umbral tipico de una bottom-sheet: menos que eso es un
         toque torpe, no una intencion de cerrar. */
      if (dy > 70) fermerPanneaux();
      y0 = null;
    });
  });

  /* TOCAR FUERA CIERRA — tambien en escritorio.
     Antes solo valia en movil, con el argumento de que en escritorio el panel
     flota al lado y no estorba. Franklin: « cuando aplasto debajo de la imagen
     no desaparece el panel que esta abierto ». Y es verdad: el panel tapa el
     lado izquierdo de la escena y la unica forma de quitarlo era buscar la ✕.

     Lo que SI se conserva de aquel argumento: en escritorio, tocar el PRODUCTO
     no cierra nada. Ahi es donde se selecciona y se mueve, y cerrar el panel en
     cada clic seria justo el incordio que se queria evitar — se toca el texto
     para editarlo y se pierde el panel donde se edita.
     Tampoco cierran la barra de arriba ni la columna de la derecha: elegir una
     vista o una zona no es « he terminado con este panel ».
     En movil el panel es una hoja que tapa media pantalla, asi que ahi
     cualquier toque fuera sigue contando. */
  document.addEventListener('pointerdown', e => {
    const abierto = $$('.panneau').find(p => !p.hidden);
    if (!abierto) return;
    const t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    if (t.closest('.panneau, .onglet, .modale')) return;
    /* NO con esMobile(): mira el lado MAS CORTO de la ventana, y en un
       portatil ese es el alto — un MacBook da « movil » y las excepciones no
       se aplicaban nunca. Medido: con el panel abierto, tocar el producto lo
       cerraba igual. Lo que decide aqui es si el panel flota AL LADO, y eso
       es cuestion de ANCHO; es el mismo umbral que ya usa el resto. */
    if (matchMedia('(min-width: 900px)').matches
        && t.closest('.plateau, .cote, .barre, .apercu3d, .alertes')) return;
    fermerPanneaux();
  }, true);
}

function fermerPanneaux() {
  ['texte','photos','fond','formes','qr'].forEach(k => {
    const p = $('#panneau-' + k); if (p) p.hidden = true;
  });
  $$('.onglet').forEach(o => o.setAttribute('aria-selected', false));
}

function ouvrirPanneau(id) {
  const dejaOuvert = !$('#panneau-' + id).hidden;
  ['texte','photos','fond','formes','qr'].forEach(k => {
    const p = $('#panneau-' + k); if (p) p.hidden = true; });
  $$('.onglet').forEach(o => o.setAttribute('aria-selected', false));
  if (!dejaOuvert) {
    $('#panneau-' + id).hidden = false;
    $(`.onglet[data-panneau="${id}"]`).setAttribute('aria-selected', true);
    if (id === 'texte') { construireGenres(); construirePolices(); }
    if (id === 'photos') {
      construireRecentes();
      FondIA.precharger();   // que la descarga ocurra mientras el cliente mira
    }
    /* En el teléfono, el panel se recorre por pasos con « Suivant ». En el
       ordenador esta llamada no cambia nada: el asistente se apaga solo. */
    if (typeof ASISTENTE !== 'undefined') {
      ASISTENTE.activar('#panneau-' + id, { reiniciar: true });
    }
  }
}

/* ================================== PANIER =============================== */

/**
 * LAS VISTAS QUE FORMAN ESTA PIEZA — Y SÓLO ÉSAS.
 * -----------------------------------------------------------------------------
 * Franklin, con el cojín: « subí 2 productos que personalicé y se me subieron
 * 4 ». La ventana de « Votre personnalisation » pintaba TODAS las vistas del
 * producto —Devant, Modèle 1, 2, 3 y 4—, hubiera diseño en ellas o no, y
 * parecía un pedido de cinco cojines. Peor aún el fichero: un diseño que se
 * quedó en el Modèle 1 viajaba dentro de la línea del Modèle 2.
 *
 * En un producto por modelos cada modelo ES una pieza distinta, con su
 * variante de Shopify. Lo que se compra es el modelo elegido: sus vistas y las
 * que no están atadas a ninguno. Lo de los otros modelos se queda donde está,
 * para cuando el cliente vuelva a ellos y los añada.
 */
function vuesDeLaPieza() {
  const vues = (etat.produit && etat.produit.perso && etat.produit.perso.vues) || [];
  const porModelo = vues.filter(v => v.varianteId != null).length;
  if (porModelo < 2 || etat.variante == null) return vues;
  return vues.filter(v => v.varianteId == null
                       || String(v.varianteId) === String(etat.variante));
}

function construireJSON() {
  etat.designs[etat.vue] = canvas.toJSON(PROPS);
  const dpi = S.defauts().dpi || 300, pxPerCm = dpi / 2.54;
  const vues = vuesDeLaPieza().map(v => {
    const objets = ((etat.designs[v.id] || {}).objects) || [];
    const zones = (v.zones || []).map(z => {
      let dedans = objets.filter(o => o.zoneId === z.id && !o.estFond);
      /* baseImprimee: si el diseno base ya viene impreso en el producto
         fisico, el archivo lleva SOLO lo que anadio el cliente. Y un
         emplacement vacio es un hueco de plantilla, no contenido. */
      if (typeof MODELES !== 'undefined')
        dedans = MODELES.elementsAImprimer(dedans, etat.produit);
      const fond = (etat.fond[v.id]) || null;
      if (!dedans.length && !fond) return null;
      return {
        zone:z.id, nom:z.nom, cm:{ w:z.cmW, h:z.cmH },
        impressionPx:{ w:Math.round(z.cmW*pxPerCm), h:Math.round(z.cmH*pxPerCm) },
        /* El generador de impresion recorta a la forma real: sin esto un
           porte-cle redondo saldria como un cuadrado. */
        forme: z.forme || 'rect',
        /* Los seis puntos, si se ajustaron a mano. Sin esto el fichero de
           impresion recortaba el hexagono REGULAR y no el que se calibro. */
        sommets: z.sommets || null,
        radiusCm: z.radiusCm != null ? z.radiusCm : null,
        trou: z.trou || null,
        fond: fond,
        elements: dedans.map(o => elementJSON(o, z, pxPerCm)),
      };
    }).filter(Boolean);
    return zones.length ? { vue:v.id, nom:v.nom, zones } : null;
  }).filter(Boolean);

  return {
    version:2,
    /* `produit` describe LO QUE SE COMPRA. Talla y acabado van aqui y no en la
       raiz porque son atributos del articulo, no del diseno: en el punto 9 son
       exactamente lo que hay que casar con la variante de Shopify. Y el
       generador de impresion lee de aqui el acabado para saber si tiene que
       sacar ademas el fichero de laser. */
    produit:{ handle:etat.produit.handle, titre:etat.produit.titre,
              prix:etat.produit.prix, devise:etat.produit.devise,
              varianteId:etat.produit.varianteId,
              taille: etat.taille || null,
              finition: etat.finition || 'impression' },
    impression:{ dpi, pxPerCm:+pxPerCm.toFixed(4) },
    espaceMockup: S.defauts().mockupSize || 1024,
    vues,
  };
}

function elementJSON(o, z, pxPerCm) {
  const sx = o.scaleX || 1, sy = o.scaleY || 1;
  const w = o.width*sx, h = o.height*sy;
  const base = {
    type: (o.type === 'textbox' || o.type === 'i-text') ? 'texte' : 'image',
    centre:{ x:+((o.left-z.x)/z.w).toFixed(5), y:+((o.top-z.y)/z.h).toFixed(5) },
    taille:{ w:+(w/z.w).toFixed(5), h:+(h/z.h).toFixed(5) },
    tailleCm:{ w:+(w*z.cmW/z.w).toFixed(2), h:+(h*z.cmH/z.h).toFixed(2) },
    angle:+(o.angle||0).toFixed(2), miroir:{ x:!!o.flipX, y:!!o.flipY },
    opacite:o.opacity === undefined ? 1 : o.opacity,
  };

  /* Emplacement: el MARCO va normalizado a la zona, igual que el resto de
     coordenadas. El export lo necesita para recortar la foto al hueco; sin
     el, la foto saldria entera y desbordando la plantilla. */
  if (o.emplacement) {
    const m = o.emplacement;
    base.emplacement = {
      id: m.id || null, media: m.media || 'photo',
      forme: m.forme || 'rect',
      cadre: { x:+((m.x - z.x)/z.w).toFixed(5), y:+((m.y - z.y)/z.h).toFixed(5),
               w:+(m.w/z.w).toFixed(5),         h:+(m.h/z.h).toFixed(5) },
      rempli: !!o.emplacementRempli,
    };
    if (o.cadrage) base.cadrage = o.cadrage;
  }
  if (base.type === 'texte') {
    return Object.assign(base, {
      contenu:o.text, police:o.policeId || null, familleCss:o.fontFamily,
      couleur:o.fill, alignement:o.textAlign,
      graisse:o.fontWeight || 'normal', style:o.fontStyle || 'normal',
      espacementLettres:o.charSpacing || 0,
      contour:{ couleur:o.stroke || null, epaisseur:o.strokeWidth || 0,
                epaisseurCm:+(((o.strokeWidth||0)*sy)*z.cmH/z.h).toFixed(3) },
      tailleTexte:{ px1024:Math.round(o.fontSize*sy),
                    cm:+(o.fontSize*sy*z.cmH/z.h).toFixed(2),
                    pxImpression:Math.round(o.fontSize*sy*(z.cmH/z.h)*pxPerCm) },
    });
  }
  const cm = w*z.cmW/z.w;
  /* Ojo: aqui `o` es el objeto SERIALIZADO, sin _element. El tamano natural
     viene de source.natif, guardado al subir la foto. */
  const nat = (o.source && o.source.natif) || {};
  const natW = nat.w || o.width || 1;
  const natH = nat.h || o.height || 1;
  const ratio = o.source ? o.source.px.w / natW : 1;   // miniatura -> original
  const recadre = !!(o.cropX || o.cropY || o.width !== natW || o.height !== natH);

  /* DPI que se puede entregar DE VERDAD: si el original ya no esta (recarga
     de pagina), los unicos pixeles son los de la miniatura. Informar el DPI
     del original en ese caso seria mentir. */
  const original = o.source && o.source.idOriginal ? S.ORIGINALES.get(o.source.idOriginal) : null;
  const pxDisponibles = original ? (o.width * ratio) : o.width;
  const dpiReal = cm > 0 ? Math.round(pxDisponibles / cm * 2.54) : null;

  /* El QR viaja como RECETA: url + estilo. El generador de impresion lo
     rehace a 300 DPI en vez de estirar esta vista previa, que saldria con los
     modulos borrosos y dejaria de leerse. */
  if (o.qr) base.qr = Object.assign({}, o.qr);

  /* Un simbolo es GEOMETRIA, no pixeles: se guarda su id y su color y el
     generador lo redibuja a la resolucion de impresion. Estirar el bitmap del
     canvas daria un corazon de 8 cm con el borde dentado. */
  if (o.symbole) {
    base.type = 'forme';
    base.symbole = { id:o.symbole.id, couleur:o.symbole.couleur,
                     trait:!!o.symbole.trait,
                     epaisseur:o.strokeWidth || 0 };
  }

  return Object.assign(base, {
    source:{ px:o.source ? o.source.px : null, dataUrl:o.src || null,
             dataUrlOriginale: original || null,
             origineDisponible: !!original },
    fondSupprime: !!o.fondSupprime,
    /* Recorte en pixeles del ARCHIVO ORIGINAL: el export a 300 DPI recorta el
       original en alta resolucion, no esta miniatura. */
    recadrage: recadre ? {
      x: Math.round((o.cropX||0) * ratio),
      y: Math.round((o.cropY||0) * ratio),
      w: Math.round(o.width * ratio),
      h: Math.round(o.height * ratio),
    } : null,
    dpiEffectif: dpiReal,
    dpiSiOriginal: (o.source && cm > 0) ? Math.round(o.width * ratio / cm * 2.54) : null,
  });
}

function jsonLisible(d) {
  const c = JSON.parse(JSON.stringify(d));
  c.vues.forEach(v => v.zones.forEach(z => (z.elements||[]).forEach(e => {
    if (e.source && e.source.dataUrl) {
      const ko = Math.round(e.source.dataUrl.length*.75/1024);
      e.source.dataUrl = `«${e.source.dataUrl.slice(0,30)}… ${ko} Ko»`;
    }
  })));
  return JSON.stringify(c, null, 2);
}

/* crossOrigin ANTES del src, que es lo unico que importa del orden aqui.
   genererApercuPlat dibuja el mockup y luego hace toDataURL: sin CORS eso
   lanza SecurityError en cuanto el mockup vive en cdn.shopify.com. */
const chargerImage = src => new Promise((r,j) => {
  const i = new Image();
  i.crossOrigin = 'anonymous';
  i.onload = () => r(i); i.onerror = j; i.src = src; });

/* Para un producto con preview3D, el aperçu que cuenta es la TAZA, no el
   rectangulo plano: es lo que el cliente reconoce en el carrito y lo que hay
   que mandar a Cloudinary en el punto 9. Un wrap de 19 x 9 cm sobre fondo
   blanco no le dice nada a nadie. */
function apercu3DSiPossible(v) {
  /* Antes exigia `v.sansMockup`, y esa era la decision pendiente con Franklin.
     Queda resuelta: el 3D envuelve la ZONA de impresion, y da igual que su
     contenido venga de un gabarit en blanco o de una imagen de diseno usada
     como mockup —que es el caso de la taza Stitch, y ademas el bueno, porque
     asi la banda del prenom se coloca mirando el dibujo real. */
  if (!S.produitAvec3D()) return null;
  if (typeof TASSE3D === 'undefined' || !TASSE3D.instantane) return null;
  try { return TASSE3D.instantane(900); } catch (e) { return null; }
}

function genererApercu(v) {
  const t = apercu3DSiPossible(v);
  if (t) return Promise.resolve(t);
  return genererApercuPlat(v);
}

function genererApercuPlat(v) {
  return new Promise(async resolve => {
    const taille = S.defauts().mockupSize || 1024;
    const sc = new fabric.StaticCanvas(null, { width:taille, height:taille });
    const dessiner = async () => {
      const dpr = sc.lowerCanvasEl.width / taille, cote = Math.round(taille*dpr);
      const out = document.createElement('canvas'); out.width = out.height = cote;
      const ctx = out.getContext('2d');
      try { ctx.drawImage(await chargerImage(v.mockup), 0, 0, cote, cote); } catch(e){}
      /* En gravure el diseno va con el tono grabado, igual que en el editor.
         El filtro se aplica SOLO al diseno, no al mockup: el producto no se
         graba entero, se graba lo que el cliente puso. Sin esto el aperçu de
         « Continuer » — que es el que acaba viendo en el carrito — prometeria
         colores que el laser no puede hacer. */
      const grave = (etat.finition === 'gravure');
      if (grave) ctx.filter = S.FILTRE_GRAVURE;
      ctx.drawImage(sc.lowerCanvasEl, 0, 0, cote, cote);
      ctx.filter = 'none';

      /* Misma textura que en pantalla, recortada a cada zona y solo si el modo
         realista esta activo. NUNCA entra en el design JSON ni en el archivo de
         impresion: el DTF va siempre limpio. */
      if (etat.realiste && v.texture) { try {
        const tex = await chargerImage(v.texture);
        const k = cote / 1024;
        ctx.save();
        ctx.beginPath();
        (v.zones || []).forEach(z => ctx.rect(z.x*k, z.y*k, z.w*k, z.h*k));
        ctx.clip();
        ctx.globalCompositeOperation = 'soft-light';
        ctx.globalAlpha = (S.defauts().textureOpacite != null) ? S.defauts().textureOpacite : .15;
        ctx.drawImage(tex, 0, 0, cote, cote);
        ctx.restore();
        ctx.globalCompositeOperation = 'source-over';
        ctx.globalAlpha = 1;
      } catch(e){} }
      /* `toDataURL` codifica de forma SÍNCRONA: en un lienzo de 2000 × 2000
         eso son cientos de milisegundos con la interfaz congelada en un
         teléfono — el módulo ya lo sabía y por eso existe `_aDataUrl`, pero
         aquí no se usaba. */
      sc.dispose(); _aDataUrl(out, 'image/png').then(resolve);
    };
    const json = etat.designs[v.id];
    if (!json || !(json.objects||[]).length) { dessiner(); return; }
    sc.loadFromJSON(json, () => {
      sc.getObjects().forEach(o => {
        const z = S.zonePar(v.id, o.zoneId);
        if (z) o.clipPath = S.clipPour(z);

      });
      sc.renderAll(); dessiner();
    });
  });
}

/* ============================================================================
   EL APERÇU QUE VIAJA AL CARRITO PESA LO QUE TIENE QUE PESAR
   ----------------------------------------------------------------------------
   Franklin, en el móvil: « cuando pulso continuar / añadir al carrito, la
   transición tarda demasiado ». Medido en la tienda, con un solo texto y
   ninguna foto: 5,0 s de reloj, de los cuales **4,4 s eran UNA subida a
   Cloudinary** y 0,6 s el `/cart/add.js`. Guardar el proyecto no costaba nada
   —es local— y no había peticiones duplicadas.

   Lo que se subía: el aperçu, un PNG de 2000 × 2000 px. En el carrito se ve a
   90 px de ancho. O sea que el cliente esperaba cuatro segundos y medio para
   mandar veinte veces más píxeles de los que nadie va a mirar, y encima en
   PNG —sin pérdida— de una foto, que es el peor formato posible para una foto.

   Aquí se reduce a 900 px y JPEG de calidad 0,82 ANTES de subirlo. Sigue
   siendo el doble de lo que el carrito enseña, así que se ve nítido en una
   pantalla Retina, y pesa entre veinte y treinta veces menos.

   Ojo: esto NO toca el archivo de impresión ni las fotos originales del
   cliente, que siguen subiéndose en resolución completa. Es sólo la
   miniatura.
   ========================================================================== */
const APERCU_PANIER_PX = 900;
async function alegerApercu(dataUrl) {
  if (!dataUrl || !/^data:image\//.test(dataUrl)) return dataUrl;
  try {
    const im = await chargerImage(dataUrl);
    const lado = Math.max(im.naturalWidth || im.width, im.naturalHeight || im.height);
    if (!lado) return dataUrl;
    const k = Math.min(1, APERCU_PANIER_PX / lado);
    const c = document.createElement('canvas');
    c.width = Math.round((im.naturalWidth || im.width) * k);
    c.height = Math.round((im.naturalHeight || im.height) * k);
    const g = c.getContext('2d');
    /* El JPEG no tiene transparencia: sin fondo, lo que era transparente sale
       NEGRO. El aperçu del plano puede traerla en las esquinas. */
    g.fillStyle = '#ffffff'; g.fillRect(0, 0, c.width, c.height);
    g.imageSmoothingQuality = 'high';
    g.drawImage(im, 0, 0, c.width, c.height);
    return await _aDataUrl(c, 'image/jpeg', 0.82);
  } catch (e) {
    console.warn('[EDISAMP] aperçu sin aligerar', e);
    return dataUrl;
  }
}

async function ouvrirPanier() {
  /* Con piezas ya dentro, « Continuer » es ir a pagar. Antes abria siempre la
     ventana de vista previa, y desde ahi el cliente no tenia salida hacia el
     carrito mas que cerrarla y buscar el icono. */
  if (_enPanier > 0 && typeof PANIER !== 'undefined'
      && PANIER.dansLaBoutique && PANIER.dansLaBoutique()) {
    location.replace('/cart'); return;
  }
  const d = construireJSON();
  /* El JSON que se MUESTRA lleva los dataUrl elididos para poder leerlo. El
     completo se guarda aparte: copiarlo o generar el archivo de impresion
     desde el elidido perderia todas las fotos. */
  etat.jsonCompleto = d;
  $('#json').textContent = jsonLisible(d);
  $('#apercus').innerHTML = '<p class="aide">Génération de l’aperçu…</p>';
  /* El botón vuelve a ser el de añadir: si se llega aquí otra vez es porque
     hay algo nuevo que añadir, no porque haya que volver al carrito. */
  /* CON SU PRECIO. En el teléfono el precio de la barra se esconde para que
     « Continuer » quepa; aquí es donde el cliente decide, así que aquí se
     dice cuánto cuesta — en todas las pantallas. */
  const bp = $('#btn-panier');
  if (bp) {
    const u = etat.produit && etat.produit.prix, dv = (etat.produit && etat.produit.devise) || 'CHF';
    bp.textContent = (typeof u === 'number')
      ? `Ajouter au panier \u00B7 ${u.toFixed(2)} ${dv}` : 'Ajouter au panier';
    bp.onclick = () => ajouterAuPanier();
  }
  const pe = $('#panier-etat'); if (pe) pe.textContent = '';
  /* LO DE DENTRO NO ES DEL CLIENTE. « Copier le JSON complet », « Télécharger
     le fichier d’impression » y « Données techniques (JSON) » son
     herramientas de Franklin — quien compra una camiseta no tiene nada que
     hacer con un JSON. Franklin: « eso no tiene que tener el cliente ».
     En la tienda desaparecen; en local siguen, que es donde se usan. */
  /* Ni en la tienda ni en local: Franklin prueba en local COMO CLIENTE y
     tampoco las quiere ver ahí. Quien las necesite las abre con ?outils=1. */
  const av = $('#avance-studio');
  if (av) av.hidden = !new URLSearchParams(location.search).has('outils');
  $('#modale-panier').hidden = false;
  /* Se enseña lo que se compra: las vistas de esta pieza que llevan diseño.
     Si todavía no hay ninguna, la que se está mirando — que la ventana no se
     quede vacía. */
  const conDiseno = new Set((d.vues || []).map(x => x.vue));
  let aEnsenar = vuesDeLaPieza().filter(vue => conDiseno.has(vue.id));
  if (!aEnsenar.length) aEnsenar = vuesDeLaPieza().filter(vue => vue.id === etat.vue);
  const v = await Promise.all(aEnsenar.map(async vue => {
    const url = await genererApercu(vue);
    return `<figure class="apercu"><img src="${url}" alt="${vue.nom}">
            <figcaption>${vue.nom}</figcaption></figure>`;
  }));
  $('#apercus').innerHTML = v.join('');
}

/* ================================= EVENTS ================================ */
function brancher() {
  $$('.onglet').forEach(o => o.onclick = () => ouvrirPanneau(o.dataset.panneau));
  brancherFermetureMobile();
  brancherQR();
  brancherSymboles();
  brancherCouleursImage();
  if ($('#btn-panier')) $('#btn-panier').onclick = ajouterAuPanier;
  if ($('#btn-ameliorer')) $('#btn-ameliorer').onclick = ameliorerPhoto;
  if ($('#btn-fond-mieux')) $('#btn-fond-mieux').onclick = () => supprimerFondIA('large');
  $$('.modale').forEach(m => m.addEventListener('click', e => { if (e.target === m) m.hidden = true; }));

  $('#btn-produit').onclick = () => { construireListeProduits(); $('#modale-produits').hidden = false; };
  $('#btn-continuer').onclick = ouvrirPanier;

  /* AÑADIR SIN SALIR. El mismo ajouterAuPanier() de siempre; lo unico nuevo es
     que se llega a el sin abrir una ventana. Despues de anadir, la escena se
     deja LIMPIA para el siguiente: encadenar cuatro llaveros iguales seria
     imposible si el cuarto arrastrara el diseno del tercero, y borrarlo a mano
     elemento por elemento es lo que hace que se abandone el carrito. */
  /* Modo local: se dice en la barra Y en el boton. Ver el bandeau en
     index.html. En la tienda no se toca nada. */
  const enTienda = (typeof PANIER !== 'undefined')
                && PANIER.dansLaBoutique && PANIER.dansLaBoutique();
  if (!enTienda) {
    const bl = $('#bandeau-local'); if (bl) bl.hidden = false;
    const ba = $('#btn-ajouter-barre');
    if (ba) { ba.textContent = '+ Ajouter (simulation)';
              ba.title = 'Fuera de la tienda no se sube nada a Shopify.'; }
  }

  const bAjout = $('#btn-ajouter-barre');
  if (bAjout) bAjout.onclick = async () => {
    /* EL ESTADO TIENE QUE VERSE. La primera version escribia en
       `#panier-etat`, que vive DENTRO de la ventana de « Continuer »: pulsar
       el boton de la barra y que Cloudinary no estuviera configurado daba un
       mensaje perfectamente claro... en un sitio oculto. Desde fuera parecia
       un boton muerto. Ahora los avisos —y los « Envoi de vos photos 2/3 »—
       salen en el acuse flotante, que es lo que el cliente esta mirando. */
    const t = $('#toast-panier');
    t.innerHTML = '<span id="toast-msg">Ajout en cours…</span>';
    t.hidden = false;
    await ajouterAuPanier(bAjout, $('#toast-msg'));
    majBoutonsPanier();
  };
  majBoutonsPanier();
  $('#btn-annuler-h').onclick = S.annuler;
  $('#btn-refaire').onclick   = S.refaire;
  /* Delegacion en document: no depende de que los nodos existan al arrancar
     ni de que sobrevivan a un re-render. Un solo listener para todo. */
  document.addEventListener('click', e => {
    const b = e.target.closest && e.target.closest('button');
    if (!b) return;
    if (b.id === 'btn-confirmer') { e.preventDefault(); S.executerConfirmation(); return; }
    if (b.id === 'btn-refuser')   { e.preventDefault(); S.fermerConfirmer(); return; }
    if (b.hasAttribute('data-fermer-modale')) {
      const m = b.closest('.modale'); if (m) m.hidden = true; return;
    }
    if (b.hasAttribute('data-fermer-panneau')) {
      const pa = b.closest('.panneau'); if (pa) pa.hidden = true;
      $$('.onglet').forEach(o => o.setAttribute('aria-selected', false));
    }
  });

  /* APERÇU. En un producto plano sigue siendo lo de siempre: quitar guias y
     seleccion para ver el diseno limpio. En un producto con 3D, lo que el
     cliente quiere comprobar es la TAZA — « que aparezca como un popup para
     mostrar la taza, para que lo pueda girar y vea todos los detalles en
     grande ». */
  const boiteApercu  = $('#apercu-grand');
  const modaleApercu = $('#modale-apercu');
  let _sitio3D = null;          // de donde salio el visor, para devolverlo

  function ouvrirApercu3D() {
    const vis = $('#apercu3d');
    if (!vis || !boiteApercu) return false;
    /* Se MUEVE el visor, no se crea otro: dos contextos WebGL a la vez son el
       doble de memoria y un bucle de dibujo de mas en un movil. */
    if (!_sitio3D) _sitio3D = { padre: vis.parentNode, antes: vis.nextSibling };
    vis.hidden = false;
    boiteApercu.appendChild(vis);
    modaleApercu.hidden = false;
    document.body.classList.add('modale-ouverte');
    /* El renderer mide su contenedor al crearse: sin esto sale del tamano
       viejo, el de la columna, y aparece diminuto en la ventana. */
    if (typeof TASSE3D !== 'undefined') {
      TASSE3D.redimensionner(); TASSE3D.majTexture(true);
    }
    return true;
  }

  function fermerApercu3D() {
    const vis = $('#apercu3d');
    if (modaleApercu) modaleApercu.hidden = true;
    document.body.classList.remove('modale-ouverte');
    if (vis && _sitio3D && _sitio3D.padre) {
      _sitio3D.padre.insertBefore(vis, _sitio3D.antes);
      if (typeof TASSE3D !== 'undefined') TASSE3D.redimensionner();
    }
  }

  /* ---------------------------------------------------- CREATE → MADE ---
     Antes esto escondía los controles y ya. El cliente no percibía haber
     terminado de crear: sólo veía menos botones.

     Ahora hay una secuencia, y el orden ES el significado. Lo único que NO
     se mueve es el diseño: toda la animación vive en la escena, nunca en los
     objetos del lienzo. El estampado que se ve al final es exactamente el que
     se va a imprimir.

     Las duraciones salen de los tokens. Si el sistema cambia una, esto cambia
     con él en vez de quedarse con un número viejo escrito aquí. */
  const _ms = (nombre, porDefecto) => {
    const v = getComputedStyle(document.documentElement)
      .getPropertyValue(nombre).trim();
    if (!v) return porDefecto;
    return v.endsWith('ms') ? parseFloat(v) : parseFloat(v) * 1000;
  };
  const _espera = (ms) => new Promise(r => setTimeout(r, ms));

  let _materializando = false;

  async function materialiser() {
    if (_materializando) return;
    _materializando = true;
    const body = document.body;

    // 1-2. Las herramientas se retiran y se sueltan asas, guías y zona segura.
    body.dataset.made = 'out';
    etat.apercu = true;
    body.classList.add('apercu');
    canvas.discardActiveObject();
    S.dessinerGuides();
    canvas.requestRenderAll();
    await _espera(_ms('--motion-panel', 400));

    // 3. El diseño se asienta.
    body.dataset.made = 'settle';
    await _espera(_ms('--motion-enter', 600) * 0.55);

    /* 4. La materia vuelve. La textura del tejido estaba apagada en aperçu;
       encenderla aquí es, literalmente, el estampado integrándose en la tela
       — y es además lo que la prenda hace de verdad. */
    etat.apercu = false;
    S.majTexture();
    etat.apercu = true;

    // 5. Profundidad y la cámara un punto más cerca.
    body.dataset.made = 'done';
    canvas.requestRenderAll();

    /* Y AQUÍ deja de ser « el editor sin controles » y pasa a ser un sitio:
       el producto terminado, con las dos decisiones a la vista. Retirar las
       herramientas no es un estado; esto sí. */
    if (typeof ETAPE_PRODUIT !== 'undefined') ETAPE_PRODUIT.entrer(_datosEtape());

    if (typeof EVENEMENTS !== 'undefined') {
      EVENEMENTS.emitir(EVENEMENTS.TIPOS.DESIGN_PREVIEWED, {
        designId: (typeof CREATION !== 'undefined') ? CREATION.idActual() : null,
        productHandle: etat.produit ? etat.produit.handle : null,
        meta: { engine: 'APPAREL' },
      });
    }
    _materializando = false;
  }

  /* Lo que el estado producto necesita saber, en un solo sitio. */
  function _datosEtape() {
    const vues = (etat.produit && etat.produit.perso && etat.produit.perso.vues) || [];
    return {
      vues: vues.map(v => ({ id: v.id, nom: v.nom })),
      vueActive: etat.vue,
      conDiseno: (id) => S.nbElements(id) > 0,
    };
  }

  function revenirEditeur() {
    const body = document.body;
    if (typeof ETAPE_PRODUIT !== 'undefined') ETAPE_PRODUIT.sortir();
    delete body.dataset.made;
    etat.apercu = false;
    body.classList.remove('apercu');
    S.dessinerGuides(); S.majTexture(); canvas.requestRenderAll();
  }

  /* Inspeccionar NO es editar. Cambiar de cara aquí mira la otra parte de la
     prenda: `changerVue` ya guarda lo de la cara que se deja y carga lo de la
     que se abre, así que el diseño no se toca. Lo único que se añade es
     repintar el selector para que el punto y el estado marcado sigan siendo
     ciertos. */
  function inspecterVue(id) {
    if (id === etat.vue) return;
    S.changerVue(id);
    setTimeout(() => {
      if (typeof ETAPE_PRODUIT !== 'undefined') ETAPE_PRODUIT.majVues(_datosEtape());
    }, 60);
  }

  $('#btn-apercu').onclick = () => {
    /* Un producto con 3D ya tiene su materialización: la taza en volumen. Es
       el mismo momento contado en el idioma de ese motor. */
    if (S.produitAvec3D() && ouvrirApercu3D()) {
      if (typeof EVENEMENTS !== 'undefined') {
        EVENEMENTS.emitir(EVENEMENTS.TIPOS.DESIGN_PREVIEWED, {
          designId: (typeof CREATION !== 'undefined') ? CREATION.idActual() : null,
          productHandle: etat.produit ? etat.produit.handle : null,
          meta: { engine: 'CYLINDRICAL' },
        });
      }
      return;
    }
    const enMade = !!document.body.dataset.made;
    $('#btn-apercu').classList.toggle('btn--actif', !enMade);
    if (enMade) revenirEditeur(); else materialiser();
  };

  // Volver al editor sin buscar el botón.
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && document.body.dataset.made) {
      $('#btn-apercu').classList.remove('btn--actif');
      revenirEditeur();
    }
  });

  if (typeof ETAPE_PRODUIT !== 'undefined') {
    ETAPE_PRODUIT.monter({
      modifier: () => {
        $('#btn-apercu').classList.remove('btn--actif');
        revenirEditeur();
      },
      /* Una sola puerta al carrito: la que ya existe. No hay un segundo
         camino que pueda divergir del primero. */
      ajouterAuPanier: () => { ajouterAuPanier(); },
      inspecterVue,
      creerVariante: (typeof CREATION !== 'undefined' && CREATION.disponible())
        ? async () => {
            const copia = await S.creerVariante();
            if (!copia) { ETAPE_PRODUIT.noter('Variante impossible'); return; }
            const n = CREATION.versiones(etat.produit.handle).length;
            /* Se dice, y se dice donde ya estaba mirando: seguir diseñando sin
               saber que ahora se está en otra creación es peor que no tener
               variantes. */
            ETAPE_PRODUIT.noter(`Variante créée · version ${n}`);
          }
        : null,
    });
  }

  S.materialiser = materialiser;
  S.revenirEditeur = revenirEditeur;
  S.inspecterVue = inspecterVue;
  S.datosEtape = _datosEtape;

  /* Cerrar: la cruz, el fondo y Escape. Las tres, porque en un movil la cruz
     es el unico gesto evidente y en escritorio nadie la busca. */
  modaleApercu && modaleApercu.addEventListener('click', e => {
    if (e.target === modaleApercu || e.target.closest('[data-fermer-modale]'))
      fermerApercu3D();
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && modaleApercu && !modaleApercu.hidden) fermerApercu3D();
  });

  /* El boton ya no existe en la interfaz del cliente. Se conserva el enganche
     por si vuelve en el admin o en un modo de prueba: sin la guarda, un $()
     que devuelve null aqui reventaria TODO el arranque del Studio. */
  const btnRealiste = $('#btn-realiste');
  if (btnRealiste) btnRealiste.onclick = () => {
    etat.realiste = !etat.realiste;
    btnRealiste.classList.toggle('btn--actif', etat.realiste);
    btnRealiste.setAttribute('aria-pressed', etat.realiste);
    S.majTexture();
  };

  $('#zoom-plus').onclick  = () => S.appliquerZoom(etat.zoom + .1);
  $('#zoom-moins').onclick = () => S.appliquerZoom(etat.zoom - .1);
  $('#zoom-val').onclick   = () => S.appliquerZoom(1);

  // --- texte ---
  $('#btn-ajouter-texte').onclick = ajouterTexte;
  $('#txt-contenu').oninput = () => {
    const o = canvas.getActiveObject();
    if (S.estTexte(o)) { o.set({ text: $('#txt-contenu').value }); S.apresChangement(); }
  };
  $('#txt-recherche').oninput = () => {
    rechercheTexte = $('#txt-recherche').value.trim().toLowerCase(); construirePolices();
  };
  $('#txt-taille').oninput = () => appliquerTexte({ fontSize: +$('#txt-taille').value });
  $('#txt-moins').onclick  = () => appliquerTexte({ fontSize: Math.max(8, (canvas.getActiveObject()||{}).fontSize - 4) });
  $('#txt-plus').onclick   = () => appliquerTexte({ fontSize: Math.min(240, (canvas.getActiveObject()||{}).fontSize + 4) });
  $('#txt-gras').onclick     = () => { const o = canvas.getActiveObject(); if (S.estTexte(o)) appliquerTexte({ fontWeight: o.fontWeight === 'bold' ? 'normal':'bold' }); };
  $('#txt-italique').onclick = () => { const o = canvas.getActiveObject(); if (S.estTexte(o)) appliquerTexte({ fontStyle: o.fontStyle === 'italic' ? 'normal':'italic' }); };
  $('#txt-gauche').onclick = () => appliquerTexte({ textAlign:'left' });
  $('#txt-centre').onclick = () => appliquerTexte({ textAlign:'center' });
  $('#txt-droite').onclick = () => appliquerTexte({ textAlign:'right' });
  $('#txt-espacement').oninput = () => appliquerTexte({ charSpacing: +$('#txt-espacement').value });
  $('#txt-contour').oninput = () => appliquerTexte({
    strokeWidth:+$('#txt-contour').value, stroke:$('#txt-contour-couleur').value });
  $('#txt-contour-couleur').oninput = () => appliquerTexte({ stroke:$('#txt-contour-couleur').value });

  // --- photos ---
  $('#btn-ouvrir-depot').onclick = () => { construireRecentes(); majConseilPhoto();
                                           $('#modale-depot').hidden = false; };
  $('#fichier').onchange = async e => {
    const f = e.target.files[0]; if (f) await ajouterFichier(f); e.target.value = '';
  };
  const dep = $('#depot');
  ['dragenter','dragover'].forEach(t => dep.addEventListener(t, e => {
    e.preventDefault(); dep.classList.add('depot--survol'); }));
  ['dragleave','drop'].forEach(t => dep.addEventListener(t, e => {
    e.preventDefault(); dep.classList.remove('depot--survol'); }));
  dep.addEventListener('drop', async e => {
    const f = (e.dataTransfer.files || [])[0]; if (f) await ajouterFichier(f);
  });
  /* Delegacion, como en el modal: no depende de que el nodo siga siendo el
     mismo tras un re-render del panel. */
  document.addEventListener('click', e => {
    const b = e.target.closest && e.target.closest('button');
    if (!b || b.disabled) return;
    switch (b.id) {
      case 'btn-fond-photo':   supprimerFondIA(); break;
      case 'btn-fond-annuler': annulerFondIA(); break;
      case 'btn-recadrer':     entrerRecadrage(imageCourante()); break;
      case 'photo-dupliquer':  dupliquerObjet(imageCourante()); break;
      case 'txt-dupliquer':    dupliquerObjet(texteCourant()); break;
      case 'photo-supprimer':  supprimerObjet(imageCourante()); break;
      case 'txt-supprimer':    supprimerObjet(texteCourant()); break;
      case 'recadre-ok':       sortirRecadrage(true); break;
      case 'recadre-non':      sortirRecadrage(false); break;
    }
  });

  FondIA.surEtat(() => majEtatIA());
  $('#travail-annuler').onclick = () => { _travailAnnule = true; cacherTravail(); };

  // --- fond ---
  $('#fond-libre').oninput = () => {
    const c = $('#fond-libre').value;
    /* La pastilla es lo unico que el cliente ve del selector: si no se
       actualiza, no hay ninguna senal de que su eleccion se aplico. */
    const p = $('#fond-libre-vue'); if (p) p.style.background = c;
    appliquerFond(c);
  };
  $('#fond-aucun').onclick = () => appliquerFond(null);

  // --- canvas ---
  ['selection:created','selection:updated','selection:cleared'].forEach(e =>
    canvas.on(e, majPanneaux));
  /* ARRASTRAR TIENE QUE IR SUAVE. Franklin: « mueve como tres centímetros
     para arriba, cuatro para la derecha, no es un movimiento fluido y eso me
     molesta mucho ». No era el ratón ni la escala: `majAlertes()` vacía y
     REHACE la caja de avisos —`innerHTML=''` y a construir nodos—, y estaba
     enganchada a cada `object:moving`. Un trackpad manda más de cien de esos
     por segundo; cada uno forzaba un recálculo de estilo y un pintado, el
     hilo se quedaba sin aire y el dibujo aparecía a saltos, lejos del dedo.
     Ahora se pide UNA por cuadro de imagen: los avisos siguen al día —60
     veces por segundo es más de lo que se puede leer— y el arrastre recupera
     los fotogramas que le faltaban. */
  let _avisoEnCola = false;
  const avisosPorCuadro = () => {
    if (_avisoEnCola) return;
    _avisoEnCola = true;
    requestAnimationFrame(() => { _avisoEnCola = false; S.majAlertes(); });
  };
  ['object:moving','object:scaling','object:rotating','object:resizing'].forEach(e =>
    canvas.on(e, avisosPorCuadro));
  /* Al soltar, la última palabra sin esperar a nadie. */
  canvas.on('mouse:up', () => { if (_avisoEnCola) return; S.majAlertes(); });
  canvas.on('object:modified', e => {
    const o = e.target; if (!o) return;
    if (S.estTexte(o) && (o.scaleX !== 1 || o.scaleY !== 1)) {
      o.set({ fontSize: Math.round(o.fontSize*o.scaleY), scaleX:1, scaleY:1 });
      o.setCoords(); majPanneauTexte(o);
    }
    S.apresChangement();
  });
  canvas.on('text:changed', () => {
    const o = canvas.getActiveObject();
    if (o) $('#txt-contenu').value = o.text;
    S.apresChangement();
  });

  // tope de ancho dentro del actionHandler (no despues: Fabric reancla)
  const cu = fabric.controlsUtils;
  if (cu && cu.changeWidth && cu.wrapWithFixedAnchor) {
    const bride = (ev, tr, x, y) => {
      const ch = cu.changeWidth(ev, tr, x, y);
      const z = S.zonePar(etat.vue, tr.target.zoneId);
      if (z && tr.target.width > largeurTexte(z)) tr.target.set('width', largeurTexte(z));
      return ch;
    };
    const ancre = cu.wrapWithFixedAnchor(bride);
    ['ml','mr'].forEach(id => {
      const base = fabric.Textbox.prototype.controls[id]; if (!base) return;
      const c = Object.create(base); c.actionHandler = ancre;
      fabric.Textbox.prototype.controls[id] = c;
    });
  }

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      if (recadrage) { sortirRecadrage(false); return; }
      $$('.modale').forEach(m => m.hidden = true); return;
    }
    const mod = e.metaKey || e.ctrlKey;
    if (mod && e.key.toLowerCase() === 'z') {
      e.preventDefault(); e.shiftKey ? S.refaire() : S.annuler(); return;
    }
    if (e.key === 'Delete' || e.key === 'Backspace') {
      const o = canvas.getActiveObject();
      if (o && !o.isEditing) { e.preventDefault(); supprimerSelection(); }
    }
  });

  /* Doble tap para editar texto. Fabric solo trae doble CLIC; con el dedo no
     llega nunca, asi que lo detectamos a mano. */
  /* Doble clic / doble tap:
       - sobre TEXTO  -> editar (comportamiento de siempre)
       - sobre IMAGEN -> modo recorte
     Fabric solo trae doble CLIC; con el dedo hay que detectarlo a mano. */
  function doubleAction(cible) {
    if (!cible || recadrage) return;
    if (S.estTexte(cible)) {
      cible.enterEditing();
      if (cible.selectAll) cible.selectAll();
      canvas.requestRenderAll();
    } else if (cible.type === 'image') {
      entrerRecadrage(cible);
    }
  }
  canvas.on('mouse:dblclick', opt => doubleAction(opt.target));

  let dernierTap = 0;
  canvas.on('mouse:down', opt => {
    const t = Date.now();
    if (t - dernierTap < 320) doubleAction(opt.target);
    dernierTap = t;
  });

  /* El teclado movil encoge visualViewport sin cambiar innerHeight: el
     bottom-sheet quedaria debajo del teclado. Le damos su altura real y
     escondemos los rieles mientras se escribe. */
  if (window.visualViewport) {
    const vv = window.visualViewport;
    const majClavier = () => {
      const cache = window.innerHeight - vv.height;
      const ouvert = cache > 140;
      document.body.classList.toggle('clavier', ouvert);
      document.documentElement.style.setProperty(
        '--vh-panneau', Math.max(180, Math.round(vv.height * 0.55)) + 'px');
    };
    vv.addEventListener('resize', majClavier);
    vv.addEventListener('scroll', majClavier);
    majClavier();
  }

  /* Asa del bottom-sheet: arrastrar hacia abajo lo cierra */
  document.addEventListener('touchstart', e => {
    const tete = e.target.closest && e.target.closest('.panneau__tete');
    if (!tete || innerWidth > 900) return;
    const pan = tete.closest('.panneau');
    const y0 = e.touches[0].clientY;
    const bouger = ev => {
      const d = ev.touches[0].clientY - y0;
      if (d > 0) pan.style.transform = `translateY(${d}px)`;
    };
    const finir = ev => {
      const d = (ev.changedTouches[0].clientY - y0);
      pan.style.transform = '';
      if (d > 70) {
        pan.hidden = true;
        $$('.onglet').forEach(o => o.setAttribute('aria-selected', false));
      }
      document.removeEventListener('touchmove', bouger);
      document.removeEventListener('touchend', finir);
    };
    document.addEventListener('touchmove', bouger, { passive:true });
    document.addEventListener('touchend', finir);
  }, { passive:true });

  /* `plateau` es del bloque 1. Aqui funcionaba de milagro: un elemento con
     id="plateau" se cuela como variable global del navegador, asi que el
     nombre resolvia por accidente. El dia que ese id cambiara, el pinch del
     movil dejaria de existir sin un solo error. Se coge del puente. */
  const plateau = S.plateau;

  /* --- rueda y trackpad, en el escritorio ------------------------------
     El pellizco de un trackpad de Mac llega como `wheel` con ctrlKey: ése es
     el zoom. La rueda o el deslizamiento de dos dedos, sin ctrl, DESPLAZA —
     que es lo natural y lo que evita que la página entera se mueva debajo. */
  const escena = plateau.parentElement || plateau;
  escena.addEventListener('wheel', e => {
    if (!etat.produit) return;
    e.preventDefault();
    const r = plateau.getBoundingClientRect();
    /* el puntero, en coordenadas del contenedor y sin el pan ya aplicado */
    const centro = {
      x: e.clientX - r.left + (etat.pan ? etat.pan.x : 0),
      y: e.clientY - r.top + (etat.pan ? etat.pan.y : 0),
    };
    if (e.ctrlKey || e.metaKey) {
      S.appliquerZoom(etat.zoom * (1 - e.deltaY * 0.01), centro);
    } else {
      S.deplacerPlateau(-e.deltaX, -e.deltaY);
    }
  }, { passive: false });

  /* --- arrastrar para mover -------------------------------------------
     Con la barra espaciadora, o arrastrando en el hueco de alrededor del
     producto. Sobre el producto manda Fabric: ahí el arrastre mueve el
     dibujo, que es lo que el cliente espera. */
  let arrastre = null, espacio = false;
  window.addEventListener('keydown', e => {
    if (e.code === 'Space' && !/^(INPUT|TEXTAREA)$/.test((e.target.tagName || ''))) {
      espacio = true; escena.style.cursor = 'grab'; e.preventDefault();
    }
  });
  window.addEventListener('keyup', e => {
    if (e.code === 'Space') { espacio = false; escena.style.cursor = ''; }
  });
  escena.addEventListener('pointerdown', e => {
    const sobreLienzo = e.target.closest && e.target.closest('.canvas-container');
    if (!espacio && sobreLienzo) return;      // ahí trabaja Fabric
    arrastre = { x: e.clientX, y: e.clientY };
    escena.setPointerCapture && escena.setPointerCapture(e.pointerId);
    escena.style.cursor = 'grabbing';
  });
  escena.addEventListener('pointermove', e => {
    if (!arrastre) return;
    S.deplacerPlateau(e.clientX - arrastre.x, e.clientY - arrastre.y);
    arrastre = { x: e.clientX, y: e.clientY };
  });
  const soltar = () => { arrastre = null; escena.style.cursor = espacio ? 'grab' : ''; };
  escena.addEventListener('pointerup', soltar);
  escena.addEventListener('pointercancel', soltar);

  /* --- DOS DEDOS: ACERCAR Y MOVER A LA VEZ, como en Fotos ----------------
     Franklin, en el iPhone: « tengo que hacer con los dos dedos y solamente
     puedo acercar y alejar, no puedo mover la imagen a derecha o izquierda ».
     El pellizco sólo cambiaba el zoom, y siempre hacia el centro: una vez
     cerca, no había forma de ir a la esquina donde estaba escribiendo.
     Ahora el zoom va hacia el punto medio de los dedos y, si los dedos se
     desplazan juntos, el lienzo se desplaza con ellos.
     Y mientras hay dos dedos, el dibujo seleccionado se queda QUIETO: Fabric
     sigue al primer dedo como si fuera un ratón, y sin esto mover el lienzo
     arrastraba de paso el texto. */
  let g0 = null, bloqueado = null;
  const dist = t => Math.hypot(t[0].clientX-t[1].clientX, t[0].clientY-t[1].clientY);
  const medio = t => ({ x:(t[0].clientX+t[1].clientX)/2, y:(t[0].clientY+t[1].clientY)/2 });
  plateau.addEventListener('touchstart', e => {
    if (e.touches.length !== 2) return;
    g0 = { d: dist(e.touches), m: medio(e.touches) };
    const o = canvas.getActiveObject();
    if (o && !bloqueado) {
      bloqueado = { o, left:o.left, top:o.top, lx:o.lockMovementX, ly:o.lockMovementY };
      o.lockMovementX = o.lockMovementY = true;
    }
  }, { passive:true });
  plateau.addEventListener('touchmove', e => {
    if (e.touches.length !== 2 || !g0) return;
    e.preventDefault();                       // que no se mueva la página debajo
    const d = dist(e.touches), m = medio(e.touches);
    const r = plateau.getBoundingClientRect();
    const centro = { x: m.x - r.left + (etat.pan ? etat.pan.x : 0),
                     y: m.y - r.top  + (etat.pan ? etat.pan.y : 0) };
    if (Math.abs(d - g0.d) > 0.5) S.appliquerZoom(etat.zoom * (d / g0.d), centro);
    S.deplacerPlateau(m.x - g0.m.x, m.y - g0.m.y);
    g0 = { d, m };
  }, { passive:false });
  const finDedos = e => {
    if (e.touches && e.touches.length >= 2) return;
    g0 = null;
    if (bloqueado) {
      const b = bloqueado; bloqueado = null;
      /* Si el primer dedo lo llegó a mover antes de bloquearlo, vuelve. */
      b.o.set({ left:b.left, top:b.top, lockMovementX:b.lx, lockMovementY:b.ly });
      b.o.setCoords(); canvas.requestRenderAll();
    }
  };
  plateau.addEventListener('touchend', finDedos);
  plateau.addEventListener('touchcancel', finDedos);

  window.addEventListener('resize', S.majEchelleControles);
  if (window.ResizeObserver) new ResizeObserver(S.majEchelleControles).observe(plateau);
}

/**
 * Duplicar un elemento.
 *
 * Es lo que quita el miedo a probar: « pongo otro igual aquí y comparo » en
 * vez de « lo muevo y a ver si sé volver ».
 *
 * Tres cosas que importan:
 *   · identidad NUEVA. Copiar el id dejaría dos objetos que el modelo, los
 *     bloqueos y la zona tratarían como el mismo.
 *   · un desplazamiento pequeño, o la copia queda debajo y parece que no ha
 *     pasado nada.
 *   · entra en el historial, así que deshacer la revierte. Sin eso, duplicar
 *     sería la única acción del editor de la que no se puede volver.
 *
 * La foto NO se copia: el clon apunta al MISMO original en el Map. Duplicar
 * una imagen de móvil duplicaría varios megas en memoria por nada.
 */
function dupliquerObjet(o) {
  if (!o || o.locked) return;
  o.clone((copia) => {
    copia.set({
      left: (o.left || 0) + 18,
      top: (o.top || 0) + 18,
      /* Identidad propia. `zoneId` sí se hereda: la copia vive en la misma
         zona de impresión que el original. */
      id: undefined,
      evented: true,
    });
    if (copia.set && o.zoneId) copia.zoneId = o.zoneId;
    // El original de la foto se comparte, no se duplica.
    if (o.idOriginal != null) copia.idOriginal = o.idOriginal;

    const z = S.zonePar(etat.vue, copia.zoneId);
    if (z) copia.clipPath = S.clipPour(z);

    canvas.add(copia);
    canvas.setActiveObject(copia);
    S.apresChangement();
    majPanneaux();
  }, ['zoneId', 'idOriginal', 'estFond', 'verrous', 'emplacementId']);
}

function supprimerObjet(o) {
  if (!o) return;
  canvas.setActiveObject(o);
  supprimerSelection();
}

function supprimerSelection() {
  const o = canvas.getActiveObject(); if (!o) return;
  canvas.remove(o); canvas.discardActiveObject();
  S.apresChangement(); majPanneaux();
}

window.__panneaux = { maj: majPanneaux };

/* ================================== INIT ================================= */
function init() {
  brancher();
  S.majEchelleControles();
  S.appliquerZoom(1);
  /* Red de seguridad: pase lo que pase, la pantalla de arranque no puede
     quedarse tapando el Studio para siempre. */
  setTimeout(() => { try { fermerDemarrage(); } catch (e) {} }, 12000);
  demarrer().catch(e => {
    console.error(e);
    fermerDemarrage();
    $('#nom-produit').textContent = 'Erreur de chargement';
    alert('Le studio n\u2019a pas pu charger le catalogue. Vérifiez votre connexion '
        + 'et rechargez la page.');
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();

/* ------------- C · JSON completo y archivo de impresion directo ----------- */
/* Sin copiar y pegar: el Studio ya tiene el diseno en memoria, con las fotos
   originales. Pasar por el portapapeles perdia las imagenes. */
$('#btn-copier-json').onclick = async () => {
  const el = $('#etat-impression-studio');
  if (!etat.jsonCompleto) { el.textContent = 'Aucun design à copier.'; return; }
  const texto = JSON.stringify(etat.jsonCompleto);
  try {
    await navigator.clipboard.writeText(texto);
    el.textContent = `JSON complet copié (${Math.round(texto.length/1024)} ko, photos incluses).`;
  } catch (e) {
    /* Sin permiso de portapapeles (Safari sin gesto directo): se ofrece
       descargar en vez de dejar al cliente sin salida. */
    const b = new Blob([texto], { type:'application/json' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(b); a.download = 'design.json'; a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 1000);
    el.textContent = 'Presse-papiers indisponible : le JSON a été téléchargé.';
  }
};

$('#btn-fichier-impression').onclick = async () => {
  const el = $('#etat-impression-studio');
  if (!etat.jsonCompleto) { el.textContent = 'Aucun design à imprimer.'; return; }
  if (typeof IMPRESSION === 'undefined') { el.textContent = 'Module d\u2019impression indisponible.'; return; }
  el.textContent = 'Génération du fichier d\u2019impression…';
  try {
    const { fichiers } = await IMPRESSION.generer(etat.jsonCompleto);
    if (!fichiers.length) { el.textContent = 'Aucune zone à imprimer.'; return; }
    for (const f of fichiers) await IMPRESSION.descargar(f.canvas, f.nom);
    const avisos = [...new Set(fichiers.flatMap(f => f.avisos))];
    el.textContent = `${fichiers.length} fichier(s) à 300 DPI téléchargé(s)`
      + (avisos.length ? ' — ' + avisos.join(' ') : '.');
  } catch (e) {
    el.textContent = 'Échec : ' + e.message;
  }
};

/* ============================== F5 · SYMBOLES ============================
   Formas vectoriales para el cliente. Ver `symboles.js` para el porque de
   paths y no imagenes.

   Se colocan como `fabric.Path`: se escalan sin perder filo, se recolorean sin
   tocar pixeles, y el export los REDIBUJA desde el catalogo a la resolucion de
   impresion — igual que el QR, y por la misma razon.
   ======================================================================== */
let _symFamille = null;
let _symCouleur = null;

const symboleCourant = () => {
  const o = canvas.getActiveObject();
  return (o && o.symbole) ? o : null;
};

function couleursDuProduit() {
  const c = (etat.produit && etat.produit.perso && etat.produit.perso.couleurs) || [];
  return c.length ? c : ['#222D52', '#D2B68A', '#FFFFFF', '#111111'];
}

/* Luminancia 0..255 de un #rrggbb, para saber si un color se vera sobre el
   panel claro. Los pesos son los de siempre: el ojo ve mucho mas el verde. */
function _luma(hex) {
  const m = /^#?([0-9a-f]{6})$/i.exec(String(hex || ''));
  if (!m) return 128;
  const n = parseInt(m[1], 16);
  return 0.2126 * ((n >> 16) & 255) + 0.7152 * ((n >> 8) & 255) + 0.0722 * (n & 255);
}

/* COLOR DE PARTIDA DE UNA FORMA NUEVA. Era `couleursDuProduit()[0]`, y en el
   porte-cles ese primer color es el BLANCO: la forma se colocaba blanca sobre
   un acrilico blanco y parecia que no habia pasado nada. Se coge el primero
   que se vea; si la ficha solo trae claros, negro. */
/* LAS FORMAS EMPIEZAN EN NEGRO. Franklin: « si empieza con blanco y nuestro
   fondo es beige, no se ve casi nada ». Antes se cogía el primer color del
   producto que no fuera muy claro, y en una ficha cuyo primer color es el
   blanco la forma nacía blanca sobre beige: invisible.
   Negro salvo que la prenda sea oscura de verdad —ahí el negro tampoco se
   vería—, y en ese caso blanco. El cliente lo cambia en un toque justo
   debajo. */
/* LA PRENDA SE MIDE EN SU FOTO, NO SE DEDUCE DE LA PALETA.
   Esto miraba `couleursDuProduit()[0]`, y esos colores son LAS TINTAS que el
   cliente puede elegir, no el color de la camiseta. Para la camiseta negra la
   primera tinta de la ficha es el BLANCO, así que la regla concluía « fondo
   claro » y la forma nacía NEGRA sobre una camiseta NEGRA: invisible, que es
   justo lo que había que evitar. Medido en la zona de impresión de esa foto,
   la luminancia real es 27 sobre 255.
   Así que se muestrea la foto dentro de la zona. Si no hay foto —las tazas van
   sin mockup— o el navegador no deja leerla, negro: es lo que Franklin pidió
   para su fondo beige. */
const _lumaZona = new Map();

function _lumaDeLaPrenda() {
  const img = $('#mockup');
  const z = S.zoneActive();
  if (!img || !img.naturalWidth || !z) return null;
  const clave = img.src + '|' + [z.x, z.y, z.w, z.h].join(',');
  if (_lumaZona.has(clave)) return _lumaZona.get(clave);

  let v = null;
  try {
    const cv = document.createElement('canvas');
    cv.width = img.naturalWidth; cv.height = img.naturalHeight;
    const ctx = cv.getContext('2d');
    ctx.drawImage(img, 0, 0);
    const x = Math.max(0, Math.round(z.x)), y = Math.max(0, Math.round(z.y));
    const w = Math.min(Math.round(z.w), cv.width - x);
    const h = Math.min(Math.round(z.h), cv.height - y);
    if (w > 0 && h > 0) {
      const d = ctx.getImageData(x, y, w, h).data;
      let suma = 0, n = 0;
      /* Un pixel de cada 37: de sobra para saber si es clara u oscura, y no
         cuesta nada aunque la foto sea de 1024x1024. */
      for (let i = 0; i < d.length; i += 4 * 37) {
        if (d[i + 3] < 8) continue;                    // transparente no cuenta
        suma += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
        n++;
      }
      if (n) v = suma / n;
    }
  } catch (e) {
    /* Lienzo contaminado: una foto de otro dominio servida sin CORS. No es un
       fallo, simplemente no se puede medir. */
    v = null;
  }
  /* SÓLO SE GUARDA LO QUE SE PUDO MEDIR. Si la foto todavía no ha cargado,
     `naturalWidth` es 0 y aquí no hay nada que recordar: guardar el fallo
     dejaría la prenda marcada como « no medible » para toda la sesión, y el
     panel se abre antes de que la foto llegue. */
  if (v != null) _lumaZona.set(clave, v);
  return v;
}

/* El color que se ENSEÑA como activo. No es lo mismo que `_symCouleur`: ése
   guarda lo que el cliente ELIGIÓ, y sólo debe escribirse cuando ha elegido de
   verdad. Congelarlo con el valor por defecto al abrir el panel era el fallo:
   el panel se monta con la foto a medio cargar, no se podía medir la prenda,
   salía negro y ese negro se quedaba puesto aunque la camiseta fuera negra. */
function couleurSymboleActive() {
  return _symCouleur || couleurSymboleDefaut();
}

function couleurSymboleDefaut() {
  const l = _lumaDeLaPrenda();
  return (l != null && l < 110) ? '#FFFFFF' : '#111111';
}

function construireFamilles() {
  const c = $('#sym-familles'); if (!c) return;
  c.innerHTML = '';
  const todas = ['Tout'].concat(SYMBOLES.FAMILLES);
  todas.forEach(f => {
    const b = document.createElement('button');
    b.className = 'genre' + ((f === 'Tout' ? null : f) === _symFamille ? ' genre--actif' : '');
    b.type = 'button'; b.textContent = f;
    b.onclick = () => { _symFamille = (f === 'Tout') ? null : f;
                        construireFamilles(); construireSymboles(); };
    c.appendChild(b);
  });
}

function construireSymboles() {
  const c = $('#symboles'); if (!c) return;
  c.innerHTML = '';
  SYMBOLES.LISTE
    .filter(s => !_symFamille || s.famille === _symFamille)
    .forEach(s => {
      const b = document.createElement('button');
      b.className = 'symbole'; b.type = 'button';
      b.title = s.nom; b.setAttribute('aria-label', s.nom);
      /* Tinta fija, no el color elegido: ver la nota de apercuSVG(). Una
         miniatura blanca sobre un panel blanco no es una vista previa, es un
         hueco. */
      b.innerHTML = SYMBOLES.apercuSVG(s, '#1A1A1A');
      b.onclick = () => ajouterSymbole(s.id);
      c.appendChild(b);
    });
}

function ajouterSymbole(id) {
  if (!puedePoner('forme')) { avisarNoPermitido('forme'); return; }
  const s = SYMBOLES.parId(id); if (!s) return;
  const z = S.zoneActive(); if (!z) return;
  const couleur = _symCouleur || couleurSymboleDefaut();

  /* El path esta en la caja 0..100; se escala a un tercio del lado menor de la
     zona, que es un tamano util de partida sin comerse el diseno. */
  const cote = Math.min(z.w, z.h) * 0.34;
  const e = cote / 100;
  const trait = (s.plein === false);

  const p = new fabric.Path(s.d, {
    left: z.x + z.w/2, top: z.y + z.h/2,
    originX:'center', originY:'center',
    scaleX: e, scaleY: e,
    fill: trait ? '' : couleur,
    stroke: trait ? couleur : null,
    strokeWidth: trait ? 7 : 0,
    strokeLineJoin: 'round',
    /* Sin esto el grosor del trazo se escalaria con la forma y un marco
       agrandado saldria con el borde gordisimo. */
    strokeUniform: true,
    objectCaching: false,
  });
  p.zoneId = z.id;
  p.symbole = { id: s.id, couleur, trait };
  p.clipPath = S.clipPour(z);
  canvas.add(p); canvas.setActiveObject(p);
  canvas.requestRenderAll(); S.apresChangement(); majPanneaux();
}

function colorierSymbole(couleur) {
  _symCouleur = couleur;
  const o = symboleCourant();
  const pv = $('#sym-libre-vue'); if (pv) pv.style.background = couleur;
  /* sin forma elegida esto no es un error: es elegir el color de la próxima */
  if (o) {
    if (o.symbole.trait) o.set({ stroke: couleur });
    else o.set({ fill: couleur });
    o.symbole = Object.assign({}, o.symbole, { couleur });
    canvas.requestRenderAll(); S.apresChangement();
  }
  construireSymboles();
}

function majPanneauSymboles() {
  const o = symboleCourant();
  const opt = $('#sym-options'); if (!opt) return;
  /* EL COLOR SE ELIGE ANTES, NO DESPUÉS. Franklin: « en la parte de formas,
     poner un botoncito para que vean qué color quieren elegir ». El bloque
     entero se escondía hasta tener una forma puesta, así que el color sólo
     aparecía cuando ya la habías colocado del color que fuera.
     Ahora los colores se ven siempre: sin forma elegida, deciden con qué
     color NACE la siguiente; con una forma elegida, la recolorean. */
  opt.style.display = '';
  opt.classList.toggle('inactif', !o);
  /* lo que sí depende de tener una forma elegida */
  const soloConForma = ['#sym-fond', '#sym-devant', '#sym-supprimer'];
  soloConForma.forEach(sel => { const b = $(sel); if (b) b.disabled = !o; });
  const et = opt.querySelector('.etiq');
  if (et) et.textContent = o ? 'Couleur de cette forme' : 'Couleur des formes';
  $('#sym-indice').hidden = false;
  $('#sym-indice').textContent = o
    ? 'Touchez une autre forme pour l’ajouter, ou changez sa couleur.'
    : 'Choisissez la couleur, puis touchez une forme pour l’ajouter.';
  if (o) _symCouleur = o.symbole.couleur;
  const activo = couleurSymboleActive();
  const pv = $('#sym-libre-vue'); if (pv) pv.style.background = activo;
  const cc = $('#sym-couleurs');
  if (cc) {
    cc.innerHTML = '';
    /* el negro y el blanco SIEMPRE están: son los dos que hacen falta sobre
       cualquier prenda, y puede que la ficha no los traiga */
    const base = ['#111111', '#FFFFFF'];
    const lista = base.concat(couleursDuProduit().filter(h => !base.includes(h.toUpperCase())));
    lista.forEach(hex => {
      const b = document.createElement('button');
      b.className = 'pastille' + (hex.toLowerCase() === String(activo).toLowerCase()
        ? ' pastille--actif' : '');
      b.style.background = hex; b.title = hex; b.type = 'button';
      b.onclick = () => { colorierSymbole(hex); majPanneauSymboles(); };
      cc.appendChild(b);
    });
  }
}

function brancherSymboles() {
  if (!$('#symboles')) return;
  construireFamilles(); construireSymboles();
  $('#sym-libre').oninput = () => colorierSymbole($('#sym-libre').value);
  $('#sym-supprimer').onclick = () => {
    const o = symboleCourant(); if (!o) return;
    canvas.remove(o); canvas.discardActiveObject();
    canvas.requestRenderAll(); S.apresChangement(); majPanneaux();
  };

  /* sendToBack, no sendBackwards: el color de fondo de la zona es otro objeto
     que vive en el fondo del todo (estFond). Mandar la tache « una capa mas
     atras » la dejaria a medias; se manda al fondo y se vuelve a bajar el
     fondo de color por debajo. */
  const bFond = $('#sym-fond');
  if (bFond) bFond.onclick = () => {
    const o = symboleCourant(); if (!o) return;
    canvas.sendToBack(o);
    canvas.getObjects().filter(x => x.estFond).forEach(x => canvas.sendToBack(x));
    canvas.requestRenderAll(); S.apresChangement();
  };
  const bDevant = $('#sym-devant');
  if (bDevant) bDevant.onclick = () => {
    const o = symboleCourant(); if (!o) return;
    canvas.bringToFront(o);
    canvas.requestRenderAll(); S.apresChangement();
  };
}

/* ================================ F3 · QR ================================
   El cliente pega su enlace y el QR entra como un elemento mas del diseno.

   LO CRITICO: en el JSON viaja la URL y el estilo, NO la imagen. El archivo de
   impresion REGENERA el codigo a la resolucion final. Un QR estirado desde una
   vista previa sale con los modulos borrosos y deja de leerse — o se lee mal,
   que es peor porque nadie lo nota hasta que el producto esta impreso.
   ======================================================================== */
let _qrLogo = null;

const qrAutorise = () => {
  const p = etat.produit && etat.produit.perso;
  if (!p) return false;
  /* El producto manda; si no dice nada, el defecto global. La medaille lo
     apaga: 2,8 cm no dan para un QR legible. */
  if (p.qrClientAutorise != null) return !!p.qrClientAutorise;
  return !!(S.defauts().qrClientAutorise);
};

const qrCourant = () => canvas.getObjects().find(o => o.qr && o === canvas.getActiveObject())
                     || canvas.getObjects().find(o => o.qr);

function majOngletQR() {
  const on = qrAutorise();
  $('#onglet-qr').hidden = !on;
  if (!on && !$('#panneau-qr').hidden) fermerPanneaux();
  construireCouleursQR();
  majPanneauQR();
}

function construireCouleursQR() {
  const c = $('#qr-couleurs'); if (!c) return;
  c.innerHTML = '';
  /* Un QR necesita CONTRASTE. Se ofrecen solo tonos oscuros: un QR amarillo
     sobre blanco no lo lee ningun telefono. */
  ['#111111', '#222D52', '#3B2A1A', '#1F4033', '#4A1220'].forEach(hex => {
    const b = document.createElement('button');
    b.className = 'pastille'; b.style.background = hex; b.title = hex;
    b.onclick = () => { _qrStyle.couleur = hex; regenererQR(); };
    c.appendChild(b);
  });
}

let _qrStyle = { couleur:'#111111', fond:'#FFFFFF', coinsArrondis:true, logo:null };

function majPanneauQR() {
  const o = qrCourant();
  $('#qr-supprimer').hidden = !o;
  $('#qr-ajouter').textContent = o ? 'Remplacer le code QR' : '+ Ajouter le code QR';
  $('#qr-logo-retirer').hidden = !_qrStyle.logo;
  if (o && o.qr) {
    $('#qr-url').value = o.qr.url || '';
    $('#qr-arrondi').checked = o.qr.coinsArrondis !== false;
    $('#qr-fond').checked = !!o.qr.fond;
  }
  majEtatQR(o);
}

/* El aviso de tamano se calcula sobre los CM REALES, no sobre pixeles: es lo
   unico que predice si el movil del cliente final lo va a leer. */
function majEtatQR(o) {
  const el = $('#qr-etat'); if (!el) return;
  if (!o || !o.qr) { el.textContent = ''; return; }
  const z = S.zonePar(etat.vue, o.zoneId) || S.zoneActive();
  const cm = o.getScaledWidth() * (z.cmW / z.w);
  const v = QR.verifierTaille(cm);
  el.innerHTML = v.ok
    ? `✓ Imprimé à ${v.cm} cm — lisible par un téléphone.`
    : `⚠ Imprimé à ${v.cm} cm : trop petit pour être scanné. `
      + `Agrandissez-le à ${v.cmMin} cm au minimum.`;
  el.style.color = v.ok ? '' : 'var(--rouge)';
}

async function ajouterOuRemplacerQR() {
  if (!puedePoner('qr')) { avisarNoPermitido('qr'); return; }
  const v = QR.normaliserUrl($('#qr-url').value);
  const err = $('#qr-erreur');
  if (!v.ok) { err.textContent = v.motif; err.hidden = false; return; }
  err.hidden = true;

  _qrStyle.coinsArrondis = $('#qr-arrondi').checked;
  _qrStyle.fond = $('#qr-fond').checked ? '#FFFFFF' : 'transparent';

  montrerTravail('Création du code QR…', '');
  try {
    const z = S.zoneActive();
    const dataUrl = await QR.generer(v.url, _qrStyle, 900);
    const ancien = qrCourant();
    await new Promise(res => {
      fabric.Image.fromURL(dataUrl, img => {
        /* Nace a 4 cm reales: por encima del minimo de 1,5 y sin comerse el
           diseno. */
        const cote = Math.min(z.w, z.h) * 0.45;
        const cible = ancien
          ? { left: ancien.left, top: ancien.top,
              e: ancien.getScaledWidth() / img.width }
          : { left: z.x + z.w/2, top: z.y + z.h*0.7, e: cote / img.width };
        img.set({ left: cible.left, top: cible.top,
                  originX:'center', originY:'center',
                  scaleX: cible.e, scaleY: cible.e,
                  /* Un QR girado se lee peor y no aporta nada: sin rotacion. */
                  lockRotation: true });
        img.setControlVisible('mtr', false);
        img.zoneId = z.id;
        img.qr = { url: v.url, couleur:_qrStyle.couleur, fond:_qrStyle.fond,
                   coinsArrondis:_qrStyle.coinsArrondis, logo:_qrStyle.logo || null };
        img.source = { px:{ w:img.width, h:img.height },
                       natif:{ w:img.width, h:img.height } };
        img.clipPath = S.clipPour(z);
        if (ancien) canvas.remove(ancien);
        canvas.add(img); canvas.setActiveObject(img);
        res();
      }, { crossOrigin:'anonymous' });
    });
    canvas.requestRenderAll(); S.apresChangement(); majPanneauQR(); majPanneaux();
  } catch (e) {
    console.error('[EDISAMP] QR:', e);
    err.textContent = e.message || 'Impossible de créer le code QR.';
    err.hidden = false;
  } finally { cacherTravail(); }
}

/* Cambiar color o esquinas rehace el codigo en el mismo sitio y al mismo
   tamano: el cliente no deberia perder su encuadre por cambiar un tono. */
async function regenererQR() {
  const o = qrCourant();
  if (!o) return;
  $('#qr-url').value = o.qr.url;
  await ajouterOuRemplacerQR();
}

function brancherQR() {
  if (!$('#qr-ajouter')) return;
  $('#qr-ajouter').onclick = ajouterOuRemplacerQR;
  $('#qr-supprimer').onclick = () => {
    const o = qrCourant(); if (!o) return;
    canvas.remove(o); canvas.discardActiveObject();
    canvas.requestRenderAll(); S.apresChangement(); majPanneauQR(); majPanneaux();
  };
  ['#qr-arrondi', '#qr-fond'].forEach(sel => {
    $(sel).onchange = () => { if (qrCourant()) regenererQR(); };
  });
  $('#qr-logo').onchange = e => {
    const f = e.target.files && e.target.files[0];
    e.target.value = '';
    if (!f) return;
    const l = new FileReader();
    l.onload = () => {
      _qrStyle.logo = l.result;
      $('#qr-logo-retirer').hidden = false;
      if (qrCourant()) regenererQR();
    };
    l.readAsDataURL(f);
  };
  $('#qr-logo-retirer').onclick = () => {
    _qrStyle.logo = null; $('#qr-logo-retirer').hidden = true;
    if (qrCourant()) regenererQR();
  };
  /* Al mover o escalar el QR, el aviso de tamano tiene que seguirlo. */
  canvas.on('object:modified', e => { if (e.target && e.target.qr) majEtatQR(e.target); });
}

/* ======================= F4 · MEJORAR LA CALIDAD =========================
   Ver `ameliorer.js` para el porque de no usar un modelo generativo. Aqui
   solo esta el enganche con el Studio.

   Se trabaja sobre el ORIGINAL de alta resolucion cuando existe, no sobre la
   miniatura del canvas: ampliar una miniatura de 1600 px seria ampliar una
   reduccion, o sea perder dos veces. */
function majEtatAmeliorer(o) {
  const el = $('#ameliorer-etat'); if (!el || !o) return;
  const z = S.zonePar(etat.vue, o.zoneId) || S.zoneActive();
  const cm = o.getScaledWidth() * (z.cmW / z.w);
  const nat = (o.source && o.source.natif) || { w:o.width, h:o.height };
  const a = AMELIORER.analyser(nat.w, nat.h, cm);
  $('#btn-ameliorer').disabled = !!a.dejaBon;
  /* LA MISMA VARA QUE EL AVISO DE ARRIBA. Aquí se decía « Qualité suffisante »
     cuando la foto ya no se podía agrandar más —su lado ya llegaba al
     máximo—, aunque tuviera 117 DPI; y arriba, con el umbral de 150, el mismo
     cojín decía « Qualité d'impression faible (≈ 117 DPI) ». Franklin lo vio
     en su iPhone, las dos frases a la vez. « No se puede agrandar más » y
     « es suficiente » son cosas distintas, y se dicen distinto. */
  const umbral = S.defauts().dpiAvertissement || 150;
  const baja = a.dpi !== null && a.dpi < umbral;
  el.textContent = !baja && a.dejaBon
    ? `✓ Qualité suffisante (≈ ${a.dpi} DPI à cette taille).`
    : baja && a.dejaBon
      ? `≈ ${a.dpi} DPI à cette taille : la photo est déjà à sa taille maximale. `
        + `Pour une impression plus nette, réduisez-la sur le produit.`
      : `≈ ${a.dpi} DPI à cette taille. L’amélioration agrandit la photo sans `
        + `inventer de détail, pour une impression plus nette.`;
}

async function ameliorerPhoto() {
  const o = imageCourante(); if (!o) return;
  const idOrig = o.source && o.source.idOriginal;

  /* LA ENTRADA ES EL ARTWORK TAL COMO ESTA AHORA, no la foto original.
     Aqui estaba el segundo fallo, y hacia algo que parecia magia negra: el
     cliente quitaba el fondo, pulsaba « Ameliorer la qualite », y el fondo
     VOLVIA. La razon era prosaica — se leia `ORIGINALES`, que seguia
     guardando la foto de antes del detourage, se mejoraba ESA y se ponia en
     su sitio. La mejora deshacia el detourage sin querer.

     Ahora `ORIGINALES` guarda el artwork preparado (con su mascara ya
     aplicada), asi que mejorar parte de lo que el cliente ve. El original de
     verdad sigue guardado aparte, en `o.sourceOriginale`, para poder volver. */
  const source = (idOrig && S.ORIGINALES.get(idOrig)) || sourcePleineResolution(o);
  const z = S.zonePar(etat.vue, o.zoneId) || S.zoneActive();
  const cm = o.getScaledWidth() * (z.cmW / z.w);
  const nat = (o.source && o.source.natif) || { w:o.width, h:o.height };
  const a = AMELIORER.analyser(nat.w, nat.h, cm);

  montrerTravail('Amélioration de la photo…', '');
  try {
    const mieux = await AMELIORER.ameliorer(source, a.facteurUtile,
      (pc, etape) => progresTravail('Amélioration de la photo…',
        typeof pc === 'number' ? pc : null, etape));
    /* El resultado sustituye tanto la vista del canvas como el ORIGINAL que
       usa el archivo de impresion: si solo se cambiara la vista, el PNG a 300
       DPI seguiria saliendo de la foto vieja y la mejora seria mentira. */
    const ok = await remplacerImage(o, mieux);
    if (!ok) throw new Error('image illisible');
    /* `fondSupprime` NO se toca: la mejora no deshace el detourage, y el
       interfaz debe seguir diciendo la verdad sobre lo que se ha hecho. */
    majOriginalPrepare(o, mieux);
    o.source = Object.assign({}, o.source, {
      natif: { w:o.width, h:o.height },
      px: { w:o.width, h:o.height },
    });
    majPanneaux(); S.apresChangement();
  } catch (e) {
    console.error('[EDISAMP] améliorer:', e);
    alert('Impossible d’améliorer cette photo. Réessayez avec une autre.');
  } finally { cacherTravail(); }
}

/* ========================= 9 · AJOUTER AU PANIER =========================
   El ultimo tramo. Ver `panier.js` para el porque de Cloudinary y del limite
   de tamano; aqui esta la orquestacion.

   Orden y por que: primero se suben las fotos ORIGINALES (son lo que produce
   el archivo de impresion), despues el apercu, despues se aligera el JSON
   sustituyendo los dataUrl por esas URL, y solo al final se manda al carrito.
   Si algo falla, falla ANTES de tocar el carrito: no se quiere un articulo en
   el carrito con la mitad de sus datos. */
/* El vuelo en curso y cuántas piezas van. El contador es LOCAL a esta sesión
   de editor: la autoridad del carrito es Shopify, y esto sólo dice cuántas ha
   metido el cliente desde aquí. */
let _vuelo = null;
let _enPanier = 0;

/* CUANTAS PIEZAS LLEVA, Y QUE HACE « CONTINUER ». Con la cesta vacia
   continuar es « ensename lo que he hecho »; con cuatro llaveros dentro es
   « llevame a pagar ». Un mismo boton que no dice cual de las dos cosas hace
   es el que deja al cliente dando vueltas. */
function majBoutonsPanier() {
  const c = $('#btn-continuer');
  if (c) c.textContent = _enPanier > 0 ? `Voir le panier (${_enPanier})` : 'Continuer';

  /* EL PRECIO TIENE QUE SUBIR. Franklin: « ya puse los 3 llaveros, el precio
     no suma ni sube ». El indicador enseñaba el precio UNITARIO del producto
     y no se movia nunca, asi que con tres piezas dentro seguia poniendo 4.90
     — y desde fuera eso se lee como « no se ha añadido nada ».
     La autoridad del importe sigue siendo Shopify; esto es la cuenta de lo
     que se ha metido desde ESTE editor, y se dice que es un subtotal. */
  const pz = $('#prix');
  if (pz && etat.produit && etat.produit.prix != null
      && typeof etat.produit.prix === 'number') {
    const u = etat.produit.prix, d = etat.produit.devise || 'CHF';
    pz.textContent = _enPanier > 0
      ? `${(u * _enPanier).toFixed(2)} ${d}`
      : `${u.toFixed(2)} ${d}`;
    pz.title = _enPanier > 0
      ? `${_enPanier} × ${u.toFixed(2)} ${d} — sous-total du panier`
      : '';
  }
}

/* Vaciar la zona activa para la pieza siguiente. Se ofrece, nunca se hace
   solo: ver la nota en ajouterAuPanier(). */
/* Deja la escena lista para la pieza siguiente. Se quita SOLO lo que puso el
   cliente: el color de fondo, los huecos de la plantilla y el diseno que ya
   viene impreso en el producto se quedan donde estan.
   Nunca se llama solo: lo dispara « Personnaliser le suivant » de la
   superficie del carrito. Vaciarle el lienzo sin pedirselo le tiraria el
   trabajo justo cuando lo que queria eran DOS piezas iguales. */
function viderPourSuivant() {
  canvas.getObjects()
    .filter(o => !o.estFond && !o.estModele)
    .forEach(o => canvas.remove(o));
  canvas.discardActiveObject();
  canvas.renderAll();
  etat.jsonCompleto = null;
  const t = $('#toast-panier'); if (t) t.hidden = true;
  S.apresChangement(); majPanneaux();
}

/* Los dos botones que pueden anadir —el de la barra y el de la ventana—
   comparten TODO menos donde escriben. Se pasan por parametro en vez de
   duplicar cuatrocientas lineas. */
async function ajouterAuPanier(btnEl, etatEl) {
  const el = etatEl || $('#panier-etat');
  const btn = btnEl || $('#btn-panier');
  /* Desde la barra no se ha pasado por « Continuer », asi que el JSON no
     existe todavia: se construye aqui. Era lo unico que ataba este boton a
     tener que abrir la ventana antes. */
  const json = etat.jsonCompleto || (etat.jsonCompleto = construireJSON());
  if (!json) { el.textContent = 'Aucun design à ajouter.'; return; }

  /* Solo se PARA en la tienda: fuera, televerser() simula y el recorrido se
     puede probar entero en local. Ver la nota en panier.js. */
  if (!PANIER.configure() && PANIER.dansLaBoutique()) {
    el.innerHTML = '\u26A0 Cloudinary n\u2019est pas configuré. '
      + 'Renseignez-le dans l\u2019admin (Connexion Shopify).';
    return;
  }

  btn.disabled = true;
  /* EL AVISO, DONDE SE ESTÁ MIRANDO. En un teléfono el texto de estado queda
     fuera de la pantalla la mitad de las veces; lo que el cliente mira es el
     botón que acaba de pulsar. Así que el botón también lo cuenta, y vuelve a
     su texto pase lo que pase (`finally`, más abajo). */
  const textoBoton = btn.textContent;
  const dire = t => {
    el.textContent = t;
    if (t && !/^\u2713/.test(t)) btn.textContent = t.replace(/…$/, '…');
  };
  try {
    /* 1. Las fotos originales, en resolucion completa: son lo que se imprime.
          Se suben una a una para poder decir por cual va. */
    /* DE UNA EN UNA ERA DE UNA EN UNA. Con tres fotos, tres subidas en fila:
       el cliente esperaba la suma de las tres. Van de tres en tres —un móvil
       con cuatro subidas a la vez se queda sin ancho de banda para nada más—
       y el aviso dice cuántas quedan, que es lo que el cliente necesita
       saber. El orden del resultado se conserva por índice. */
    const conImagen = PANIER.elementsAvecImage(json);
    const urls = new Array(conImagen.length).fill(null).map(() => ({}));
    if (conImagen.length) {
      let hechas = 0;
      const total = conImagen.length;
      dire(total === 1 ? 'Envoi de votre photo…' : `Envoi de vos photos… 0/${total}`);
      const cola = conImagen.map((e, i) => ({ e, i }));
      const obrero = async () => {
        for (;;) {
          const tarea = cola.shift();
          if (!tarea) return;
          const src = (tarea.e.source
            && (tarea.e.source.dataUrlOriginale || tarea.e.source.dataUrl));
          if (src) {
            urls[tarea.i] = { original: await PANIER.televerser(src, json.produit.handle) };
          }
          hechas += 1;
          if (total > 1) dire(`Envoi de vos photos… ${hechas}/${total}`);
        }
      };
      const obreros = [];
      for (let n = 0; n < Math.min(3, total); n++) obreros.push(obrero());
      await Promise.all(obreros);
    }

    /* 2. El apercu: es la miniatura que Franklin y el cliente veran en el
          carrito y en el pedido. Para la taza es el render 3D.

          Y es ademas lo que VUELA. Existe en local antes de subir nada, asi
          que MADE → BAG empieza en cuanto se pulsa en vez de esperar a la
          red. La subida sigue por detras; la animacion no la espera. */
    dire('Préparation de l’aperçu…');
    const vue0 = (etat.produit.perso.vues || [])[0];
    const apercu = vue0 ? await genererApercu(vue0) : null;

    if (typeof VOL_PANIER !== 'undefined' && typeof COQUILLE !== 'undefined') {
      const destino = COQUILLE.rectSac();
      const escena = document.querySelector('.plateau');
      /* Sin destino visible no se lanza nada hacia una coordenada inventada:
         se resuelve el rect REAL o no hay vuelo. */
      if (destino && escena) _vuelo = VOL_PANIER.volar({
        origen: escena, imagen: apercu, destino,
      });
    }

    const apercuUrl = apercu
      ? await PANIER.televerser(await alegerApercu(apercu), json.produit.handle + '-apercu')
      : '';

    /* 3. El JSON, ya sin base64. */
    dire('Finalisation…');
    const { json: leger, originales } = PANIER.alegerJSON(json, urls);
    /* « MODIFIER » DESDE EL CARRITO. Se guarda la creación TAL COMO SE COMPRA
       y la línea del carrito lleva cómo volver a ella (`?reprendre=`, que el
       Studio ya sabía abrir). Guardarla aquí y no fiarse del autoguardado:
       después de añadir se vacía el lienzo para la pieza siguiente, y el
       autoguardado escribiría ese lienzo vacío encima. */
    let modifier = null;
    try {
      if (typeof CREATION !== 'undefined' && CREATION.disponible()) {
        const idPieza = CREATION.idActual() || CREATION.comenzar();
        await CREATION.guardarAhora({ ...S.instantanea(), preview: S.miniatura() });
        modifier = location.pathname + '?produit=' + encodeURIComponent(etat.produit.handle)
                 + '&reprendre=' + encodeURIComponent(idPieza);
      }
    } catch (e) { console.warn('[EDISAMP] creación no guardada para « Modifier »', e); }
    const tl = S.tailles();
    let props = PANIER.construireProprietes(leger, apercuUrl, originales, {
      qualiteAcceptee: !!etat.qualiteAcceptee,
      /* Talla y acabado se enseñan en el carrito sólo si había donde elegir. */
      tallaElegible: !!(tl && Object.keys(tl).length >= 2),
      finitionElegible: !!S.finitions(),
      modifier,
    });
    const t = await PANIER.garantirTaille(props);
    props = t.props;

    /* 4. La variante: talla y acabado tienen que casar con la de Shopify. */
    /* SI EL CLIENTE ELIGIÓ UN MODELO, ES ÉSE. `choisirVariante` casa talla y
       acabado, que aquí no aplican: con « Modele 1-4 » devolvía siempre la
       primera y el cliente recibía el cojín equivocado. */
    const v = etat.variante
      ? { id: etat.variante, exacte: true }
      : PANIER.choisirVariante(etat.produit, json.produit.taille,
                               json.produit.finition);
    if (!v.exacte && v.motif) console.warn('[EDISAMP] variante:', v.motif);

    /* El último tramo tiene nombre propio: es el que el cliente está
       esperando de verdad, y decirlo evita el segundo de silencio entre
       « Finalisation » y la bolsa llenándose. */
    dire('Ajout de votre personnalisation…');

    /* Y LA IDENTIDAD DE LA LÍNEA, con la variante ya resuelta: qué producto,
       qué variante, qué proyecto y qué personalización. Se añade DESPUÉS de
       `garantirTaille` a propósito: son cinco cadenas cortas y no pueden
       empujar al JSON del diseño por encima del límite de Shopify. */
    Object.assign(props, PANIER.identite({
      produitId: etat.produit.id,
      handle: etat.produit.handle,
      varianteId: v.id,
      projetId: (typeof CREATION !== 'undefined' && CREATION.disponible())
        ? CREATION.idActual() : null,
    }));

    const r = await PANIER.ajouter(v.id, props, 1);

    /* La ANIMACION no confirma nada: solo /cart/add.js confirma. El icono
       reacciona y el contador cambia AQUI, cuando la tienda ha dicho que si.
       Se espera al aterrizaje para que el acuse caiga sobre la pieza y no
       antes de que llegue. */
    if (_vuelo) { try { await _vuelo; } catch (e) {} _vuelo = null; }

    /* EL CONTADOR SUBE SIEMPRE, HAYA CONCHA O NO. Vivía dentro del `if` de
       COQUILLE, que es quien pinta la bolsa — si esa pieza no estaba montada,
       `_enPanier` se quedaba en cero para siempre y « Continuer » volvía a
       abrir la ventana de vista previa en vez de llevar al carrito. Lo que
       cuenta es que la tienda haya dicho que sí, no que haya un icono. */
    _enPanier += 1;
    /* Lo que se haga a partir de ahora es OTRA pieza: creación nueva, para que
       la que está en el carrito se quede como se compró. */
    try { if (typeof CREATION !== 'undefined' && CREATION.disponible()) CREATION.comenzar(); } catch (e) {}
    if (typeof COQUILLE !== 'undefined') {
      COQUILLE.mostrarSac(_enPanier);
      COQUILLE.acuserSac();
    }
    /* AQUI, donde el contador cambia — no en el handler de un boton concreto.
       Estaba solo tras pulsar el de la barra, asi que anadiendo desde la
       ventana de « Continuer » el precio no se movia. Franklin: « ajoute y no
       se suma, sigue sin sumarse ». */
    majBoutonsPanier();

    if (typeof EVENEMENTS !== 'undefined') {
      EVENEMENTS.emitir(EVENEMENTS.TIPOS.DESIGN_ADDED_TO_CART, {
        designId: (typeof CREATION !== 'undefined') ? CREATION.idActual() : null,
        productHandle: etat.produit.handle,
      });
    }

    if (typeof VOL_PANIER !== 'undefined') {
      VOL_PANIER.surface({
        imagen: apercu,
        nom: etat.produit.titre || etat.produit.handle,
        variante: json.produit.taille || '',
        resume: (r && r.simule) ? 'Simulation — hors boutique' : '',
        // El precio lo manda Shopify. Si no ha llegado, no se enseña ninguno.
        prix: (etat.produit.prix != null)
          ? `CHF ${etat.produit.prix}` : '',
        /* Fuera de la tienda no hay /cart: el enlace se quita, no se deja
           apuntando a un 404. */
        urlPanier: (PANIER.dansLaBoutique && PANIER.dansLaBoutique()) ? '/cart' : null,
        surSuivant: viderPourSuivant,
      });
    }

    if (r && r.simule) {
      el.innerHTML = `\u2713 Simulation réussie — hors boutique, rien n\u2019a été `
        + `ajouté.<br>JSON : ${t.taille} caractères${t.parUrl ? ' (envoyé par URL)' : ''} · `
        + `${originales.length} photo(s) · variante ${v.id}`;
    } else {
      /* Ya NO se redirige sola. El cliente acaba de ver su creación entrar en
         la bolsa; mandarlo al carrito de golpe se lleva por delante el
         momento y le quita la opción de seguir creando. La superficie tiene
         « Voir le panier ». */
      /* AÑADIR VARIOS. Franklin: « si quiere otro más, simplemente va a
         agregar al carrito y lo va a volver a personalizar… el precio va
         subiendo ». Eso ya funciona —no se redirige al carrito y el contador
         sube—, pero nadie lo sabía: ahora se dice, y con el modelo delante. */
      const hayModelos = ((etat.produit.variantes || [])
        .filter(x => x.disponible !== false).length) > 1;
      dire(hayModelos
        ? '\u2713 Añadido a la cesta. Elige otro modelo arriba y personalízalo '
          + 'también: se suman en la cesta.'
        : '\u2713 Añadido a la cesta.');
      /* Y EL BOTÓN DEJA DE AÑADIR: AHORA LLEVA AL CARRITO.
         Franklin: « pongo Ajouter au panier pero simplemente no me devuelve a
         mi sitio web, para seguir viendo o para comprar ». El mensaje decía
         que ya estaba añadido y debajo seguía el mismo botón dorado ofreciendo
         añadirlo otra vez: la única salida era cerrar la ventana y buscar el
         icono de la bolsa. Aquí termina el recorrido, así que aquí está la
         puerta. Fuera de la tienda no hay /cart, y entonces no se promete. */
      /* Sólo el de la ventana: el de la barra sigue siendo « añadir », que es
         desde donde se encadena un segundo llavero sin abrir nada. */
      if (btn && btn.id === 'btn-panier'
          && PANIER.dansLaBoutique && PANIER.dansLaBoutique()) {
        btn.textContent = 'Voir le panier \u2192';
        /* `replace` y no `href`: Franklin, en el carrito, dio « atrás » y volvió
           al Studio. Lo que compró ya está en el carrito, con su « Modifier »;
           « atrás » desde el carrito lleva a la tienda. */
        btn.onclick = () => { location.replace('/cart'); };
        /* DESDE LA VENTANA, DE VUELTA A LA TIENDA. Franklin: « cuando aplasto
           Ajouter au panier después de Continuer, tendría que devolverme a mi
           shop ». « Continuer » es terminar: quien ha llegado hasta aquí ya
           no está creando, está comprando. El botón de la barra sigue sin
           salir de la página, que es desde donde se encadenan varias piezas.
           Un instante para que vea el « añadido » antes de irse. */
        setTimeout(() => { location.replace('/cart'); }, 900);
      }
    }

    /* Y el acuse flotante se retira: la superficie del carrito ya dice lo
       mismo, con la miniatura y el precio. Dos ventanas repitiendo « anadido »
       es peor que una. El toast se queda solo para el progreso —« Envoi de vos
       photos 2/3 »— y para los fallos. */
    const tp = $('#toast-panier'); if (tp) tp.hidden = true;
  } catch (e) {
    console.error('[EDISAMP] panier:', e);
    /* Falla: la pieza se disuelve donde está y el escenario vuelve entero.
       Perder de vista el diseño justo cuando algo ha fallado es la peor
       lectura posible. El DesignSession no se toca. */
    if (typeof VOL_PANIER !== 'undefined') {
      VOL_PANIER.deshacer();
      VOL_PANIER.echec(e.message || '');
    }
    _vuelo = null;
    el.textContent = 'Échec : ' + (e.message || 'impossible d’ajouter au panier.');
  } finally {
    btn.disabled = false;
    /* Y el botón recupera su nombre — salvo si el propio recorrido se lo ha
       cambiado por « Voir le panier », que es el final bueno. Se reconoce por
       los puntos suspensivos: todos los avisos de progreso acaban en « … ». */
    if (btn && /…$/.test(btn.textContent || '')) btn.textContent = textoBoton;
  }
}

/* ------------------------- interaccion con emplacements ------------------ */
/* Tocar un hueco vacio abre la subida ligada a ESE hueco. Arrastrar una foto
   ya colocada la encuadra DENTRO del marco en vez de mover el marco: el marco
   es de la plantilla, el encuadre es del cliente. */
canvas.on('mouse:down', opt => {
  const o = opt.target;
  if (o && o.emplacement && !o.emplacementRempli) {
    /* Un hueco de texto no abre la subida de fotos: crea su texto en el sitio. */
    if (o.emplacement.media === 'texte') { remplirEmplacementTexte(o); return; }
    etat.emplacementPendiente = o;
    majConseilPhoto();
    $('#modale-depot').hidden = false;
    return;
  }
  if (o && o.emplacementRempli && opt.pointer) {
    _panEmp = { o, x:opt.pointer.x, y:opt.pointer.y,
                dx:(o.cadrage||{}).dx || 0, dy:(o.cadrage||{}).dy || 0 };
  }
});

let _panEmp = null;

canvas.on('mouse:move', opt => {
  if (!_panEmp || !opt.pointer) return;
  const { o } = _panEmp;
  const m = o.emplacement;
  const nat = (o.source && o.source.natif) || { w:o.width, h:o.height };
  const f = MODELES.encadrer(m, nat.w, nat.h, o.cadrage);
  /* dx/dy son fracciones del sobrante: asi el encuadre no depende de la
     resolucion y vale igual en pantalla que a 300 DPI. */
  const ndx = f.sobraX > 0 ? _panEmp.dx - (opt.pointer.x - _panEmp.x) / f.sobraX : 0;
  const ndy = f.sobraY > 0 ? _panEmp.dy - (opt.pointer.y - _panEmp.y) / f.sobraY : 0;
  o.cadrage = Object.assign({}, o.cadrage, {
    dx: MODELES.clamp(ndx, -1, 1), dy: MODELES.clamp(ndy, -1, 1) });
  const g = MODELES.encadrer(m, nat.w, nat.h, o.cadrage);
  o.set({ left:g.cx, top:g.cy });
  canvas.requestRenderAll();
});

canvas.on('mouse:up', () => {
  if (_panEmp) { _panEmp = null; S.apresChangement(); }
});

/* Zoom del cliente dentro del hueco, sin tocar el marco. */
function zoomEmplacement(o, factor) {
  if (!o || !o.emplacementRempli) return;
  const nat = (o.source && o.source.natif) || { w:o.width, h:o.height };
  const z = MODELES.clamp(((o.cadrage||{}).zoom || 1) * factor, 1, 4);
  o.cadrage = Object.assign({}, o.cadrage, { zoom:z });
  const f = MODELES.encadrer(o.emplacement, nat.w, nat.h, o.cadrage);
  o.set({ left:f.cx, top:f.cy, scaleX:f.escala, scaleY:f.escala });
  canvas.requestRenderAll(); S.apresChangement();
}
S.zoomEmplacement = zoomEmplacement;

/* Los botones de unidad. Van en el segundo bloque, asi que todo lo del primero
   lleva `S.` delante — la trampa de los dos IIFE que ya ha costado cuatro
   sesiones (ver CLAUDE.md). */
document.querySelectorAll('#unites .unite').forEach(b => {
  if (b.dataset.unite === S.unite()) b.classList.add('unite--on');
  else b.classList.remove('unite--on');
  b.onclick = () => {
    S.setUnite(b.dataset.unite);
    document.querySelectorAll('#unites .unite').forEach(x =>
      x.classList.toggle('unite--on', x === b));
    S.construireVues();
    S.dessinerGuides();
  };
});

/* VENTANA DE PRUEBAS, SÓLO EN LOCAL. En la tienda no existe: sin esto no hay
   forma de comprobar desde fuera qué le pasa a un objeto del lienzo, y las
   pruebas se vuelven adivinanza. El if mira el dominio, no una bandera que
   alguien pueda encender sin querer. */
if (/^(localhost|127\.0\.0\.1|\[::1\])$/.test(location.hostname)
    || /\.local$/.test(location.hostname)) {
  window.__EDISAMP_QA = { canvas, S, etat };
}

})();
